import { trpcSlice as api } from "./src/trpcSlice";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ping: build.query<PingApiResponse, PingApiArg>({
      query: () => ({ url: `/trpcping` }),
    }),
    putProjectsAutodeskConnect: build.mutation<PutProjectsAutodeskConnectApiResponse, PutProjectsAutodeskConnectApiArg>(
      {
        query: (queryArg) => ({ url: `/projects/autodesk/connect`, method: "PUT", body: queryArg.body }),
      },
    ),
    deleteProjectsAutodeskConnection: build.mutation<
      DeleteProjectsAutodeskConnectionApiResponse,
      DeleteProjectsAutodeskConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/autodesk/connection`,
        method: "DELETE",
        params: {
          projectId: queryArg.projectId,
        },
      }),
    }),
    getProjectsAutodeskConnection: build.query<
      GetProjectsAutodeskConnectionApiResponse,
      GetProjectsAutodeskConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/autodesk/connection`,
        params: {
          projectId: queryArg.projectId,
        },
      }),
    }),
    getProjectsAutodeskAvailableProjects: build.query<
      GetProjectsAutodeskAvailableProjectsApiResponse,
      GetProjectsAutodeskAvailableProjectsApiArg
    >({
      query: () => ({ url: `/projects/autodesk/available-projects` }),
    }),
    postProjectsAutodeskLoginStart: build.mutation<
      PostProjectsAutodeskLoginStartApiResponse,
      PostProjectsAutodeskLoginStartApiArg
    >({
      query: (queryArg) => ({ url: `/projects/autodesk/login-start`, method: "POST", body: queryArg.body }),
    }),
    postProjectsAutodeskVerifyServiceAccountAccess: build.mutation<
      PostProjectsAutodeskVerifyServiceAccountAccessApiResponse,
      PostProjectsAutodeskVerifyServiceAccountAccessApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/autodesk/verify-service-account-access`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectMembers: build.query<GetProjectMembersApiResponse, GetProjectMembersApiArg>({
      query: (queryArg) => ({
        url: `/project/members`,
        params: {
          projectId: queryArg.projectId,
        },
      }),
    }),
    putProjectMember: build.mutation<PutProjectMemberApiResponse, PutProjectMemberApiArg>({
      query: (queryArg) => ({ url: `/project/member`, method: "PUT", body: queryArg.body }),
    }),
    getProjectMember: build.query<GetProjectMemberApiResponse, GetProjectMemberApiArg>({
      query: (queryArg) => ({
        url: `/project/member`,
        params: {
          projectId: queryArg.projectId,
          memberId: queryArg.memberId,
        },
      }),
    }),
    putProjectMemberOtherAttributes: build.mutation<
      PutProjectMemberOtherAttributesApiResponse,
      PutProjectMemberOtherAttributesApiArg
    >({
      query: (queryArg) => ({ url: `/project/member/other-attributes`, method: "PUT", body: queryArg.body }),
    }),
    getProjectIssueboards: build.query<GetProjectIssueboardsApiResponse, GetProjectIssueboardsApiArg>({
      query: (queryArg) => ({
        url: `/project/issueboards`,
        params: {
          projectId: queryArg.projectId,
        },
      }),
    }),
    getProjectPns: build.query<GetProjectPnsApiResponse, GetProjectPnsApiArg>({
      query: (queryArg) => ({
        url: `/project/pns`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getProjectProjectId: build.query<GetProjectProjectIdApiResponse, GetProjectProjectIdApiArg>({
      query: (queryArg) => ({
        url: `/project/project-id`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getProjectsMcapps: build.query<GetProjectsMcappsApiResponse, GetProjectsMcappsApiArg>({
      query: () => ({ url: `/projects/mcapps` }),
    }),
    getProjectsMaconomy: build.query<GetProjectsMaconomyApiResponse, GetProjectsMaconomyApiArg>({
      query: () => ({ url: `/projects/maconomy` }),
    }),
    postProjectMaconomyMembersSync: build.mutation<
      PostProjectMaconomyMembersSyncApiResponse,
      PostProjectMaconomyMembersSyncApiArg
    >({
      query: (queryArg) => ({ url: `/project/maconomy-members/sync`, method: "POST", body: queryArg.body }),
    }),
    postProjectByProjectIdReportboards: build.mutation<
      PostProjectByProjectIdReportboardsApiResponse,
      PostProjectByProjectIdReportboardsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/reportboards`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putUserProfile: build.mutation<PutUserProfileApiResponse, PutUserProfileApiArg>({
      query: (queryArg) => ({ url: `/user/profile`, method: "PUT", body: queryArg.body }),
    }),
    getWhoami: build.query<GetWhoamiApiResponse, GetWhoamiApiArg>({
      query: () => ({ url: `/whoami` }),
    }),
    postUsersProfilePictureSas: build.mutation<PostUsersProfilePictureSasApiResponse, PostUsersProfilePictureSasApiArg>(
      {
        query: (queryArg) => ({ url: `/users/profile-picture-sas`, method: "POST", body: queryArg.body }),
      },
    ),
    postUserApikey: build.mutation<PostUserApikeyApiResponse, PostUserApikeyApiArg>({
      query: (queryArg) => ({ url: `/user/apikey`, method: "POST", body: queryArg.body }),
    }),
    getUserApikey: build.query<GetUserApikeyApiResponse, GetUserApikeyApiArg>({
      query: () => ({ url: `/user/apikey` }),
    }),
    deleteUserApikey: build.mutation<DeleteUserApikeyApiResponse, DeleteUserApikeyApiArg>({
      query: () => ({ url: `/user/apikey`, method: "DELETE" }),
    }),
    getProjectByProjectIdChecklistTemplates: build.query<
      GetProjectByProjectIdChecklistTemplatesApiResponse,
      GetProjectByProjectIdChecklistTemplatesApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/checklist/templates` }),
    }),
    postProjectByProjectIdChecklistAll: build.mutation<
      PostProjectByProjectIdChecklistAllApiResponse,
      PostProjectByProjectIdChecklistAllApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/all`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdChecklistInstanceAndChecklistId: build.query<
      GetProjectByProjectIdChecklistInstanceAndChecklistIdApiResponse,
      GetProjectByProjectIdChecklistInstanceAndChecklistIdApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/checklist/instance/${queryArg.checklistId}` }),
    }),
    getProjectByProjectIdChecklistCreatedByUser: build.query<
      GetProjectByProjectIdChecklistCreatedByUserApiResponse,
      GetProjectByProjectIdChecklistCreatedByUserApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/checklist/createdByUser` }),
    }),
    postProjectByProjectIdChecklistUpdateRowPosition: build.mutation<
      PostProjectByProjectIdChecklistUpdateRowPositionApiResponse,
      PostProjectByProjectIdChecklistUpdateRowPositionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/updateRowPosition`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdChecklistAndChecklistIdParts: build.query<
      GetProjectByProjectIdChecklistAndChecklistIdPartsApiResponse,
      GetProjectByProjectIdChecklistAndChecklistIdPartsApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/parts` }),
    }),
    getProjectByProjectIdChecklistAndChecklistIdLogsRowId: build.query<
      GetProjectByProjectIdChecklistAndChecklistIdLogsRowIdApiResponse,
      GetProjectByProjectIdChecklistAndChecklistIdLogsRowIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/logs/${queryArg.rowId}`,
      }),
    }),
    postProjectByProjectIdChecklistAdd: build.mutation<
      PostProjectByProjectIdChecklistAddApiResponse,
      PostProjectByProjectIdChecklistAddApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/add`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdChecklistImportExcel: build.mutation<
      PostProjectByProjectIdChecklistImportExcelApiResponse,
      PostProjectByProjectIdChecklistImportExcelApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/import/excel`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdChecklistAndChecklistIdCategory: build.mutation<
      PostProjectByProjectIdChecklistAndChecklistIdCategoryApiResponse,
      PostProjectByProjectIdChecklistAndChecklistIdCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/category`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdChecklistAndChecklistIdItem: build.mutation<
      PostProjectByProjectIdChecklistAndChecklistIdItemApiResponse,
      PostProjectByProjectIdChecklistAndChecklistIdItemApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/item`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdInactive: build.mutation<
      PutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdInactiveApiResponse,
      PutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/category/${queryArg.categoryId}/inactive`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProjectByProjectIdChecklistAndChecklistIdCategoryCategoryId: build.mutation<
      DeleteProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdApiResponse,
      DeleteProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/category/${queryArg.categoryId}`,
        method: "DELETE",
      }),
    }),
    putProjectByProjectIdChecklistAndChecklistIdCategoryCategoryId: build.mutation<
      PutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdApiResponse,
      PutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/category/${queryArg.categoryId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProjectByProjectIdChecklistAndChecklistIdItemItemId: build.mutation<
      DeleteProjectByProjectIdChecklistAndChecklistIdItemItemIdApiResponse,
      DeleteProjectByProjectIdChecklistAndChecklistIdItemItemIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/item/${queryArg.itemId}`,
        method: "DELETE",
      }),
    }),
    putProjectByProjectIdChecklistAndChecklistIdItemItemId: build.mutation<
      PutProjectByProjectIdChecklistAndChecklistIdItemItemIdApiResponse,
      PutProjectByProjectIdChecklistAndChecklistIdItemItemIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/item/${queryArg.itemId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdChecklistAndChecklistId: build.mutation<
      PutProjectByProjectIdChecklistAndChecklistIdApiResponse,
      PutProjectByProjectIdChecklistAndChecklistIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdChecklistChecklistitemAndChecklistitemid: build.query<
      GetProjectByProjectIdChecklistChecklistitemAndChecklistitemidApiResponse,
      GetProjectByProjectIdChecklistChecklistitemAndChecklistitemidApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/checklistitem/${queryArg.checklistitemid}`,
      }),
    }),
    getProjectByProjectIdChecklistTags: build.query<
      GetProjectByProjectIdChecklistTagsApiResponse,
      GetProjectByProjectIdChecklistTagsApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/checklist/tags` }),
    }),
    putProjectByProjectIdChecklistIssueConnectDisconnectIssue: build.mutation<
      PutProjectByProjectIdChecklistIssueConnectDisconnectIssueApiResponse,
      PutProjectByProjectIdChecklistIssueConnectDisconnectIssueApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/issue/connect-disconnect-issue`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdChecklistAndChecklistIdUpdateChecklistIds: build.mutation<
      PutProjectByProjectIdChecklistAndChecklistIdUpdateChecklistIdsApiResponse,
      PutProjectByProjectIdChecklistAndChecklistIdUpdateChecklistIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/${queryArg.checklistId}/updateChecklistIds`,
        method: "PUT",
      }),
    }),
    postProjectByProjectIdChecklistTemplatesChecklistsFromTemplateGet: build.mutation<
      PostProjectByProjectIdChecklistTemplatesChecklistsFromTemplateGetApiResponse,
      PostProjectByProjectIdChecklistTemplatesChecklistsFromTemplateGetApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/templates/checklists.from.template.get`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getChecklistMcTemplates: build.query<GetChecklistMcTemplatesApiResponse, GetChecklistMcTemplatesApiArg>({
      query: (queryArg) => ({
        url: `/checklist/mc-templates`,
        params: {
          showInDevelopment: queryArg.showInDevelopment,
        },
      }),
    }),
    postChecklistMcTemplates: build.mutation<PostChecklistMcTemplatesApiResponse, PostChecklistMcTemplatesApiArg>({
      query: (queryArg) => ({ url: `/checklist/mc-templates`, method: "POST", body: queryArg.body }),
    }),
    getChecklistByChecklistIdExport: build.query<
      GetChecklistByChecklistIdExportApiResponse,
      GetChecklistByChecklistIdExportApiArg
    >({
      query: (queryArg) => ({
        url: `/checklist/${queryArg.checklistId}/export`,
        params: {
          excel: queryArg.excel,
        },
      }),
    }),
    postChecklistValidateExcel: build.mutation<PostChecklistValidateExcelApiResponse, PostChecklistValidateExcelApiArg>(
      {
        query: (queryArg) => ({ url: `/checklist/validate-excel`, method: "POST", body: queryArg.body }),
      },
    ),
    postChecklistMcTemplatesPublish: build.mutation<
      PostChecklistMcTemplatesPublishApiResponse,
      PostChecklistMcTemplatesPublishApiArg
    >({
      query: (queryArg) => ({ url: `/checklist/mc-templates/publish`, method: "POST", body: queryArg.body }),
    }),
    getChecklistLogs: build.query<GetChecklistLogsApiResponse, GetChecklistLogsApiArg>({
      query: (queryArg) => ({
        url: `/checklist/logs`,
        params: {
          projectNo: queryArg.projectNo,
          checklistId: queryArg.checklistId,
        },
      }),
    }),
    getChecklistProjectTemplates: build.query<
      GetChecklistProjectTemplatesApiResponse,
      GetChecklistProjectTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/checklist/project-templates`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postChecklistMcTemplatesUploadDocx: build.mutation<
      PostChecklistMcTemplatesUploadDocxApiResponse,
      PostChecklistMcTemplatesUploadDocxApiArg
    >({
      query: (queryArg) => ({ url: `/checklist/mc-templates/upload-docx`, method: "POST", body: queryArg.body }),
    }),
    getChecklistMcTemplatesDocxDownload: build.query<
      GetChecklistMcTemplatesDocxDownloadApiResponse,
      GetChecklistMcTemplatesDocxDownloadApiArg
    >({
      query: (queryArg) => ({
        url: `/checklist/mc-templates/docx/download`,
        params: {
          filename: queryArg.filename,
        },
      }),
    }),
    getChecklistMcTemplatesDocx: build.query<GetChecklistMcTemplatesDocxApiResponse, GetChecklistMcTemplatesDocxApiArg>(
      {
        query: () => ({ url: `/checklist/mc-templates/docx` }),
      },
    ),
    postChecklistIntegrationGenerate: build.mutation<
      PostChecklistIntegrationGenerateApiResponse,
      PostChecklistIntegrationGenerateApiArg
    >({
      query: (queryArg) => ({ url: `/checklist/integration/generate`, method: "POST", body: queryArg.body }),
    }),
    getChecklistsByReviewByReviewId: build.query<
      GetChecklistsByReviewByReviewIdApiResponse,
      GetChecklistsByReviewByReviewIdApiArg
    >({
      query: (queryArg) => ({ url: `/checklists/by-review/${queryArg.reviewId}` }),
    }),
    putProjectByProjectIdChecklistItemAndChecklistItemIdCommentCommentIdReaction: build.mutation<
      PutProjectByProjectIdChecklistItemAndChecklistItemIdCommentCommentIdReactionApiResponse,
      PutProjectByProjectIdChecklistItemAndChecklistItemIdCommentCommentIdReactionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/checklist/item/${queryArg.checklistItemId}/comment/${queryArg.commentId}/reaction`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putChecklistsByChecklistIdDkApprovalToggle: build.mutation<
      PutChecklistsByChecklistIdDkApprovalToggleApiResponse,
      PutChecklistsByChecklistIdDkApprovalToggleApiArg
    >({
      query: (queryArg) => ({
        url: `/checklists/${queryArg.checklistId}/dk-approval/toggle`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssuesCreate: build.mutation<
      PostProjectByProjectIdIssuesCreateApiResponse,
      PostProjectByProjectIdIssuesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/create`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssuesTrpcIssueGetConnectedIssues: build.query<
      GetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesApiResponse,
      GetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/trpcIssueGetConnectedIssues`,
        params: {
          _id: queryArg._id,
        },
      }),
    }),
    putProjectByProjectIdIssuesUpdateGantActivity: build.mutation<
      PutProjectByProjectIdIssuesUpdateGantActivityApiResponse,
      PutProjectByProjectIdIssuesUpdateGantActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/update-gant-activity`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putIssueConnect: build.mutation<PutIssueConnectApiResponse, PutIssueConnectApiArg>({
      query: (queryArg) => ({ url: `/issue/connect`, method: "PUT", body: queryArg.body }),
    }),
    getIssueByUser: build.query<GetIssueByUserApiResponse, GetIssueByUserApiArg>({
      query: (queryArg) => ({
        url: `/issue/by-user`,
        params: {
          relation: queryArg.relation,
          maxAgeYears: queryArg.maxAgeYears,
          projectId: queryArg.projectId,
        },
      }),
    }),
    putProjectByProjectIdIssuesKanbanreorder: build.mutation<
      PutProjectByProjectIdIssuesKanbanreorderApiResponse,
      PutProjectByProjectIdIssuesKanbanreorderApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/kanbanreorder`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoards: build.query<
      GetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsApiResponse,
      GetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/by-connectedTasksAndIssuesFromOtherBoards`,
        params: {
          issueId: queryArg.issueId,
        },
      }),
    }),
    postProjectByProjectIdIssuesCopy: build.mutation<
      PostProjectByProjectIdIssuesCopyApiResponse,
      PostProjectByProjectIdIssuesCopyApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/issues/copy`, method: "POST", body: queryArg.body }),
    }),
    getProjectByProjectIdIssuesGetSingle: build.query<
      GetProjectByProjectIdIssuesGetSingleApiResponse,
      GetProjectByProjectIdIssuesGetSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/get-single`,
        params: {
          issueId: queryArg.issueId,
        },
      }),
    }),
    getProjectByProjectIdIssuesExternal: build.query<
      GetProjectByProjectIdIssuesExternalApiResponse,
      GetProjectByProjectIdIssuesExternalApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/external`,
        params: {
          issueboardId: queryArg.issueboardId,
          includeTasks: queryArg.includeTasks,
        },
      }),
    }),
    getProjectByProjectIdIssuesOnBoard: build.query<
      GetProjectByProjectIdIssuesOnBoardApiResponse,
      GetProjectByProjectIdIssuesOnBoardApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues-on-board`,
        params: {
          issueboardId: queryArg.issueboardId,
          includeIssues: queryArg.includeIssues,
          includeTasks: queryArg.includeTasks,
          includeAllCompletedIssues: queryArg.includeAllCompletedIssues,
          taskOrIssue: queryArg.taskOrIssue,
        },
      }),
    }),
    getProjectByProjectIdIssuesOnBoardOldCompleted: build.query<
      GetProjectByProjectIdIssuesOnBoardOldCompletedApiResponse,
      GetProjectByProjectIdIssuesOnBoardOldCompletedApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues-on-board/old-completed`,
        params: {
          issueboardId: queryArg.issueboardId,
          includeIssues: queryArg.includeIssues,
          includeTasks: queryArg.includeTasks,
          taskOrIssue: queryArg.taskOrIssue,
        },
      }),
    }),
    getProjectByProjectIdIssuesOnBoardOldCompletedCount: build.query<
      GetProjectByProjectIdIssuesOnBoardOldCompletedCountApiResponse,
      GetProjectByProjectIdIssuesOnBoardOldCompletedCountApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues-on-board/old-completed-count`,
        params: {
          issueboardId: queryArg.issueboardId,
          includeIssues: queryArg.includeIssues,
          includeTasks: queryArg.includeTasks,
          taskOrIssue: queryArg.taskOrIssue,
        },
      }),
    }),
    postProjectByProjectIdIssuesOnBoards: build.mutation<
      PostProjectByProjectIdIssuesOnBoardsApiResponse,
      PostProjectByProjectIdIssuesOnBoardsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues-on-boards`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssuesFilesOnBoard: build.query<
      GetProjectByProjectIdIssuesFilesOnBoardApiResponse,
      GetProjectByProjectIdIssuesFilesOnBoardApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/files-on-board`,
        params: {
          issueboardId: queryArg.issueboardId,
        },
      }),
    }),
    putProjectByProjectIdIssueUpdateDates: build.mutation<
      PutProjectByProjectIdIssueUpdateDatesApiResponse,
      PutProjectByProjectIdIssueUpdateDatesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/update-dates`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssueFormulaGroupIssues: build.query<
      GetProjectByProjectIdIssueFormulaGroupIssuesApiResponse,
      GetProjectByProjectIdIssueFormulaGroupIssuesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/formula-group-issues`,
        params: {
          issueId: queryArg.issueId,
          formulaAttributeKey: queryArg.formulaAttributeKey,
        },
      }),
    }),
    putProjectByProjectIdIssueUpdateFormulaCounter: build.mutation<
      PutProjectByProjectIdIssueUpdateFormulaCounterApiResponse,
      PutProjectByProjectIdIssueUpdateFormulaCounterApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/update-formula-counter`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssuesFileDescription: build.mutation<
      PostProjectByProjectIdIssuesFileDescriptionApiResponse,
      PostProjectByProjectIdIssuesFileDescriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/file-description`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueConnectedBimSpaces: build.mutation<
      PutProjectByProjectIdIssueConnectedBimSpacesApiResponse,
      PutProjectByProjectIdIssueConnectedBimSpacesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/connected-bim-spaces`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdConnectedTasks: build.query<
      GetProjectByProjectIdConnectedTasksApiResponse,
      GetProjectByProjectIdConnectedTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/connected-tasks`,
        params: {
          issueId: queryArg.issueId,
        },
      }),
    }),
    postProjectByProjectIdIssueTodosAdd: build.mutation<
      PostProjectByProjectIdIssueTodosAddApiResponse,
      PostProjectByProjectIdIssueTodosAddApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/todos/add`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueTodosUpdate: build.mutation<
      PutProjectByProjectIdIssueTodosUpdateApiResponse,
      PutProjectByProjectIdIssueTodosUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/todos/update`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueTodosToggle: build.mutation<
      PutProjectByProjectIdIssueTodosToggleApiResponse,
      PutProjectByProjectIdIssueTodosToggleApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/todos/toggle`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueTodosReorder: build.mutation<
      PutProjectByProjectIdIssueTodosReorderApiResponse,
      PutProjectByProjectIdIssueTodosReorderApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/todos/reorder`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProjectByProjectIdIssueTodosDelete: build.mutation<
      DeleteProjectByProjectIdIssueTodosDeleteApiResponse,
      DeleteProjectByProjectIdIssueTodosDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/todos/delete`,
        method: "DELETE",
        params: {
          issueId: queryArg.issueId,
          todoId: queryArg.todoId,
        },
      }),
    }),
    postProjectByProjectIdIssuesGenerateDocx: build.mutation<
      PostProjectByProjectIdIssuesGenerateDocxApiResponse,
      PostProjectByProjectIdIssuesGenerateDocxApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/generate-docx`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueUpdateSimple: build.mutation<
      PutProjectByProjectIdIssueUpdateSimpleApiResponse,
      PutProjectByProjectIdIssueUpdateSimpleApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/update-simple`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueUpdateDescription: build.mutation<
      PutProjectByProjectIdIssueUpdateDescriptionApiResponse,
      PutProjectByProjectIdIssueUpdateDescriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/update-description`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueUpdateUser: build.mutation<
      PutProjectByProjectIdIssueUpdateUserApiResponse,
      PutProjectByProjectIdIssueUpdateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/update-user`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueConnectedTasksUpdateOrder: build.mutation<
      PutProjectByProjectIdIssueConnectedTasksUpdateOrderApiResponse,
      PutProjectByProjectIdIssueConnectedTasksUpdateOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/connected-tasks/update-order`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueSubscribe: build.mutation<
      PutProjectByProjectIdIssueSubscribeApiResponse,
      PutProjectByProjectIdIssueSubscribeApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/subscribe`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueArchive: build.mutation<
      PutProjectByProjectIdIssueArchiveApiResponse,
      PutProjectByProjectIdIssueArchiveApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/archive`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueItemAndIssueIdCommentCommentIdReaction: build.mutation<
      PutProjectByProjectIdIssueItemAndIssueIdCommentCommentIdReactionApiResponse,
      PutProjectByProjectIdIssueItemAndIssueIdCommentCommentIdReactionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/item/${queryArg.issueId}/comment/${queryArg.commentId}/reaction`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueConvertType: build.mutation<
      PutProjectByProjectIdIssueConvertTypeApiResponse,
      PutProjectByProjectIdIssueConvertTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/convert-type`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssueAndIssueIdLogs: build.query<
      GetProjectByProjectIdIssueAndIssueIdLogsApiResponse,
      GetProjectByProjectIdIssueAndIssueIdLogsApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/issue/${queryArg.issueId}/logs` }),
    }),
    getProjectByProjectIdIssuesValidateOtherAttributesByBoard: build.query<
      GetProjectByProjectIdIssuesValidateOtherAttributesByBoardApiResponse,
      GetProjectByProjectIdIssuesValidateOtherAttributesByBoardApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/validate-other-attributes-by-board`,
        params: {
          issueBoardId: queryArg.issueBoardId,
        },
      }),
    }),
    postProjectByProjectIdIssuesAndIssueIdRunBreeamCheck: build.mutation<
      PostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckApiResponse,
      PostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/${queryArg.issueId}/run-breeam-check`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsageAggregateProjectStarts: build.query<
      GetUsageAggregateProjectStartsApiResponse,
      GetUsageAggregateProjectStartsApiArg
    >({
      query: (queryArg) => ({
        url: `/usage/aggregate/project-starts`,
        params: {
          fromDate: queryArg.fromDate,
          toDate: queryArg.toDate,
          appName: queryArg.appName,
        },
      }),
    }),
    getUsageAggregateProject: build.query<GetUsageAggregateProjectApiResponse, GetUsageAggregateProjectApiArg>({
      query: (queryArg) => ({
        url: `/usage/aggregate/project`,
        params: {
          fromDate: queryArg.fromDate,
          toDate: queryArg.toDate,
          projectId: queryArg.projectId,
        },
      }),
    }),
    getProjectByProjectIdTableTemplates: build.query<
      GetProjectByProjectIdTableTemplatesApiResponse,
      GetProjectByProjectIdTableTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/table-templates`,
        params: {
          issueboardId: queryArg.issueboardId,
        },
      }),
    }),
    patchProjectByProjectIdTableTemplate: build.mutation<
      PatchProjectByProjectIdTableTemplateApiResponse,
      PatchProjectByProjectIdTableTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/table-template`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdTableTemplate: build.mutation<
      PostProjectByProjectIdTableTemplateApiResponse,
      PostProjectByProjectIdTableTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/table-template`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdMeeting: build.mutation<
      PostProjectByProjectIdMeetingApiResponse,
      PostProjectByProjectIdMeetingApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/meeting`, method: "POST", body: queryArg.body }),
    }),
    getProjectByProjectIdMeetingAndMeetingId: build.query<
      GetProjectByProjectIdMeetingAndMeetingIdApiResponse,
      GetProjectByProjectIdMeetingAndMeetingIdApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/meeting/${queryArg.meetingId}` }),
    }),
    putProjectByProjectIdMeetingAndMeetingId: build.mutation<
      PutProjectByProjectIdMeetingAndMeetingIdApiResponse,
      PutProjectByProjectIdMeetingAndMeetingIdApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/meeting/${queryArg.meetingId}`, method: "PUT" }),
    }),
    getMeetingParticipantByUserId: build.query<
      GetMeetingParticipantByUserIdApiResponse,
      GetMeetingParticipantByUserIdApiArg
    >({
      query: (queryArg) => ({ url: `/meeting/participant/${queryArg.userId}` }),
    }),
    postProjectByProjectIdMeetingNewSingleMeeting: build.mutation<
      PostProjectByProjectIdMeetingNewSingleMeetingApiResponse,
      PostProjectByProjectIdMeetingNewSingleMeetingApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meeting/new-single-meeting`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingNewMeetingInSeries: build.mutation<
      PutProjectByProjectIdMeetingNewMeetingInSeriesApiResponse,
      PutProjectByProjectIdMeetingNewMeetingInSeriesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meeting/new-meeting-in-series`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingAndMeetingIdAttribute: build.mutation<
      PutProjectByProjectIdMeetingAndMeetingIdAttributeApiResponse,
      PutProjectByProjectIdMeetingAndMeetingIdAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meeting/${queryArg.meetingId}/attribute`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingAndMeetingIdSendagenda: build.mutation<
      PutProjectByProjectIdMeetingAndMeetingIdSendagendaApiResponse,
      PutProjectByProjectIdMeetingAndMeetingIdSendagendaApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meeting/${queryArg.meetingId}/sendagenda`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdMeetingAndMeetingIdParticipantUserId: build.mutation<
      PostProjectByProjectIdMeetingAndMeetingIdParticipantUserIdApiResponse,
      PostProjectByProjectIdMeetingAndMeetingIdParticipantUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meeting/${queryArg.meetingId}/participant/${queryArg.userId}`,
        method: "POST",
      }),
    }),
    putProjectByProjectIdMeetingAndMeetingIdParticipantParticipantId: build.mutation<
      PutProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdApiResponse,
      PutProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meeting/${queryArg.meetingId}/participant/${queryArg.participantId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProjectByProjectIdMeetingAndMeetingIdParticipantParticipantId: build.mutation<
      DeleteProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdApiResponse,
      DeleteProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meeting/${queryArg.meetingId}/participant/${queryArg.participantId}`,
        method: "DELETE",
      }),
    }),
    postProjectByProjectIdMeetingAndMeetingIdExternalParticipants: build.mutation<
      PostProjectByProjectIdMeetingAndMeetingIdExternalParticipantsApiResponse,
      PostProjectByProjectIdMeetingAndMeetingIdExternalParticipantsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meeting/${queryArg.meetingId}/externalParticipants`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingAndMeetingIdUpdateAgendaIds: build.mutation<
      PutProjectByProjectIdMeetingAndMeetingIdUpdateAgendaIdsApiResponse,
      PutProjectByProjectIdMeetingAndMeetingIdUpdateAgendaIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meeting/${queryArg.meetingId}/updateAgendaIds`,
        method: "PUT",
      }),
    }),
    getProjectByProjectIdMeetingserie: build.query<
      GetProjectByProjectIdMeetingserieApiResponse,
      GetProjectByProjectIdMeetingserieApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/meetingserie` }),
    }),
    postProjectByProjectIdMeetingserie: build.mutation<
      PostProjectByProjectIdMeetingserieApiResponse,
      PostProjectByProjectIdMeetingserieApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingserie`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdMeetingserieAndMeetingSerieId: build.query<
      GetProjectByProjectIdMeetingserieAndMeetingSerieIdApiResponse,
      GetProjectByProjectIdMeetingserieAndMeetingSerieIdApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/meetingserie/${queryArg.meetingSerieId}` }),
    }),
    putProjectByProjectIdMeetingserieAndMeetingSerieId: build.mutation<
      PutProjectByProjectIdMeetingserieAndMeetingSerieIdApiResponse,
      PutProjectByProjectIdMeetingserieAndMeetingSerieIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingserie/${queryArg.meetingSerieId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdMeetingserieAllFields: build.mutation<
      PostProjectByProjectIdMeetingserieAllFieldsApiResponse,
      PostProjectByProjectIdMeetingserieAllFieldsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingserie/all-fields`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingserieAndMeetingSerieIdAttribute: build.mutation<
      PutProjectByProjectIdMeetingserieAndMeetingSerieIdAttributeApiResponse,
      PutProjectByProjectIdMeetingserieAndMeetingSerieIdAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingserie/${queryArg.meetingSerieId}/attribute`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdMeetingagendaMeetingAndMeetingId: build.mutation<
      PostProjectByProjectIdMeetingagendaMeetingAndMeetingIdApiResponse,
      PostProjectByProjectIdMeetingagendaMeetingAndMeetingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/meeting/${queryArg.meetingId}`,
        method: "POST",
      }),
    }),
    getProjectByProjectIdMeetingagendaAndAgendaId: build.query<
      GetProjectByProjectIdMeetingagendaAndAgendaIdApiResponse,
      GetProjectByProjectIdMeetingagendaAndAgendaIdApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/meetingagenda/${queryArg.agendaId}` }),
    }),
    putProjectByProjectIdMeetingagendaAndAgendaIdAttribute: build.mutation<
      PutProjectByProjectIdMeetingagendaAndAgendaIdAttributeApiResponse,
      PutProjectByProjectIdMeetingagendaAndAgendaIdAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/${queryArg.agendaId}/attribute`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingagendaAndAgendaIdOrder: build.mutation<
      PutProjectByProjectIdMeetingagendaAndAgendaIdOrderApiResponse,
      PutProjectByProjectIdMeetingagendaAndAgendaIdOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/${queryArg.agendaId}/order`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingagendaAndAgendaIdConnectDisconnectIssueIssueId: build.mutation<
      PutProjectByProjectIdMeetingagendaAndAgendaIdConnectDisconnectIssueIssueIdApiResponse,
      PutProjectByProjectIdMeetingagendaAndAgendaIdConnectDisconnectIssueIssueIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/${queryArg.agendaId}/connect-disconnect-issue/${queryArg.issueId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingagendaTodoAndAgendaIdToggle: build.mutation<
      PutProjectByProjectIdMeetingagendaTodoAndAgendaIdToggleApiResponse,
      PutProjectByProjectIdMeetingagendaTodoAndAgendaIdToggleApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/todo/${queryArg.agendaId}/toggle`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdMeetingagendaTodoAndAgendaIdAdd: build.mutation<
      PostProjectByProjectIdMeetingagendaTodoAndAgendaIdAddApiResponse,
      PostProjectByProjectIdMeetingagendaTodoAndAgendaIdAddApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/todo/${queryArg.agendaId}/add`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingagendaTodoAndAgendaIdUpdate: build.mutation<
      PutProjectByProjectIdMeetingagendaTodoAndAgendaIdUpdateApiResponse,
      PutProjectByProjectIdMeetingagendaTodoAndAgendaIdUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/todo/${queryArg.agendaId}/update`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProjectByProjectIdMeetingagendaTodoAndAgendaIdDeleteTodoId: build.mutation<
      DeleteProjectByProjectIdMeetingagendaTodoAndAgendaIdDeleteTodoIdApiResponse,
      DeleteProjectByProjectIdMeetingagendaTodoAndAgendaIdDeleteTodoIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/todo/${queryArg.agendaId}/delete/${queryArg.todoId}`,
        method: "DELETE",
      }),
    }),
    postProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentId: build.mutation<
      PostProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdApiResponse,
      PostProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/${queryArg.agendaId}/comment/${queryArg.commentId}`,
        method: "POST",
      }),
    }),
    deleteProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentId: build.mutation<
      DeleteProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdApiResponse,
      DeleteProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/${queryArg.agendaId}/comment/${queryArg.commentId}`,
        method: "DELETE",
      }),
    }),
    putProjectByProjectIdMeetingagendaCommentAndCommentId: build.mutation<
      PutProjectByProjectIdMeetingagendaCommentAndCommentIdApiResponse,
      PutProjectByProjectIdMeetingagendaCommentAndCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/comment/${queryArg.commentId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdReaction: build.mutation<
      PutProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdReactionApiResponse,
      PutProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdReactionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/meetingagenda/${queryArg.agendaId}/comment/${queryArg.commentId}/reaction`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdAgendaItemReorderConnectedIssues: build.mutation<
      PutProjectByProjectIdAgendaItemReorderConnectedIssuesApiResponse,
      PutProjectByProjectIdAgendaItemReorderConnectedIssuesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/agendaItem/reorder-connected-issues`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postIssueboardFavoriteToggle: build.mutation<
      PostIssueboardFavoriteToggleApiResponse,
      PostIssueboardFavoriteToggleApiArg
    >({
      query: (queryArg) => ({ url: `/issueboard/favorite/toggle`, method: "POST", body: queryArg.body }),
    }),
    getIssueboardFavorites: build.query<GetIssueboardFavoritesApiResponse, GetIssueboardFavoritesApiArg>({
      query: (queryArg) => ({
        url: `/issueboard/favorites`,
        params: {
          projectId: queryArg.projectId,
        },
      }),
    }),
    postProjectByProjectIdIssueboard: build.mutation<
      PostProjectByProjectIdIssueboardApiResponse,
      PostProjectByProjectIdIssueboardApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/issueboard`, method: "POST", body: queryArg.body }),
    }),
    getProjectByProjectIdIssueboard: build.query<
      GetProjectByProjectIdIssueboardApiResponse,
      GetProjectByProjectIdIssueboardApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/issueboard` }),
    }),
    getProjectByProjectIdIssueboardAndIssueBoardId: build.query<
      GetProjectByProjectIdIssueboardAndIssueBoardIdApiResponse,
      GetProjectByProjectIdIssueboardAndIssueBoardIdApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/issueboard/${queryArg.issueBoardId}` }),
    }),
    postProjectByProjectIdIssueboardAndBoardIdTableTemplate: build.mutation<
      PostProjectByProjectIdIssueboardAndBoardIdTableTemplateApiResponse,
      PostProjectByProjectIdIssueboardAndBoardIdTableTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/${queryArg.boardId}/tableTemplate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteProjectByProjectIdIssueboardAndBoardIdTableTemplateTemplateId: build.mutation<
      DeleteProjectByProjectIdIssueboardAndBoardIdTableTemplateTemplateIdApiResponse,
      DeleteProjectByProjectIdIssueboardAndBoardIdTableTemplateTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/${queryArg.boardId}/tableTemplate/${queryArg.templateId}`,
        method: "DELETE",
      }),
    }),
    putProjectByProjectIdIssueboardAndBoardId: build.mutation<
      PutProjectByProjectIdIssueboardAndBoardIdApiResponse,
      PutProjectByProjectIdIssueboardAndBoardIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/${queryArg.boardId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueboardAndBoardIdBuckets: build.mutation<
      PutProjectByProjectIdIssueboardAndBoardIdBucketsApiResponse,
      PutProjectByProjectIdIssueboardAndBoardIdBucketsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/${queryArg.boardId}/buckets`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueboardAndBoardIdUsebucketsasworkflow: build.mutation<
      PutProjectByProjectIdIssueboardAndBoardIdUsebucketsasworkflowApiResponse,
      PutProjectByProjectIdIssueboardAndBoardIdUsebucketsasworkflowApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/${queryArg.boardId}/usebucketsasworkflow`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueboardAndBoardIdTypes: build.mutation<
      PutProjectByProjectIdIssueboardAndBoardIdTypesApiResponse,
      PutProjectByProjectIdIssueboardAndBoardIdTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/${queryArg.boardId}/types`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueboardAndBoardIdAttribute: build.mutation<
      PutProjectByProjectIdIssueboardAndBoardIdAttributeApiResponse,
      PutProjectByProjectIdIssueboardAndBoardIdAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/${queryArg.boardId}/attribute`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssueboardTemplateAll: build.query<
      GetProjectByProjectIdIssueboardTemplateAllApiResponse,
      GetProjectByProjectIdIssueboardTemplateAllApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/issueboard/template/all` }),
    }),
    postProjectByProjectIdIssueboardImportExcel: build.mutation<
      PostProjectByProjectIdIssueboardImportExcelApiResponse,
      PostProjectByProjectIdIssueboardImportExcelApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/import-excel`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueboardAndBoardIdAccess: build.mutation<
      PutProjectByProjectIdIssueboardAndBoardIdAccessApiResponse,
      PutProjectByProjectIdIssueboardAndBoardIdAccessApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/${queryArg.boardId}/access`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueboardAndBoardIdDisabledColumns: build.mutation<
      PutProjectByProjectIdIssueboardAndBoardIdDisabledColumnsApiResponse,
      PutProjectByProjectIdIssueboardAndBoardIdDisabledColumnsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/${queryArg.boardId}/disabledColumns`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardOtherAttributesConfigAdd: build.mutation<
      PostProjectByProjectIdIssueboardOtherAttributesConfigAddApiResponse,
      PostProjectByProjectIdIssueboardOtherAttributesConfigAddApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/otherAttributesConfig.add`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardOtherAttributesConfigUpdateorder: build.mutation<
      PostProjectByProjectIdIssueboardOtherAttributesConfigUpdateorderApiResponse,
      PostProjectByProjectIdIssueboardOtherAttributesConfigUpdateorderApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/otherAttributesConfig.updateorder`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardUseonlypredefinedtagsUpdate: build.mutation<
      PostProjectByProjectIdIssueboardUseonlypredefinedtagsUpdateApiResponse,
      PostProjectByProjectIdIssueboardUseonlypredefinedtagsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/useonlypredefinedtags.update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardRisikoIsactive: build.mutation<
      PostProjectByProjectIdIssueboardRisikoIsactiveApiResponse,
      PostProjectByProjectIdIssueboardRisikoIsactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/risiko.isactive`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardRisikoProbabilityIsactiveaftertiltak: build.mutation<
      PostProjectByProjectIdIssueboardRisikoProbabilityIsactiveaftertiltakApiResponse,
      PostProjectByProjectIdIssueboardRisikoProbabilityIsactiveaftertiltakApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/risiko.probability.isactiveaftertiltak`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardRisikoProbabilityUpdate: build.mutation<
      PostProjectByProjectIdIssueboardRisikoProbabilityUpdateApiResponse,
      PostProjectByProjectIdIssueboardRisikoProbabilityUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/risiko.probability.update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardRisikoEvaluationcategoryAdd: build.mutation<
      PostProjectByProjectIdIssueboardRisikoEvaluationcategoryAddApiResponse,
      PostProjectByProjectIdIssueboardRisikoEvaluationcategoryAddApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/risiko.evaluationcategory.add`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardRisikoEvaluationcategoryUpdate: build.mutation<
      PostProjectByProjectIdIssueboardRisikoEvaluationcategoryUpdateApiResponse,
      PostProjectByProjectIdIssueboardRisikoEvaluationcategoryUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/risiko.evaluationcategory.update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardMoveIssueboardToProject: build.mutation<
      PostProjectByProjectIdIssueboardMoveIssueboardToProjectApiResponse,
      PostProjectByProjectIdIssueboardMoveIssueboardToProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/move.issueboard.to.project`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardOtherAttributesConfigGetSumsByFormula: build.mutation<
      PostProjectByProjectIdIssueboardOtherAttributesConfigGetSumsByFormulaApiResponse,
      PostProjectByProjectIdIssueboardOtherAttributesConfigGetSumsByFormulaApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/otherAttributesConfig.getSumsByFormula`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardNoteboardImageNodeAdd: build.mutation<
      PostProjectByProjectIdIssueboardNoteboardImageNodeAddApiResponse,
      PostProjectByProjectIdIssueboardNoteboardImageNodeAddApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/noteboardImageNode.add`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardNoteboardImageNodeUpdate: build.mutation<
      PostProjectByProjectIdIssueboardNoteboardImageNodeUpdateApiResponse,
      PostProjectByProjectIdIssueboardNoteboardImageNodeUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/noteboardImageNode.update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardNoteboardImageNodeDelete: build.mutation<
      PostProjectByProjectIdIssueboardNoteboardImageNodeDeleteApiResponse,
      PostProjectByProjectIdIssueboardNoteboardImageNodeDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/noteboardImageNode.delete`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdGanttVacations: build.mutation<
      PutProjectByProjectIdGanttVacationsApiResponse,
      PutProjectByProjectIdGanttVacationsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/gantt-vacations`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardOtherAttributesConfigUpdate: build.mutation<
      PostProjectByProjectIdIssueboardOtherAttributesConfigUpdateApiResponse,
      PostProjectByProjectIdIssueboardOtherAttributesConfigUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/otherAttributesConfig.update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    patchBoardsTemplateAction: build.mutation<PatchBoardsTemplateActionApiResponse, PatchBoardsTemplateActionApiArg>({
      query: (queryArg) => ({ url: `/boards/template/action`, method: "PATCH", body: queryArg.body }),
    }),
    postProjectByProjectIdIssueboardPredefinedtagsUpdate: build.mutation<
      PostProjectByProjectIdIssueboardPredefinedtagsUpdateApiResponse,
      PostProjectByProjectIdIssueboardPredefinedtagsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/predefinedtags.update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardUsepredefinedtagsUpdate: build.mutation<
      PostProjectByProjectIdIssueboardUsepredefinedtagsUpdateApiResponse,
      PostProjectByProjectIdIssueboardUsepredefinedtagsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/usepredefinedtags.update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssueLogs: build.query<
      GetProjectByProjectIdIssueLogsApiResponse,
      GetProjectByProjectIdIssueLogsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue-logs`,
        params: {
          boardId: queryArg.boardId,
          createdAtFrom: queryArg.createdAtFrom,
          createdAtTo: queryArg.createdAtTo,
          limit: queryArg.limit,
          page: queryArg.page,
          includeTotalCount: queryArg.includeTotalCount,
        },
      }),
    }),
    getMcbimCeilingsOnFloor: build.query<GetMcbimCeilingsOnFloorApiResponse, GetMcbimCeilingsOnFloorApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/ceilings-on-floor`,
        params: {
          projectNo: queryArg.projectNo,
          floorName: queryArg.floorName,
        },
      }),
    }),
    getMcbimFrags: build.query<GetMcbimFragsApiResponse, GetMcbimFragsApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/frags`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimFloors: build.query<GetMcbimFloorsApiResponse, GetMcbimFloorsApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/floors`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimFurnitureAndWallsOnFloor: build.query<
      GetMcbimFurnitureAndWallsOnFloorApiResponse,
      GetMcbimFurnitureAndWallsOnFloorApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/furniture-and-walls-on-floor`,
        params: {
          projectNo: queryArg.projectNo,
          floorName: queryArg.floorName,
        },
      }),
    }),
    getMcbimItemsInSpace: build.query<GetMcbimItemsInSpaceApiResponse, GetMcbimItemsInSpaceApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/items-in-space`,
        params: {
          projectId: queryArg.projectId,
          spaceId: queryArg.spaceId,
          spaceName: queryArg.spaceName,
        },
      }),
    }),
    getMcbimSpace: build.query<GetMcbimSpaceApiResponse, GetMcbimSpaceApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/space`,
        params: {
          projectId: queryArg.projectId,
          roomNumber: queryArg.roomNumber,
        },
      }),
    }),
    getMcbimSpaces: build.query<GetMcbimSpacesApiResponse, GetMcbimSpacesApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/spaces`,
        params: {
          projectId: queryArg.projectId,
        },
      }),
    }),
    getMcbimSpacesOnFloor: build.query<GetMcbimSpacesOnFloorApiResponse, GetMcbimSpacesOnFloorApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/spaces-on-floor`,
        params: {
          projectNo: queryArg.projectNo,
          floorName: queryArg.floorName,
        },
      }),
    }),
    getEmailsTemplates: build.query<GetEmailsTemplatesApiResponse, GetEmailsTemplatesApiArg>({
      query: () => ({ url: `/emails/templates` }),
    }),
    getEmailsTemplatesDownload: build.query<GetEmailsTemplatesDownloadApiResponse, GetEmailsTemplatesDownloadApiArg>({
      query: (queryArg) => ({
        url: `/emails/templates/download`,
        params: {
          templateKey: queryArg.templateKey,
        },
      }),
    }),
    postEmailsTemplatesUploadZip: build.mutation<
      PostEmailsTemplatesUploadZipApiResponse,
      PostEmailsTemplatesUploadZipApiArg
    >({
      query: (queryArg) => ({ url: `/emails/templates/upload-zip`, method: "POST", body: queryArg.body }),
    }),
    getProjectByProjectIdProjectdashboardAndDashboardIdNews: build.query<
      GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiResponse,
      GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/projectdashboard/${queryArg.dashboardId}/news` }),
    }),
    postProjectByProjectIdProjectdashboardNews: build.mutation<
      PostProjectByProjectIdProjectdashboardNewsApiResponse,
      PostProjectByProjectIdProjectdashboardNewsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/projectdashboard/news`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdProjectdashboardNewsAndNewsItemId: build.mutation<
      PutProjectByProjectIdProjectdashboardNewsAndNewsItemIdApiResponse,
      PutProjectByProjectIdProjectdashboardNewsAndNewsItemIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/projectdashboard/news/${queryArg.newsItemId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReaction: build.mutation<
      PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiResponse,
      PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/projectdashboard/${queryArg.dashboardId}/news/comment/reaction`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdProjectdashboardNewsSearch: build.mutation<
      PostProjectByProjectIdProjectdashboardNewsSearchApiResponse,
      PostProjectByProjectIdProjectdashboardNewsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/projectdashboard/news/search`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postNotificationsIssueStatuses: build.mutation<
      PostNotificationsIssueStatusesApiResponse,
      PostNotificationsIssueStatusesApiArg
    >({
      query: (queryArg) => ({ url: `/notifications/issue-statuses`, method: "POST", body: queryArg.body }),
    }),
    postAppadminIssueFormulaCounterMaterializationMaterialize: build.mutation<
      PostAppadminIssueFormulaCounterMaterializationMaterializeApiResponse,
      PostAppadminIssueFormulaCounterMaterializationMaterializeApiArg
    >({
      query: (queryArg) => ({
        url: `/appadmin/issue-formula-counter-materialization/materialize`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getAppadminCompanyLogo: build.query<GetAppadminCompanyLogoApiResponse, GetAppadminCompanyLogoApiArg>({
      query: () => ({ url: `/appadmin/company-logo` }),
    }),
    postAppadminCompanyLogo: build.mutation<PostAppadminCompanyLogoApiResponse, PostAppadminCompanyLogoApiArg>({
      query: (queryArg) => ({ url: `/appadmin/company-logo`, method: "POST", body: queryArg.body }),
    }),
    deleteAppadminCompanyLogo: build.mutation<DeleteAppadminCompanyLogoApiResponse, DeleteAppadminCompanyLogoApiArg>({
      query: () => ({ url: `/appadmin/company-logo`, method: "DELETE" }),
    }),
    getAppadminKafkaEmployeeProjects: build.query<
      GetAppadminKafkaEmployeeProjectsApiResponse,
      GetAppadminKafkaEmployeeProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/appadmin/kafka/employee-projects`,
        params: {
          initials: queryArg.initials,
        },
      }),
    }),
    getAppadminKafkaProjectAccess: build.query<
      GetAppadminKafkaProjectAccessApiResponse,
      GetAppadminKafkaProjectAccessApiArg
    >({
      query: (queryArg) => ({
        url: `/appadmin/kafka/project-access`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getAppadminGraphProfilePhoto: build.query<
      GetAppadminGraphProfilePhotoApiResponse,
      GetAppadminGraphProfilePhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/appadmin/graph-profile-photo`,
        params: {
          userIdOrPrincipalName: queryArg.userIdOrPrincipalName,
        },
      }),
    }),
    getAppadminMcappsInitialsAccess: build.query<
      GetAppadminMcappsInitialsAccessApiResponse,
      GetAppadminMcappsInitialsAccessApiArg
    >({
      query: (queryArg) => ({
        url: `/appadmin/mcapps/initials-access`,
        params: {
          initials: queryArg.initials,
        },
      }),
    }),
    getAppadminMcappsProjectAccess: build.query<
      GetAppadminMcappsProjectAccessApiResponse,
      GetAppadminMcappsProjectAccessApiArg
    >({
      query: (queryArg) => ({
        url: `/appadmin/mcapps/project-access`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getAppadminExternalIssueBannersActive: build.query<
      GetAppadminExternalIssueBannersActiveApiResponse,
      GetAppadminExternalIssueBannersActiveApiArg
    >({
      query: () => ({ url: `/appadmin/external-issue-banners/active` }),
    }),
    getAppadminExternalIssueBanners: build.query<
      GetAppadminExternalIssueBannersApiResponse,
      GetAppadminExternalIssueBannersApiArg
    >({
      query: () => ({ url: `/appadmin/external-issue-banners` }),
    }),
    postAppadminExternalIssueBanners: build.mutation<
      PostAppadminExternalIssueBannersApiResponse,
      PostAppadminExternalIssueBannersApiArg
    >({
      query: (queryArg) => ({ url: `/appadmin/external-issue-banners`, method: "POST", body: queryArg.body }),
    }),
    putAppadminExternalIssueBanners: build.mutation<
      PutAppadminExternalIssueBannersApiResponse,
      PutAppadminExternalIssueBannersApiArg
    >({
      query: (queryArg) => ({ url: `/appadmin/external-issue-banners`, method: "PUT", body: queryArg.body }),
    }),
    postAppadminExternalIssueBannersDelete: build.mutation<
      PostAppadminExternalIssueBannersDeleteApiResponse,
      PostAppadminExternalIssueBannersDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/appadmin/external-issue-banners/delete`, method: "POST", body: queryArg.body }),
    }),
    getAppadminMigrations: build.query<GetAppadminMigrationsApiResponse, GetAppadminMigrationsApiArg>({
      query: () => ({ url: `/appadmin/migrations` }),
    }),
    postAppadminMigrationsRun: build.mutation<PostAppadminMigrationsRunApiResponse, PostAppadminMigrationsRunApiArg>({
      query: (queryArg) => ({ url: `/appadmin/migrations/run`, method: "POST", body: queryArg.body }),
    }),
    postAppadminMaconomyUsersSync: build.mutation<
      PostAppadminMaconomyUsersSyncApiResponse,
      PostAppadminMaconomyUsersSyncApiArg
    >({
      query: (queryArg) => ({ url: `/appadmin/maconomy/users/sync`, method: "POST", body: queryArg.body }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as openapi };
export type PingApiResponse = /** status 200 Successful response */ {
  ping: string;
};
export type PingApiArg = void;
export type PutProjectsAutodeskConnectApiResponse = /** status 200 Successful response */ {
  bim360: {
    accountId: string;
    hubId: string;
    projectId: string;
    name: string;
    region: "US" | "EMEA";
    folderUrn: string | null;
    readSubfolders: boolean;
    connection: {
      method: "autodesk-3legged";
      connectedAt: string;
      connectedBy?: string;
      autodeskUserId?: string;
      autodeskUserEmail?: string;
    };
    automation: {
      serviceAccountAccess: "unknown";
    };
  };
};
export type PutProjectsAutodeskConnectApiArg = {
  body: {
    projectId: string;
    accountId: string;
    hubId?: string;
    autodeskProjectId: string;
    name: string;
    region?: "US" | "EMEA";
    folderUrn?: string | null;
    readSubfolders?: boolean;
    autodeskUserId?: string;
    autodeskUserEmail?: string;
  };
};
export type DeleteProjectsAutodeskConnectionApiResponse = /** status 200 Successful response */ {
  disconnected: boolean;
};
export type DeleteProjectsAutodeskConnectionApiArg = {
  projectId: string;
};
export type GetProjectsAutodeskConnectionApiResponse = /** status 200 Successful response */ {
  bim360: {
    accountId: string;
    hubId?: string;
    projectId: string;
    name: string;
    internalOrExternal?: string | null;
    region?: "US" | "EMEA";
    folderUrn?: string | null;
    readSubfolders?: boolean;
    connection?: {
      method?: "url" | "autodesk-3legged";
      connectedAt?: string;
      connectedBy?: string;
      autodeskUserId?: string | null;
      autodeskUserEmail?: string | null;
    };
    automation?: {
      serviceAccountAccess?: "unknown" | "verified" | "failed";
      lastVerifiedAt?: string;
      lastError?: string;
    };
  } | null;
};
export type GetProjectsAutodeskConnectionApiArg = {
  projectId: string;
};
export type GetProjectsAutodeskAvailableProjectsApiResponse = /** status 200 Successful response */ {
  hubs: {
    accountId: string;
    hubId: string;
    hubName: string;
  }[];
  projects: {
    accountId: string;
    hubId: string;
    hubName: string;
    projectId: string;
    projectName: string;
    projectNumber: string | null;
    rootFolderUrn: string | null;
    region: string | null;
    projectType: string | null;
  }[];
};
export type GetProjectsAutodeskAvailableProjectsApiArg = void;
export type PostProjectsAutodeskLoginStartApiResponse = /** status 200 Successful response */ {
  authorizationUrl: string;
  callbackUrl: string;
};
export type PostProjectsAutodeskLoginStartApiArg = {
  body: {
    projectId: string;
    returnPath?: string;
    openerOrigin?: string;
    popup?: boolean;
  };
};
export type PostProjectsAutodeskVerifyServiceAccountAccessApiResponse = /** status 200 Successful response */ {
  serviceAccountAccess: "verified" | "failed";
  checkedProject: boolean;
  checkedRootFolders: boolean;
  checkedFolder: boolean;
  message?: string;
};
export type PostProjectsAutodeskVerifyServiceAccountAccessApiArg = {
  body: {
    projectId: string;
  };
};
export type GetProjectMembersApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: {
    _id: string;
    name: string;
    email: string;
    fullEmail: string;
    employeeNumber?: string | null;
    phoneNumber: string | null;
    location: string | null;
    domain: string;
  };
  group: "ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT";
  isPassive: boolean;
  disciplin: string | null;
  memberOtherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
}[];
export type GetProjectMembersApiArg = {
  projectId: string;
};
export type PutProjectMemberApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: {
    _id: string;
    name: string;
    email: string;
    fullEmail: string;
    employeeNumber?: string | null;
    phoneNumber: string | null;
    location: string | null;
    domain: string;
  };
  group: "ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT";
  isPassive: boolean;
  disciplin: string | null;
  memberOtherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
};
export type PutProjectMemberApiArg = {
  body: {
    projectId: string;
    attribute: "disciplin" | "group" | "isPassive";
    value: string | boolean;
    memberId: string;
  };
};
export type GetProjectMemberApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: {
    _id: string;
    name: string;
    email: string;
    fullEmail: string;
    employeeNumber?: string | null;
    phoneNumber: string | null;
    location: string | null;
    domain: string;
  };
  group: "ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT";
  isPassive: boolean;
  disciplin: string | null;
  memberOtherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
};
export type GetProjectMemberApiArg = {
  projectId: string;
  memberId: string;
};
export type PutProjectMemberOtherAttributesApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: {
    _id: string;
    name: string;
    email: string;
    fullEmail: string;
    employeeNumber?: string | null;
    phoneNumber: string | null;
    location: string | null;
    domain: string;
  };
  group: "ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT";
  isPassive: boolean;
  disciplin: string | null;
  memberOtherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
};
export type PutProjectMemberOtherAttributesApiArg = {
  body: {
    projectId: string;
    memberId: string;
    key: string;
    value: string | number | boolean | null | string[];
  };
};
export type GetProjectIssueboardsApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: {
      _id: string;
      name: string;
    }[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?: {
    _id: string;
    name: string;
  };
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
}[];
export type GetProjectIssueboardsApiArg = {
  projectId: string;
};
export type GetProjectPnsApiResponse = /** status 200 Successful response */ {
  _id: string;
  parentId: string | null;
  props: {
    pnsId: string;
    title: string;
  };
}[];
export type GetProjectPnsApiArg = {
  projectNo: number;
};
export type GetProjectProjectIdApiResponse = /** status 200 Successful response */ string;
export type GetProjectProjectIdApiArg = {
  projectNo: number;
};
export type GetProjectsMcappsApiResponse = /** status 200 Successful response */ {
  createdAt?: string;
  maconomy?: {
    projectNo: number;
    name: string;
    coordinates?: {
      UTMN: number;
      GNR: number;
      BNR: number;
      UTME: number;
      UTMZ: number;
    };
    useDashboardAsDefaultStartPage?: boolean;
  };
  _id: string;
}[];
export type GetProjectsMcappsApiArg = void;
export type GetProjectsMaconomyApiResponse = /** status 200 Successful response */ {
  projectNo: number;
  name: string;
  coordinates?: {
    UTMN: number;
    GNR: number;
    BNR: number;
    UTME: number;
    UTMZ: number;
  };
  useDashboardAsDefaultStartPage?: boolean;
}[];
export type GetProjectsMaconomyApiArg = void;
export type PostProjectMaconomyMembersSyncApiResponse = /** status 200 Successful response */ {
  dryRun: boolean;
  projectId: string;
  projectNo: number;
  accessEmployeeNumberCount: number;
  rawAccessEmployeeNumberCount: number;
  localUserMatchCount: number;
  existingMemberCount: number;
  existingUniqueMemberCount: number;
  duplicateExistingMemberUserIds: string[];
  missingUserEmployeeNumbers: string[];
  missingEmployeeEmployeeNumbers: string[];
  skippedNonMulticonsultEmployeeNumbers: string[];
  skippedCreateDuplicateEmployeeNumbers: string[];
  skippedCreateDuplicateEmails: string[];
  skippedCreateInvalidEmployeeNumbers: string[];
  duplicateLocalUserEmployeeNumbers: string[];
  skippedAlreadyMemberUserIds: string[];
  skippedTerminatedUserIds: string[];
  skippedTerminatedEmployeeNumbers: string[];
  usersToCreate: {
    employeeNumber: string | null;
    name: string;
    email: string;
    fullEmail: string;
  }[];
  usersToCreateCount: number;
  createdUsers: {
    userId: string;
    employeeNumber: string | null;
    name: string | null;
    email: string | null;
    fullEmail: string | null;
  }[];
  createdUserCount: number;
  usersToAdd: {
    userId: string;
    employeeNumber: string | null;
    name: string | null;
    email: string | null;
    fullEmail: string | null;
  }[];
  usersToAddCount: number;
  addedCount: number;
  raceSkippedAlreadyMemberCount: number;
};
export type PostProjectMaconomyMembersSyncApiArg = {
  body: {
    projectId?: string;
    projectNo?: number;
    dryRun?: boolean;
  };
};
export type PostProjectByProjectIdReportboardsApiResponse = /** status 200 Successful response */ {
  _id?: string;
  project: string;
  name: string;
  createdBy?: string;
  status: "ACTIVE" | "DELETED" | "COMPLETED";
  versions: {
    versionNumber: number;
    savedBy: string;
    data: {
      [key: string]: any;
    };
    message?: string;
    createdAt: string;
  }[];
  lastUpdatedBy?: string;
  template: 101 | 102 | 103 | 104 | 106 | 201 | 202 | 205 | 301 | 401 | 601 | 701 | 901;
  doksam?: {
    subTaskNo?: string | null;
  };
  uploadedFiles?: {
    createdDate?: string;
    createdBy: string;
    height?: number;
    width?: number;
    filename: string;
    docxImageTag?: string;
  }[];
  createdAt?: string;
  updatedAt?: string;
};
export type PostProjectByProjectIdReportboardsApiArg = {
  projectId: string;
  body: {
    name: string;
    template: 101 | 102 | 103 | 104 | 106 | 201 | 202 | 205 | 301 | 401 | 601 | 701 | 901;
    doksam?: {
      subTaskNo?: string | null;
    };
  };
};
export type PutUserProfileApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  phoneNumber: string;
  location: string;
};
export type PutUserProfileApiArg = {
  body: {
    userId: string | any;
    patch: {
      name?: string;
      location?: string;
      phoneNumber?: string;
    };
  };
};
export type GetWhoamiApiResponse = /** status 200 Successful response */ {
  authType: "session" | "apiKey";
  user: {
    _id: string;
    name: string;
    email: string;
    phoneNumber: string;
    location: string;
  };
};
export type GetWhoamiApiArg = void;
export type PostUsersProfilePictureSasApiResponse = /** status 200 Successful response */ {
  ttlMinutes: number;
  profilePictures: {
    userId: string;
    url: string;
    expiresAt: string;
  }[];
};
export type PostUsersProfilePictureSasApiArg = {
  body: {
    userIds: string[];
  };
};
export type PostUserApikeyApiResponse = /** status 200 Successful response */ {
  apiKey: string;
  prefix?: string | null;
};
export type PostUserApikeyApiArg = {
  body: object;
};
export type GetUserApikeyApiResponse =
  | /** status 200 Successful response */ {
      prefix?: string | null;
      lastUsedAt: string | null;
      useCount: number;
      revokedAt: string | null;
    }
  | null;
export type GetUserApikeyApiArg = void;
export type DeleteUserApikeyApiResponse = /** status 200 Successful response */ {
  ok: true;
};
export type DeleteUserApikeyApiArg = void;
export type GetProjectByProjectIdChecklistTemplatesApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  id?: number;
  project:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  name: string;
  aboutText?: string | null;
  templateDescription: string;
  templateType: "MC" | "PROJECT" | "";
  isTemplate: boolean;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  tags: string[];
  checkTypes: {
    check1: {
      active: boolean;
      name: string;
    };
    check2: {
      active: boolean;
      name: string;
    };
    check3: {
      active: boolean;
      name: string;
    };
    check4?: {
      active: boolean;
      name: string;
    };
    check5?: {
      active: boolean;
      name: string;
    };
    check6?: {
      active: boolean;
      name: string;
    };
    check7?: {
      active: boolean;
      name: string;
    };
    check8?: {
      active: boolean;
      name: string;
    };
    check9?: {
      active: boolean;
      name: string;
    };
    check10?: {
      active: boolean;
      name: string;
    };
    check11?: {
      active: boolean;
      name: string;
    };
    check12?: {
      active: boolean;
      name: string;
    };
    check13?: {
      active: boolean;
      name: string;
    };
    check14?: {
      active: boolean;
      name: string;
    };
    check15?: {
      active: boolean;
      name: string;
    };
  };
  progress?: {
    accepted: number;
    rejected: number;
  };
  pns?: string | null;
  dueDate?: string | null;
  stampSettings?: {
    yes: {
      text: string;
      color: string;
      icon: string;
    };
    no: {
      text: string;
      color: string;
      icon: string;
    };
    na: {
      text: string;
      color: string;
      icon: string;
    };
    ir: {
      text: string;
      color: string;
      icon: string;
    };
    uav: {
      text: string;
      color: string;
      icon: string;
    };
    [key: string]: any;
  };
  templateCategory?: string | null;
  includeIrOnDefaultRoles: boolean;
  includeUavOnDefaultRoles: boolean;
  phase?: string | null;
  discipline?: string | null;
  activity?: string | null;
  itemTagsActive?: boolean;
  itemTags?: string[];
  activeItemTags?: string[];
  revisionDate?: string | null;
  revisionNr?: string | null;
  activeItemTagChangedDate?: string | null;
  doksam?: {
    docId?: string | null;
    subTaskNo?: string | null;
    reviewId?: string | null;
    check1UserUpn?: string | null;
    check2UserUpn?: string | null;
    dkApproval?: {
      userId?: string;
      name: string | null;
      upn: string | null;
      approvedAt?: string | null;
    };
    [key: string]: any;
  };
  documentCategoryCode: string;
  documentCategoryCode2: string;
  disciplineCode: string;
  subDiscipline: string;
  competenceNetwork: string;
  lastUpdatedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  createdBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  assignedTo?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  admin?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  activeItemTagChangedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  disciplineLeader?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  documentManagers?: {
    preparedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    checkedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    approvedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    [key: string]: any;
  };
  generatedFromTemplate?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  [key: string]: any;
}[];
export type GetProjectByProjectIdChecklistTemplatesApiArg = {
  projectId: string;
};
export type PostProjectByProjectIdChecklistAllApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  id?: number;
  project:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  name: string;
  aboutText?: string | null;
  templateDescription: string;
  templateType: "MC" | "PROJECT" | "";
  isTemplate: boolean;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  tags: string[];
  checkTypes: {
    check1: {
      active: boolean;
      name: string;
    };
    check2: {
      active: boolean;
      name: string;
    };
    check3: {
      active: boolean;
      name: string;
    };
    check4?: {
      active: boolean;
      name: string;
    };
    check5?: {
      active: boolean;
      name: string;
    };
    check6?: {
      active: boolean;
      name: string;
    };
    check7?: {
      active: boolean;
      name: string;
    };
    check8?: {
      active: boolean;
      name: string;
    };
    check9?: {
      active: boolean;
      name: string;
    };
    check10?: {
      active: boolean;
      name: string;
    };
    check11?: {
      active: boolean;
      name: string;
    };
    check12?: {
      active: boolean;
      name: string;
    };
    check13?: {
      active: boolean;
      name: string;
    };
    check14?: {
      active: boolean;
      name: string;
    };
    check15?: {
      active: boolean;
      name: string;
    };
  };
  progress?: {
    accepted: number;
    rejected: number;
  };
  pns?: string | null;
  dueDate?: string | null;
  stampSettings?: {
    yes: {
      text: string;
      color: string;
      icon: string;
    };
    no: {
      text: string;
      color: string;
      icon: string;
    };
    na: {
      text: string;
      color: string;
      icon: string;
    };
    ir: {
      text: string;
      color: string;
      icon: string;
    };
    uav: {
      text: string;
      color: string;
      icon: string;
    };
    [key: string]: any;
  };
  templateCategory?: string | null;
  includeIrOnDefaultRoles: boolean;
  includeUavOnDefaultRoles: boolean;
  phase?: string | null;
  discipline?: string | null;
  activity?: string | null;
  itemTagsActive?: boolean;
  itemTags?: string[];
  activeItemTags?: string[];
  revisionDate?: string | null;
  revisionNr?: string | null;
  activeItemTagChangedDate?: string | null;
  doksam?: {
    docId?: string | null;
    subTaskNo?: string | null;
    reviewId?: string | null;
    check1UserUpn?: string | null;
    check2UserUpn?: string | null;
    dkApproval?: {
      userId?: string;
      name: string | null;
      upn: string | null;
      approvedAt?: string | null;
    };
    [key: string]: any;
  };
  documentCategoryCode: string;
  documentCategoryCode2: string;
  disciplineCode: string;
  subDiscipline: string;
  competenceNetwork: string;
  lastUpdatedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  createdBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  assignedTo?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  admin?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  activeItemTagChangedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  disciplineLeader?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  documentManagers?: {
    preparedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    checkedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    approvedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    [key: string]: any;
  };
  generatedFromTemplate?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  [key: string]: any;
}[];
export type PostProjectByProjectIdChecklistAllApiArg = {
  projectId: string;
  body: {
    freeTextSearch?: string;
    pns?: string;
    doksamDocId?: string;
    isTemplate?: boolean;
  };
};
export type GetProjectByProjectIdChecklistInstanceAndChecklistIdApiResponse =
  | /** status 200 Successful response */ {
      _id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
      id?: number;
      project:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      name: string;
      aboutText?: string | null;
      templateDescription: string;
      templateType: "MC" | "PROJECT" | "";
      isTemplate: boolean;
      status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
      tags: string[];
      checkTypes: {
        check1: {
          active: boolean;
          name: string;
        };
        check2: {
          active: boolean;
          name: string;
        };
        check3: {
          active: boolean;
          name: string;
        };
        check4?: {
          active: boolean;
          name: string;
        };
        check5?: {
          active: boolean;
          name: string;
        };
        check6?: {
          active: boolean;
          name: string;
        };
        check7?: {
          active: boolean;
          name: string;
        };
        check8?: {
          active: boolean;
          name: string;
        };
        check9?: {
          active: boolean;
          name: string;
        };
        check10?: {
          active: boolean;
          name: string;
        };
        check11?: {
          active: boolean;
          name: string;
        };
        check12?: {
          active: boolean;
          name: string;
        };
        check13?: {
          active: boolean;
          name: string;
        };
        check14?: {
          active: boolean;
          name: string;
        };
        check15?: {
          active: boolean;
          name: string;
        };
      };
      progress?: {
        accepted: number;
        rejected: number;
      };
      pns?: string | null;
      dueDate?: string | null;
      stampSettings?: {
        yes: {
          text: string;
          color: string;
          icon: string;
        };
        no: {
          text: string;
          color: string;
          icon: string;
        };
        na: {
          text: string;
          color: string;
          icon: string;
        };
        ir: {
          text: string;
          color: string;
          icon: string;
        };
        uav: {
          text: string;
          color: string;
          icon: string;
        };
        [key: string]: any;
      };
      templateCategory?: string | null;
      includeIrOnDefaultRoles: boolean;
      includeUavOnDefaultRoles: boolean;
      phase?: string | null;
      discipline?: string | null;
      activity?: string | null;
      itemTagsActive?: boolean;
      itemTags?: string[];
      activeItemTags?: string[];
      revisionDate?: string | null;
      revisionNr?: string | null;
      activeItemTagChangedDate?: string | null;
      doksam?: {
        docId?: string | null;
        subTaskNo?: string | null;
        reviewId?: string | null;
        check1UserUpn?: string | null;
        check2UserUpn?: string | null;
        dkApproval?: {
          userId?: string;
          name: string | null;
          upn: string | null;
          approvedAt?: string | null;
        };
        [key: string]: any;
      };
      documentCategoryCode: string;
      documentCategoryCode2: string;
      disciplineCode: string;
      subDiscipline: string;
      competenceNetwork: string;
      lastUpdatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      createdBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      admin?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      activeItemTagChangedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      disciplineLeader?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      documentManagers?: {
        preparedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        checkedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        approvedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      generatedFromTemplate?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    }
  | null;
export type GetProjectByProjectIdChecklistInstanceAndChecklistIdApiArg = {
  projectId: string;
  checklistId: string;
};
export type GetProjectByProjectIdChecklistCreatedByUserApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  id?: number;
  project:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  name: string;
  aboutText?: string | null;
  templateDescription: string;
  templateType: "MC" | "PROJECT" | "";
  isTemplate: boolean;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  tags: string[];
  checkTypes: {
    check1: {
      active: boolean;
      name: string;
    };
    check2: {
      active: boolean;
      name: string;
    };
    check3: {
      active: boolean;
      name: string;
    };
    check4?: {
      active: boolean;
      name: string;
    };
    check5?: {
      active: boolean;
      name: string;
    };
    check6?: {
      active: boolean;
      name: string;
    };
    check7?: {
      active: boolean;
      name: string;
    };
    check8?: {
      active: boolean;
      name: string;
    };
    check9?: {
      active: boolean;
      name: string;
    };
    check10?: {
      active: boolean;
      name: string;
    };
    check11?: {
      active: boolean;
      name: string;
    };
    check12?: {
      active: boolean;
      name: string;
    };
    check13?: {
      active: boolean;
      name: string;
    };
    check14?: {
      active: boolean;
      name: string;
    };
    check15?: {
      active: boolean;
      name: string;
    };
  };
  progress?: {
    accepted: number;
    rejected: number;
  };
  pns?: string | null;
  dueDate?: string | null;
  stampSettings?: {
    yes: {
      text: string;
      color: string;
      icon: string;
    };
    no: {
      text: string;
      color: string;
      icon: string;
    };
    na: {
      text: string;
      color: string;
      icon: string;
    };
    ir: {
      text: string;
      color: string;
      icon: string;
    };
    uav: {
      text: string;
      color: string;
      icon: string;
    };
    [key: string]: any;
  };
  templateCategory?: string | null;
  includeIrOnDefaultRoles: boolean;
  includeUavOnDefaultRoles: boolean;
  phase?: string | null;
  discipline?: string | null;
  activity?: string | null;
  itemTagsActive?: boolean;
  itemTags?: string[];
  activeItemTags?: string[];
  revisionDate?: string | null;
  revisionNr?: string | null;
  activeItemTagChangedDate?: string | null;
  doksam?: {
    docId?: string | null;
    subTaskNo?: string | null;
    reviewId?: string | null;
    check1UserUpn?: string | null;
    check2UserUpn?: string | null;
    dkApproval?: {
      userId?: string;
      name: string | null;
      upn: string | null;
      approvedAt?: string | null;
    };
    [key: string]: any;
  };
  documentCategoryCode: string;
  documentCategoryCode2: string;
  disciplineCode: string;
  subDiscipline: string;
  competenceNetwork: string;
  lastUpdatedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  createdBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  assignedTo?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  admin?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  activeItemTagChangedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  disciplineLeader?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  documentManagers?: {
    preparedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    checkedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    approvedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    [key: string]: any;
  };
  generatedFromTemplate?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  [key: string]: any;
}[];
export type GetProjectByProjectIdChecklistCreatedByUserApiArg = {
  projectId: string;
};
export type PostProjectByProjectIdChecklistUpdateRowPositionApiResponse =
  | /** status 200 Successful response */ {
      _id: string;
      project?:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      title: string;
      collapsed?: boolean;
      dueDate?: string | null;
      checklist:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      categoryId: number;
      checks?: {
        check1?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check2?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check3?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check4?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check5?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check6?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check7?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check8?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check9?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check10?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check11?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check12?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check13?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check14?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check15?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
      };
      [key: string]: any;
    }[]
  | {
      _id: string;
      project?:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      checklist:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      inactive: {
        isChecked: boolean;
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      title: string;
      reference?: string | null;
      comment?: string | null;
      category:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      itemId: number;
      checks: {
        check1: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check2: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check3: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check4: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check5: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check6: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check7: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check8: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check9: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check10: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check11: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check12: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check13: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check14: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check15: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
      };
      comments?: any[];
      itemTags?: string[];
      connectedIssues?: any[];
      [key: string]: any;
    }[];
export type PostProjectByProjectIdChecklistUpdateRowPositionApiArg = {
  projectId: string;
  body: {
    checklistId: string | any;
    isCat: boolean;
    oldCategoryId: string | any;
    newCategoryId: (string | any) | null;
    rowId: string | any;
    position: number;
  };
};
export type GetProjectByProjectIdChecklistAndChecklistIdPartsApiResponse = /** status 200 Successful response */ {
  checklist: {
    _id: string;
    createdAt?: string | null;
    updatedAt?: string | null;
    id?: number;
    project:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    name: string;
    aboutText?: string | null;
    templateDescription: string;
    templateType: "MC" | "PROJECT" | "";
    isTemplate: boolean;
    status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
    tags: string[];
    checkTypes: {
      check1: {
        active: boolean;
        name: string;
      };
      check2: {
        active: boolean;
        name: string;
      };
      check3: {
        active: boolean;
        name: string;
      };
      check4?: {
        active: boolean;
        name: string;
      };
      check5?: {
        active: boolean;
        name: string;
      };
      check6?: {
        active: boolean;
        name: string;
      };
      check7?: {
        active: boolean;
        name: string;
      };
      check8?: {
        active: boolean;
        name: string;
      };
      check9?: {
        active: boolean;
        name: string;
      };
      check10?: {
        active: boolean;
        name: string;
      };
      check11?: {
        active: boolean;
        name: string;
      };
      check12?: {
        active: boolean;
        name: string;
      };
      check13?: {
        active: boolean;
        name: string;
      };
      check14?: {
        active: boolean;
        name: string;
      };
      check15?: {
        active: boolean;
        name: string;
      };
    };
    progress?: {
      accepted: number;
      rejected: number;
    };
    pns?: string | null;
    dueDate?: string | null;
    stampSettings?: {
      yes: {
        text: string;
        color: string;
        icon: string;
      };
      no: {
        text: string;
        color: string;
        icon: string;
      };
      na: {
        text: string;
        color: string;
        icon: string;
      };
      ir: {
        text: string;
        color: string;
        icon: string;
      };
      uav: {
        text: string;
        color: string;
        icon: string;
      };
      [key: string]: any;
    };
    templateCategory?: string | null;
    includeIrOnDefaultRoles: boolean;
    includeUavOnDefaultRoles: boolean;
    phase?: string | null;
    discipline?: string | null;
    activity?: string | null;
    itemTagsActive?: boolean;
    itemTags?: string[];
    activeItemTags?: string[];
    revisionDate?: string | null;
    revisionNr?: string | null;
    activeItemTagChangedDate?: string | null;
    doksam?: {
      docId?: string | null;
      subTaskNo?: string | null;
      reviewId?: string | null;
      check1UserUpn?: string | null;
      check2UserUpn?: string | null;
      dkApproval?: {
        userId?: string;
        name: string | null;
        upn: string | null;
        approvedAt?: string | null;
      };
      [key: string]: any;
    };
    documentCategoryCode: string;
    documentCategoryCode2: string;
    disciplineCode: string;
    subDiscipline: string;
    competenceNetwork: string;
    lastUpdatedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    createdBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    assignedTo?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    admin?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    activeItemTagChangedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    disciplineLeader?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    documentManagers?: {
      preparedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      checkedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      approvedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    generatedFromTemplate?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    [key: string]: any;
  } | null;
  categories: {
    _id: string;
    project?:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    title: string;
    collapsed?: boolean;
    dueDate?: string | null;
    checklist:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    categoryId: number;
    checks?: {
      check1?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check2?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check3?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check4?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check5?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check6?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check7?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check8?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check9?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check10?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check11?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check12?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check13?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check14?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check15?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
    };
    [key: string]: any;
  }[];
  items: {
    _id: string;
    project?:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    checklist:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    inactive: {
      isChecked: boolean;
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    title: string;
    reference?: string | null;
    comment?: string | null;
    category:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    itemId: number;
    checks: {
      check1: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check2: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check3: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check4: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check5: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check6: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check7: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check8: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check9: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check10: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check11: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check12: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check13: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check14: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check15: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
    };
    comments?: any[];
    itemTags?: string[];
    connectedIssues?: any[];
    [key: string]: any;
  }[];
};
export type GetProjectByProjectIdChecklistAndChecklistIdPartsApiArg = {
  projectId: string;
  checklistId: string;
};
export type GetProjectByProjectIdChecklistAndChecklistIdLogsRowIdApiResponse = /** status 200 Successful response */ {
  _id: string;
  column: string;
  columnDisplayName?: string;
  createdAt: string;
  newValue?: string | null;
  oldValue?: string | null;
  updatedAt?: string | null;
  userName?: string;
  user?: {
    _id: string;
    name: string;
  } | null;
  [key: string]: any;
}[];
export type GetProjectByProjectIdChecklistAndChecklistIdLogsRowIdApiArg = {
  projectId: string;
  checklistId: string;
  rowId: string;
};
export type PostProjectByProjectIdChecklistAddApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  id?: number;
  project:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  name: string;
  aboutText?: string | null;
  templateDescription: string;
  templateType: "MC" | "PROJECT" | "";
  isTemplate: boolean;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  tags: string[];
  checkTypes: {
    check1: {
      active: boolean;
      name: string;
    };
    check2: {
      active: boolean;
      name: string;
    };
    check3: {
      active: boolean;
      name: string;
    };
    check4?: {
      active: boolean;
      name: string;
    };
    check5?: {
      active: boolean;
      name: string;
    };
    check6?: {
      active: boolean;
      name: string;
    };
    check7?: {
      active: boolean;
      name: string;
    };
    check8?: {
      active: boolean;
      name: string;
    };
    check9?: {
      active: boolean;
      name: string;
    };
    check10?: {
      active: boolean;
      name: string;
    };
    check11?: {
      active: boolean;
      name: string;
    };
    check12?: {
      active: boolean;
      name: string;
    };
    check13?: {
      active: boolean;
      name: string;
    };
    check14?: {
      active: boolean;
      name: string;
    };
    check15?: {
      active: boolean;
      name: string;
    };
  };
  progress?: {
    accepted: number;
    rejected: number;
  };
  pns?: string | null;
  dueDate?: string | null;
  stampSettings?: {
    yes: {
      text: string;
      color: string;
      icon: string;
    };
    no: {
      text: string;
      color: string;
      icon: string;
    };
    na: {
      text: string;
      color: string;
      icon: string;
    };
    ir: {
      text: string;
      color: string;
      icon: string;
    };
    uav: {
      text: string;
      color: string;
      icon: string;
    };
    [key: string]: any;
  };
  templateCategory?: string | null;
  includeIrOnDefaultRoles: boolean;
  includeUavOnDefaultRoles: boolean;
  phase?: string | null;
  discipline?: string | null;
  activity?: string | null;
  itemTagsActive?: boolean;
  itemTags?: string[];
  activeItemTags?: string[];
  revisionDate?: string | null;
  revisionNr?: string | null;
  activeItemTagChangedDate?: string | null;
  doksam?: {
    docId?: string | null;
    subTaskNo?: string | null;
    reviewId?: string | null;
    check1UserUpn?: string | null;
    check2UserUpn?: string | null;
    dkApproval?: {
      userId?: string;
      name: string | null;
      upn: string | null;
      approvedAt?: string | null;
    };
    [key: string]: any;
  };
  documentCategoryCode: string;
  documentCategoryCode2: string;
  disciplineCode: string;
  subDiscipline: string;
  competenceNetwork: string;
  lastUpdatedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  createdBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  assignedTo?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  admin?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  activeItemTagChangedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  disciplineLeader?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  documentManagers?: {
    preparedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    checkedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    approvedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    [key: string]: any;
  };
  generatedFromTemplate?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  [key: string]: any;
};
export type PostProjectByProjectIdChecklistAddApiArg = {
  projectId: string;
  body: {
    checklistTemplateId: (string | any) | "0";
    name: string;
    pns?: string | null;
    checkTypes: {
      check1: {
        active: boolean;
        name: string;
      };
      check2: {
        active: boolean;
        name: string;
      };
      check3: {
        active: boolean;
        name: string;
      };
      check4?: {
        active: boolean;
        name: string;
      };
      check5?: {
        active: boolean;
        name: string;
      };
      check6?: {
        active: boolean;
        name: string;
      };
      check7?: {
        active: boolean;
        name: string;
      };
      check8?: {
        active: boolean;
        name: string;
      };
      check9?: {
        active: boolean;
        name: string;
      };
      check10?: {
        active: boolean;
        name: string;
      };
      check11?: {
        active: boolean;
        name: string;
      };
      check12?: {
        active: boolean;
        name: string;
      };
      check13?: {
        active: boolean;
        name: string;
      };
      check14?: {
        active: boolean;
        name: string;
      };
      check15?: {
        active: boolean;
        name: string;
      };
    };
    status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
    isTemplate: boolean;
    templateType: "MC" | "PROJECT" | "";
    doksam?: {
      docId: string;
      subTaskNo?: string | null;
      preAssignUsersToChecks: {
        check1UserUpn?: string;
        check2UserUpn?: string;
      };
      dkApproval?: {
        userId?: string | any;
        name?: string | null;
        upn?: string | null;
        approvedAt?: string | null;
      };
    };
  };
};
export type PostProjectByProjectIdChecklistImportExcelApiResponse =
  | /** status 200 Successful response */ {
      _id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
      id?: number;
      project:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      name: string;
      aboutText?: string | null;
      templateDescription: string;
      templateType: "MC" | "PROJECT" | "";
      isTemplate: boolean;
      status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
      tags: string[];
      checkTypes: {
        check1: {
          active: boolean;
          name: string;
        };
        check2: {
          active: boolean;
          name: string;
        };
        check3: {
          active: boolean;
          name: string;
        };
        check4?: {
          active: boolean;
          name: string;
        };
        check5?: {
          active: boolean;
          name: string;
        };
        check6?: {
          active: boolean;
          name: string;
        };
        check7?: {
          active: boolean;
          name: string;
        };
        check8?: {
          active: boolean;
          name: string;
        };
        check9?: {
          active: boolean;
          name: string;
        };
        check10?: {
          active: boolean;
          name: string;
        };
        check11?: {
          active: boolean;
          name: string;
        };
        check12?: {
          active: boolean;
          name: string;
        };
        check13?: {
          active: boolean;
          name: string;
        };
        check14?: {
          active: boolean;
          name: string;
        };
        check15?: {
          active: boolean;
          name: string;
        };
      };
      progress?: {
        accepted: number;
        rejected: number;
      };
      pns?: string | null;
      dueDate?: string | null;
      stampSettings?: {
        yes: {
          text: string;
          color: string;
          icon: string;
        };
        no: {
          text: string;
          color: string;
          icon: string;
        };
        na: {
          text: string;
          color: string;
          icon: string;
        };
        ir: {
          text: string;
          color: string;
          icon: string;
        };
        uav: {
          text: string;
          color: string;
          icon: string;
        };
        [key: string]: any;
      };
      templateCategory?: string | null;
      includeIrOnDefaultRoles: boolean;
      includeUavOnDefaultRoles: boolean;
      phase?: string | null;
      discipline?: string | null;
      activity?: string | null;
      itemTagsActive?: boolean;
      itemTags?: string[];
      activeItemTags?: string[];
      revisionDate?: string | null;
      revisionNr?: string | null;
      activeItemTagChangedDate?: string | null;
      doksam?: {
        docId?: string | null;
        subTaskNo?: string | null;
        reviewId?: string | null;
        check1UserUpn?: string | null;
        check2UserUpn?: string | null;
        dkApproval?: {
          userId?: string;
          name: string | null;
          upn: string | null;
          approvedAt?: string | null;
        };
        [key: string]: any;
      };
      documentCategoryCode: string;
      documentCategoryCode2: string;
      disciplineCode: string;
      subDiscipline: string;
      competenceNetwork: string;
      lastUpdatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      createdBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      admin?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      activeItemTagChangedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      disciplineLeader?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      documentManagers?: {
        preparedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        checkedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        approvedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      generatedFromTemplate?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    }
  | null;
export type PostProjectByProjectIdChecklistImportExcelApiArg = {
  projectId: string;
  body: {
    name: string;
    pns?: string;
    checkTypes: {
      check1: {
        active?: boolean;
        name: string;
      };
      check2: {
        active?: boolean;
        name: string;
      };
      check3: {
        active?: boolean;
        name: string;
      };
    };
    checklistImportRows: (string | (string | null) | (string | null))[][];
    status: string;
    templateType?: "MC" | "PROJECT" | "";
  };
};
export type PostProjectByProjectIdChecklistAndChecklistIdCategoryApiResponse = /** status 200 Successful response */ {
  _id: string;
  project?:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  title: string;
  collapsed?: boolean;
  dueDate?: string | null;
  checklist:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  categoryId: number;
  checks?: {
    check1?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check2?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check3?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check4?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check5?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check6?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check7?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check8?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check9?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check10?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check11?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check12?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check13?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check14?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    check15?: {
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
  };
  [key: string]: any;
};
export type PostProjectByProjectIdChecklistAndChecklistIdCategoryApiArg = {
  projectId: string;
  checklistId: string;
  body: {
    categoryCount: number;
  };
};
export type PostProjectByProjectIdChecklistAndChecklistIdItemApiResponse = /** status 200 Successful response */ {
  _id: string;
  project?:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  checklist:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  inactive: {
    isChecked: boolean;
    updatedDate?: string | null;
    updatedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    [key: string]: any;
  };
  title: string;
  reference?: string | null;
  comment?: string | null;
  category:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  itemId: number;
  checks: {
    check1: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check2: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check3: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check4: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check5: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check6: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check7: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check8: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check9: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check10: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check11: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check12: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check13: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check14: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check15: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
  };
  comments?: any[];
  itemTags?: string[];
  connectedIssues?: any[];
  [key: string]: any;
};
export type PostProjectByProjectIdChecklistAndChecklistIdItemApiArg = {
  projectId: string;
  checklistId: string;
  body: {
    categoryId: string;
    itemCount: number;
  };
};
export type PutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdInactiveApiResponse =
  /** status 200 Successful response */ {
    checklist: {
      _id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
      id?: number;
      project:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      name: string;
      aboutText?: string | null;
      templateDescription: string;
      templateType: "MC" | "PROJECT" | "";
      isTemplate: boolean;
      status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
      tags: string[];
      checkTypes: {
        check1: {
          active: boolean;
          name: string;
        };
        check2: {
          active: boolean;
          name: string;
        };
        check3: {
          active: boolean;
          name: string;
        };
        check4?: {
          active: boolean;
          name: string;
        };
        check5?: {
          active: boolean;
          name: string;
        };
        check6?: {
          active: boolean;
          name: string;
        };
        check7?: {
          active: boolean;
          name: string;
        };
        check8?: {
          active: boolean;
          name: string;
        };
        check9?: {
          active: boolean;
          name: string;
        };
        check10?: {
          active: boolean;
          name: string;
        };
        check11?: {
          active: boolean;
          name: string;
        };
        check12?: {
          active: boolean;
          name: string;
        };
        check13?: {
          active: boolean;
          name: string;
        };
        check14?: {
          active: boolean;
          name: string;
        };
        check15?: {
          active: boolean;
          name: string;
        };
      };
      progress?: {
        accepted: number;
        rejected: number;
      };
      pns?: string | null;
      dueDate?: string | null;
      stampSettings?: {
        yes: {
          text: string;
          color: string;
          icon: string;
        };
        no: {
          text: string;
          color: string;
          icon: string;
        };
        na: {
          text: string;
          color: string;
          icon: string;
        };
        ir: {
          text: string;
          color: string;
          icon: string;
        };
        uav: {
          text: string;
          color: string;
          icon: string;
        };
        [key: string]: any;
      };
      templateCategory?: string | null;
      includeIrOnDefaultRoles: boolean;
      includeUavOnDefaultRoles: boolean;
      phase?: string | null;
      discipline?: string | null;
      activity?: string | null;
      itemTagsActive?: boolean;
      itemTags?: string[];
      activeItemTags?: string[];
      revisionDate?: string | null;
      revisionNr?: string | null;
      activeItemTagChangedDate?: string | null;
      doksam?: {
        docId?: string | null;
        subTaskNo?: string | null;
        reviewId?: string | null;
        check1UserUpn?: string | null;
        check2UserUpn?: string | null;
        dkApproval?: {
          userId?: string;
          name: string | null;
          upn: string | null;
          approvedAt?: string | null;
        };
        [key: string]: any;
      };
      documentCategoryCode: string;
      documentCategoryCode2: string;
      disciplineCode: string;
      subDiscipline: string;
      competenceNetwork: string;
      lastUpdatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      createdBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      admin?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      activeItemTagChangedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      disciplineLeader?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      documentManagers?: {
        preparedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        checkedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        approvedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      generatedFromTemplate?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    } | null;
    categories: {
      _id: string;
      project?:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      title: string;
      collapsed?: boolean;
      dueDate?: string | null;
      checklist:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      categoryId: number;
      checks?: {
        check1?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check2?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check3?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check4?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check5?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check6?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check7?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check8?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check9?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check10?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check11?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check12?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check13?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check14?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check15?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
      };
      [key: string]: any;
    }[];
    items: {
      _id: string;
      project?:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      checklist:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      inactive: {
        isChecked: boolean;
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      title: string;
      reference?: string | null;
      comment?: string | null;
      category:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      itemId: number;
      checks: {
        check1: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check2: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check3: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check4: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check5: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check6: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check7: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check8: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check9: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check10: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check11: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check12: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check13: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check14: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check15: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
      };
      comments?: any[];
      itemTags?: string[];
      connectedIssues?: any[];
      [key: string]: any;
    }[];
  };
export type PutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdInactiveApiArg = {
  projectId: string;
  checklistId: string;
  categoryId: string;
  body: {
    inactive: boolean;
  };
};
export type DeleteProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdApiResponse =
  /** status 200 Successful response */ any;
export type DeleteProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdApiArg = {
  projectId: string;
  checklistId: string;
  categoryId: string;
};
export type PutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    project?:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    title: string;
    collapsed?: boolean;
    dueDate?: string | null;
    checklist:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    categoryId: number;
    checks?: {
      check1?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check2?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check3?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check4?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check5?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check6?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check7?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check8?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check9?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check10?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check11?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check12?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check13?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check14?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      check15?: {
        assignedTo?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
    };
    [key: string]: any;
  };
export type PutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdApiArg = {
  projectId: string;
  checklistId: string;
  categoryId: string;
  body: {
    attribute: string;
    newValue?: any;
    oldValue?: any;
  };
};
export type DeleteProjectByProjectIdChecklistAndChecklistIdItemItemIdApiResponse =
  /** status 200 Successful response */ any;
export type DeleteProjectByProjectIdChecklistAndChecklistIdItemItemIdApiArg = {
  projectId: string;
  checklistId: string;
  itemId: string;
};
export type PutProjectByProjectIdChecklistAndChecklistIdItemItemIdApiResponse = /** status 200 Successful response */ {
  _id: string;
  project?:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  checklist:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  inactive: {
    isChecked: boolean;
    updatedDate?: string | null;
    updatedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    [key: string]: any;
  };
  title: string;
  reference?: string | null;
  comment?: string | null;
  category:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  itemId: number;
  checks: {
    check1: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check2: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check3: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check4: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check5: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check6: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check7: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check8: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check9: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check10: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check11: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check12: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check13: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check14: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
    check15: {
      status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      comment?: {
        createdBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        text: string;
        createdDate?: string | null;
        [key: string]: any;
      } | null;
      [key: string]: any;
    };
  };
  comments?: any[];
  itemTags?: string[];
  connectedIssues?: any[];
  progress: {
    accepted: number;
    rejected: number;
  };
  [key: string]: any;
};
export type PutProjectByProjectIdChecklistAndChecklistIdItemItemIdApiArg = {
  projectId: string;
  checklistId: string;
  itemId: string;
  body: {
    path: string;
    newValue?: any;
    oldValue?: any;
  };
};
export type PutProjectByProjectIdChecklistAndChecklistIdApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  id?: number;
  project:
    | string
    | {
        _id: string;
        [key: string]: any;
      };
  name: string;
  aboutText?: string | null;
  templateDescription: string;
  templateType: "MC" | "PROJECT" | "";
  isTemplate: boolean;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  tags: string[];
  checkTypes: {
    check1: {
      active: boolean;
      name: string;
    };
    check2: {
      active: boolean;
      name: string;
    };
    check3: {
      active: boolean;
      name: string;
    };
    check4?: {
      active: boolean;
      name: string;
    };
    check5?: {
      active: boolean;
      name: string;
    };
    check6?: {
      active: boolean;
      name: string;
    };
    check7?: {
      active: boolean;
      name: string;
    };
    check8?: {
      active: boolean;
      name: string;
    };
    check9?: {
      active: boolean;
      name: string;
    };
    check10?: {
      active: boolean;
      name: string;
    };
    check11?: {
      active: boolean;
      name: string;
    };
    check12?: {
      active: boolean;
      name: string;
    };
    check13?: {
      active: boolean;
      name: string;
    };
    check14?: {
      active: boolean;
      name: string;
    };
    check15?: {
      active: boolean;
      name: string;
    };
  };
  progress?: {
    accepted: number;
    rejected: number;
  };
  pns?: string | null;
  dueDate?: string | null;
  stampSettings?: {
    yes: {
      text: string;
      color: string;
      icon: string;
    };
    no: {
      text: string;
      color: string;
      icon: string;
    };
    na: {
      text: string;
      color: string;
      icon: string;
    };
    ir: {
      text: string;
      color: string;
      icon: string;
    };
    uav: {
      text: string;
      color: string;
      icon: string;
    };
    [key: string]: any;
  };
  templateCategory?: string | null;
  includeIrOnDefaultRoles: boolean;
  includeUavOnDefaultRoles: boolean;
  phase?: string | null;
  discipline?: string | null;
  activity?: string | null;
  itemTagsActive?: boolean;
  itemTags?: string[];
  activeItemTags?: string[];
  revisionDate?: string | null;
  revisionNr?: string | null;
  activeItemTagChangedDate?: string | null;
  doksam?: {
    docId?: string | null;
    subTaskNo?: string | null;
    reviewId?: string | null;
    check1UserUpn?: string | null;
    check2UserUpn?: string | null;
    dkApproval?: {
      userId?: string;
      name: string | null;
      upn: string | null;
      approvedAt?: string | null;
    };
    [key: string]: any;
  };
  documentCategoryCode: string;
  documentCategoryCode2: string;
  disciplineCode: string;
  subDiscipline: string;
  competenceNetwork: string;
  lastUpdatedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  createdBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  assignedTo?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  admin?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  activeItemTagChangedBy?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  disciplineLeader?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  documentManagers?: {
    preparedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    checkedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    approvedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    [key: string]: any;
  };
  generatedFromTemplate?:
    | (
        | string
        | {
            _id: string;
            name: string;
            [key: string]: any;
          }
      )
    | null;
  [key: string]: any;
};
export type PutProjectByProjectIdChecklistAndChecklistIdApiArg = {
  projectId: string;
  checklistId: string;
  body: {
    attribute: string;
    newValue?: any;
    oldValue?: any;
  };
};
export type GetProjectByProjectIdChecklistChecklistitemAndChecklistitemidApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    project?:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    checklist:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    inactive: {
      isChecked: boolean;
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    title: string;
    reference?: string | null;
    comment?: string | null;
    category:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    itemId: number;
    checks: {
      check1: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check2: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check3: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check4: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check5: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check6: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check7: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check8: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check9: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check10: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check11: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check12: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check13: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check14: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check15: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
    };
    comments?: any[];
    itemTags?: string[];
    connectedIssues?: any[];
    [key: string]: any;
  };
export type GetProjectByProjectIdChecklistChecklistitemAndChecklistitemidApiArg = {
  projectId: string;
  checklistitemid: string;
};
export type GetProjectByProjectIdChecklistTagsApiResponse = /** status 200 Successful response */ {
  _id: string;
  [key: string]: any;
}[];
export type GetProjectByProjectIdChecklistTagsApiArg = {
  projectId: string;
};
export type PutProjectByProjectIdChecklistIssueConnectDisconnectIssueApiResponse =
  /** status 200 Successful response */ "OK";
export type PutProjectByProjectIdChecklistIssueConnectDisconnectIssueApiArg = {
  projectId: string;
  body: {
    checklistItemId: string | any;
    issueId: string | any;
    connectOrDisconnect: "CONNECT" | "DISCONNECT";
  };
};
export type PutProjectByProjectIdChecklistAndChecklistIdUpdateChecklistIdsApiResponse =
  /** status 200 Successful response */ {
    checklist: {
      _id: string;
      createdAt?: string | null;
      updatedAt?: string | null;
      id?: number;
      project:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      name: string;
      aboutText?: string | null;
      templateDescription: string;
      templateType: "MC" | "PROJECT" | "";
      isTemplate: boolean;
      status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
      tags: string[];
      checkTypes: {
        check1: {
          active: boolean;
          name: string;
        };
        check2: {
          active: boolean;
          name: string;
        };
        check3: {
          active: boolean;
          name: string;
        };
        check4?: {
          active: boolean;
          name: string;
        };
        check5?: {
          active: boolean;
          name: string;
        };
        check6?: {
          active: boolean;
          name: string;
        };
        check7?: {
          active: boolean;
          name: string;
        };
        check8?: {
          active: boolean;
          name: string;
        };
        check9?: {
          active: boolean;
          name: string;
        };
        check10?: {
          active: boolean;
          name: string;
        };
        check11?: {
          active: boolean;
          name: string;
        };
        check12?: {
          active: boolean;
          name: string;
        };
        check13?: {
          active: boolean;
          name: string;
        };
        check14?: {
          active: boolean;
          name: string;
        };
        check15?: {
          active: boolean;
          name: string;
        };
      };
      progress?: {
        accepted: number;
        rejected: number;
      };
      pns?: string | null;
      dueDate?: string | null;
      stampSettings?: {
        yes: {
          text: string;
          color: string;
          icon: string;
        };
        no: {
          text: string;
          color: string;
          icon: string;
        };
        na: {
          text: string;
          color: string;
          icon: string;
        };
        ir: {
          text: string;
          color: string;
          icon: string;
        };
        uav: {
          text: string;
          color: string;
          icon: string;
        };
        [key: string]: any;
      };
      templateCategory?: string | null;
      includeIrOnDefaultRoles: boolean;
      includeUavOnDefaultRoles: boolean;
      phase?: string | null;
      discipline?: string | null;
      activity?: string | null;
      itemTagsActive?: boolean;
      itemTags?: string[];
      activeItemTags?: string[];
      revisionDate?: string | null;
      revisionNr?: string | null;
      activeItemTagChangedDate?: string | null;
      doksam?: {
        docId?: string | null;
        subTaskNo?: string | null;
        reviewId?: string | null;
        check1UserUpn?: string | null;
        check2UserUpn?: string | null;
        dkApproval?: {
          userId?: string;
          name: string | null;
          upn: string | null;
          approvedAt?: string | null;
        };
        [key: string]: any;
      };
      documentCategoryCode: string;
      documentCategoryCode2: string;
      disciplineCode: string;
      subDiscipline: string;
      competenceNetwork: string;
      lastUpdatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      createdBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      assignedTo?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      admin?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      activeItemTagChangedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      disciplineLeader?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      documentManagers?: {
        preparedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        checkedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        approvedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      generatedFromTemplate?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    } | null;
    categories: {
      _id: string;
      project?:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      title: string;
      collapsed?: boolean;
      dueDate?: string | null;
      checklist:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      categoryId: number;
      checks?: {
        check1?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check2?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check3?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check4?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check5?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check6?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check7?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check8?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check9?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check10?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check11?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check12?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check13?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check14?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
        check15?: {
          assignedTo?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          [key: string]: any;
        };
      };
      [key: string]: any;
    }[];
    items: {
      _id: string;
      project?:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      checklist:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      inactive: {
        isChecked: boolean;
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        [key: string]: any;
      };
      title: string;
      reference?: string | null;
      comment?: string | null;
      category:
        | string
        | {
            _id: string;
            [key: string]: any;
          };
      itemId: number;
      checks: {
        check1: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check2: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check3: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check4: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check5: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check6: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check7: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check8: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check9: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check10: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check11: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check12: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check13: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check14: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
        check15: {
          status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
          updatedDate?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          comment?: {
            createdBy?:
              | (
                  | string
                  | {
                      _id: string;
                      name: string;
                      [key: string]: any;
                    }
                )
              | null;
            text: string;
            createdDate?: string | null;
            [key: string]: any;
          } | null;
          [key: string]: any;
        };
      };
      comments?: any[];
      itemTags?: string[];
      connectedIssues?: any[];
      [key: string]: any;
    }[];
  };
export type PutProjectByProjectIdChecklistAndChecklistIdUpdateChecklistIdsApiArg = {
  projectId: string;
  checklistId: string;
};
export type PostProjectByProjectIdChecklistTemplatesChecklistsFromTemplateGetApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    createdAt?: string | null;
    updatedAt?: string | null;
    id?: number;
    project:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    name: string;
    aboutText?: string | null;
    templateDescription: string;
    templateType: "MC" | "PROJECT" | "";
    isTemplate: boolean;
    status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
    tags: string[];
    checkTypes: {
      check1: {
        active: boolean;
        name: string;
      };
      check2: {
        active: boolean;
        name: string;
      };
      check3: {
        active: boolean;
        name: string;
      };
      check4?: {
        active: boolean;
        name: string;
      };
      check5?: {
        active: boolean;
        name: string;
      };
      check6?: {
        active: boolean;
        name: string;
      };
      check7?: {
        active: boolean;
        name: string;
      };
      check8?: {
        active: boolean;
        name: string;
      };
      check9?: {
        active: boolean;
        name: string;
      };
      check10?: {
        active: boolean;
        name: string;
      };
      check11?: {
        active: boolean;
        name: string;
      };
      check12?: {
        active: boolean;
        name: string;
      };
      check13?: {
        active: boolean;
        name: string;
      };
      check14?: {
        active: boolean;
        name: string;
      };
      check15?: {
        active: boolean;
        name: string;
      };
    };
    progress?: {
      accepted: number;
      rejected: number;
    };
    pns?: string | null;
    dueDate?: string | null;
    stampSettings?: {
      yes: {
        text: string;
        color: string;
        icon: string;
      };
      no: {
        text: string;
        color: string;
        icon: string;
      };
      na: {
        text: string;
        color: string;
        icon: string;
      };
      ir: {
        text: string;
        color: string;
        icon: string;
      };
      uav: {
        text: string;
        color: string;
        icon: string;
      };
      [key: string]: any;
    };
    templateCategory?: string | null;
    includeIrOnDefaultRoles: boolean;
    includeUavOnDefaultRoles: boolean;
    phase?: string | null;
    discipline?: string | null;
    activity?: string | null;
    itemTagsActive?: boolean;
    itemTags?: string[];
    activeItemTags?: string[];
    revisionDate?: string | null;
    revisionNr?: string | null;
    activeItemTagChangedDate?: string | null;
    doksam?: {
      docId?: string | null;
      subTaskNo?: string | null;
      reviewId?: string | null;
      check1UserUpn?: string | null;
      check2UserUpn?: string | null;
      dkApproval?: {
        userId?: string;
        name: string | null;
        upn: string | null;
        approvedAt?: string | null;
      };
      [key: string]: any;
    };
    documentCategoryCode: string;
    documentCategoryCode2: string;
    disciplineCode: string;
    subDiscipline: string;
    competenceNetwork: string;
    lastUpdatedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    createdBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    assignedTo?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    admin?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    activeItemTagChangedBy?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    disciplineLeader?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    documentManagers?: {
      preparedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      checkedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      approvedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    generatedFromTemplate?:
      | (
          | string
          | {
              _id: string;
              name: string;
              [key: string]: any;
            }
        )
      | null;
    [key: string]: any;
  }[];
export type PostProjectByProjectIdChecklistTemplatesChecklistsFromTemplateGetApiArg = {
  projectId: string;
  body: {
    templateId: number;
  };
};
export type GetChecklistMcTemplatesApiResponse = /** status 200 Successful response */ {
  id: number;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  name: string;
  disciplineCode: string;
  templateDescription: string;
  documentCategoryCode2: string;
  subDiscipline: string;
  competenceNetwork: string;
}[];
export type GetChecklistMcTemplatesApiArg = {
  showInDevelopment?: boolean;
};
export type PostChecklistMcTemplatesApiResponse = /** status 200 Successful response */ {
  checklistId: number;
  status: "IN_DEVELOPMENT";
  name: string;
  items: {
    id: string;
    title: string;
    reference: string;
    tags: string;
  }[];
  excel: {
    filename: string;
    contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    base64: string;
  };
};
export type PostChecklistMcTemplatesApiArg = {
  body: {
    title: string;
  };
};
export type GetChecklistByChecklistIdExportApiResponse = /** status 200 Successful response */ {
  id: number;
  name: string;
  disciplineCode?: string;
  templateDescription?: string;
  documentCategoryCode2?: string;
  subDiscipline?: string;
  competenceNetwork?: string;
  documentManagers?: {
    preparedBy?: string;
    checkedBy?: string;
    approvedBy?: string;
  };
  admin?: string;
  disciplineLeader?: string;
  items: {
    id: string;
    title: string;
    reference: string;
    tags: string;
  }[];
  excel?: {
    filename: string;
    contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    base64: string;
  };
};
export type GetChecklistByChecklistIdExportApiArg = {
  checklistId: number;
  excel?: boolean;
};
export type PostChecklistValidateExcelApiResponse =
  | /** status 200 Successful response */ {
      isValid: boolean | null;
      value: string | number;
      col: number;
      row: number;
      reference?: string;
      itemTags?: string;
    }[][]
  | {
      status: "error";
      message: string;
      errors: {
        row: number;
        col: number;
        value: string | number;
        message: string;
      }[];
    };
export type PostChecklistValidateExcelApiArg = {
  body: {
    file: string;
  };
};
export type PostChecklistMcTemplatesPublishApiResponse =
  | /** status 200 Successful response */ {
      status: "error";
      message: string;
      errors: {
        row: number;
        col: number;
        value: string | number;
        message: string;
      }[];
    }
  | {
      status: "success";
      message: string;
      data?: {
        isValid: boolean | null;
        value: string | number;
        col: number;
        row: number;
        reference?: string;
        itemTags?: string;
      }[][];
    }
  | {
      status: "dry-run";
      message: string;
      data?: {
        isValid: boolean | null;
        value: string | number;
        col: number;
        row: number;
        reference?: string;
        itemTags?: string;
      }[][];
    };
export type PostChecklistMcTemplatesPublishApiArg = {
  body: {
    checklistNrId: number;
    file: string;
    dryRun?: boolean;
    metadata: {
      name: string;
      status: "ACTIVE" | "IN_DEVELOPMENT" | "REMOVED";
      disciplineCode?: string | null;
      templateDescription?: string | null;
      subDiscipline?: string | null;
      competenceNetwork?: string | null;
      documentManagers?: {
        preparedBy?: string | null;
        checkedBy?: string | null;
        approvedBy?: string | null;
      };
      disciplineLeader?: string | null;
    };
  };
};
export type GetChecklistLogsApiResponse = /** status 200 Successful response */ {
  _id: string;
  project: string;
  board: string;
  rowId?: {
    _id: string;
    itemId: number;
    title: string;
  } | null;
  column: string;
  oldValue?: string | null;
  newValue?: string | null;
  user: {
    _id: string;
    name: string;
  };
  createdAt: string;
  updatedAt?: string | null;
}[];
export type GetChecklistLogsApiArg = {
  projectNo: number;
  checklistId: number;
};
export type GetChecklistProjectTemplatesApiResponse = /** status 200 Successful response */ {
  id: number;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  name: string;
  disciplineCode: string;
  templateDescription: string;
  documentCategoryCode2: string;
  subDiscipline: string;
  competenceNetwork: string;
}[];
export type GetChecklistProjectTemplatesApiArg = {
  projectNo: string;
};
export type PostChecklistMcTemplatesUploadDocxApiResponse = /** status 200 Successful response */ {
  collection: "checklistmctemplates";
  blobName: string;
  etag?: string;
};
export type PostChecklistMcTemplatesUploadDocxApiArg = {
  body: {
    file: {
      filename: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
      contentType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      base64: string;
    };
  };
};
export type GetChecklistMcTemplatesDocxDownloadApiResponse = /** status 200 Successful response */ {
  collection: "checklistmctemplates";
  filename: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
  contentType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  base64: string;
  sizeBytes: number;
  etag: string | null;
  lastModifiedIso: string | null;
};
export type GetChecklistMcTemplatesDocxDownloadApiArg = {
  filename: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
};
export type GetChecklistMcTemplatesDocxApiResponse = /** status 200 Successful response */ {
  collection: "checklistmctemplates";
  templates: {
    filename: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
    exists: boolean;
    contentType: string | null;
    sizeBytes: number | null;
    lastModifiedIso: string | null;
    etag: string | null;
  }[];
};
export type GetChecklistMcTemplatesDocxApiArg = void;
export type PostChecklistIntegrationGenerateApiResponse = /** status 200 Successful response */ {
  filename: string;
  mime: string;
  base64: string;
};
export type PostChecklistIntegrationGenerateApiArg = {
  body: {
    checklistId: number;
    signedBy: string;
  };
};
export type GetChecklistsByReviewByReviewIdApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  checklistNrId?: number;
  doksam?: {
    dkApproval?: {
      userId?: string;
      name: string | null;
      upn: string | null;
      approvedAt?: string | null;
    };
  };
  [key: string]: any;
}[];
export type GetChecklistsByReviewByReviewIdApiArg = {
  reviewId: string;
};
export type PutProjectByProjectIdChecklistItemAndChecklistItemIdCommentCommentIdReactionApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    project?:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    checklist:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    inactive: {
      isChecked: boolean;
      updatedDate?: string | null;
      updatedBy?:
        | (
            | string
            | {
                _id: string;
                name: string;
                [key: string]: any;
              }
          )
        | null;
      [key: string]: any;
    };
    title: string;
    reference?: string | null;
    comment?: string | null;
    category:
      | string
      | {
          _id: string;
          [key: string]: any;
        };
    itemId: number;
    checks: {
      check1: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check2: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check3: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check4: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check5: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check6: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check7: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check8: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check9: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check10: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check11: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check12: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check13: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check14: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
      check15: {
        status: "NO" | "N/A" | "YES" | "IR" | "DISABLED" | "UAV";
        updatedDate?: string | null;
        updatedBy?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                  [key: string]: any;
                }
            )
          | null;
        comment?: {
          createdBy?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                    [key: string]: any;
                  }
              )
            | null;
          text: string;
          createdDate?: string | null;
          [key: string]: any;
        } | null;
        [key: string]: any;
      };
    };
    comments?: any[];
    itemTags?: string[];
    connectedIssues?: any[];
    [key: string]: any;
  };
export type PutProjectByProjectIdChecklistItemAndChecklistItemIdCommentCommentIdReactionApiArg = {
  projectId: string;
  checklistItemId: string;
  commentId: string;
  body: {
    emoji: string;
  };
};
export type PutChecklistsByChecklistIdDkApprovalToggleApiResponse = /** status 200 Successful response */ {
  checklistId: string;
  approvedAt: string | null;
};
export type PutChecklistsByChecklistIdDkApprovalToggleApiArg = {
  checklistId: string;
  body: {
    isApproved: boolean;
  };
};
export type PostProjectByProjectIdIssuesCreateApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PostProjectByProjectIdIssuesCreateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    title: string;
    description?: string;
    connectedBimSpaces?: {
      spaceDbId?: any;
      globalId?: string;
      roomNumber: string;
      roomName?: string;
      floor?: string;
      building?: string;
      ifcFile?: string;
      pns?: string | null;
    }[];
  };
};
export type GetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesApiResponse = /** status 200 Successful response */ {
  children: {
    _id: string;
    id: number;
    title: string | null;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    issueBoard?: {
      _id: string;
      name: string;
    } | null;
  }[];
  parents: {
    _id: string;
    id: number;
    title: string | null;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    issueBoard?: {
      _id: string;
      name: string;
    } | null;
  }[];
};
export type GetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesApiArg = {
  projectId: string;
  _id: string;
};
export type PutProjectByProjectIdIssuesUpdateGantActivityApiResponse = /** status 200 Successful response */ {
  updatedIssue: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    descriptionRichText: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
      pns?: string | null;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    formulaCounters: {
      [key: string]: {
        value: number;
        updatedBy?: {
          _id: string;
          name: string;
        } | null;
        updatedDate?: string | null;
      };
    };
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
      reactions?: {
        user: {
          _id: string;
          name: string;
        };
        date: string;
        emoji: string;
      }[];
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
};
export type PutProjectByProjectIdIssuesUpdateGantActivityApiArg = {
  projectId: string;
  body: {
    issueId: string;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color?: string;
    }[];
  };
};
export type PutIssueConnectApiResponse = /** status 200 Successful response */ {
  source: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    descriptionRichText: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
      pns?: string | null;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    formulaCounters: {
      [key: string]: {
        value: number;
        updatedBy?: {
          _id: string;
          name: string;
        } | null;
        updatedDate?: string | null;
      };
    };
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
      reactions?: {
        user: {
          _id: string;
          name: string;
        };
        date: string;
        emoji: string;
      }[];
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
  target: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    descriptionRichText: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
      pns?: string | null;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    formulaCounters: {
      [key: string]: {
        value: number;
        updatedBy?: {
          _id: string;
          name: string;
        } | null;
        updatedDate?: string | null;
      };
    };
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
      reactions?: {
        user: {
          _id: string;
          name: string;
        };
        date: string;
        emoji: string;
      }[];
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
};
export type PutIssueConnectApiArg = {
  body: {
    projectId: string | any;
    issueBoardId: string | any;
    sourceIssueId: string | any;
    targetIssueId: string | any;
    action: "CONNECT" | "DISCONNECT";
  };
};
export type GetIssueByUserApiResponse = /** status 200 Successful response */ {
  _id: string;
  id: number;
  title: string | null;
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  issueBoard: {
    _id: string;
    name: string;
  };
  project: {
    _id: string;
    maconomy: {
      name?: string | null;
    };
  };
}[];
export type GetIssueByUserApiArg = {
  relation: "assignedTo" | "owner" | "itemMembers";
  maxAgeYears?: number;
  projectId?: string;
};
export type PutProjectByProjectIdIssuesKanbanreorderApiResponse = /** status 200 Successful response */ {
  moved: {
    id: string;
    column: string;
    index: number;
  };
  changed: {
    id: string;
    index: number;
  }[];
  version: string;
  updatedIssue: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    descriptionRichText: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
      pns?: string | null;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    formulaCounters: {
      [key: string]: {
        value: number;
        updatedBy?: {
          _id: string;
          name: string;
        } | null;
        updatedDate?: string | null;
      };
    };
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
      reactions?: {
        user: {
          _id: string;
          name: string;
        };
        date: string;
        emoji: string;
      }[];
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
};
export type PutProjectByProjectIdIssuesKanbanreorderApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    issueId: string;
    boardId: string;
    attributeChanged: "status" | "bucket" | "tidsfrist";
    sourceColumn: string;
    targetColumn: string;
    targetPosition?: number;
  };
};
export type GetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    id: number;
    title: string | null;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    issueBoard: {
      _id: string;
      name: string;
    };
  }[];
export type GetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsApiArg = {
  projectId: string;
  issueId: string;
};
export type PostProjectByProjectIdIssuesCopyApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PostProjectByProjectIdIssuesCopyApiArg = {
  projectId: string;
  body: {
    issueId: string;
    includeTasks?: boolean;
  };
};
export type GetProjectByProjectIdIssuesGetSingleApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type GetProjectByProjectIdIssuesGetSingleApiArg = {
  projectId: string;
  issueId: string;
};
export type GetProjectByProjectIdIssuesExternalApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
  uploadedFiles: {
    blobName?: string;
    fileName: string;
    uploadedAt: string;
    uploadedBy: string;
    description?: string;
    size?: number;
    title: string;
  }[];
}[];
export type GetProjectByProjectIdIssuesExternalApiArg = {
  projectId: string;
  issueboardId: string;
  includeTasks?: "true" | "false";
};
export type GetProjectByProjectIdIssuesOnBoardApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
}[];
export type GetProjectByProjectIdIssuesOnBoardApiArg = {
  projectId: string;
  issueboardId: string;
  includeIssues?: "true" | "false";
  includeTasks?: "true" | "false";
  includeAllCompletedIssues?: "true" | "false";
  taskOrIssue?: "ISSUE" | "TASK";
};
export type GetProjectByProjectIdIssuesOnBoardOldCompletedApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
}[];
export type GetProjectByProjectIdIssuesOnBoardOldCompletedApiArg = {
  projectId: string;
  issueboardId: string;
  includeIssues?: "true" | "false";
  includeTasks?: "true" | "false";
  taskOrIssue?: "ISSUE" | "TASK";
};
export type GetProjectByProjectIdIssuesOnBoardOldCompletedCountApiResponse = /** status 200 Successful response */ {
  count: number;
};
export type GetProjectByProjectIdIssuesOnBoardOldCompletedCountApiArg = {
  projectId: string;
  issueboardId: string;
  includeIssues?: "true" | "false";
  includeTasks?: "true" | "false";
  taskOrIssue?: "ISSUE" | "TASK";
};
export type PostProjectByProjectIdIssuesOnBoardsApiResponse = /** status 200 Successful response */ {
  items: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    descriptionRichText: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
      pns?: string | null;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    formulaCounters: {
      [key: string]: {
        value: number;
        updatedBy?: {
          _id: string;
          name: string;
        } | null;
        updatedDate?: string | null;
      };
    };
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
      reactions?: {
        user: {
          _id: string;
          name: string;
        };
        date: string;
        emoji: string;
      }[];
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  }[];
  totalCount?: number;
  boardCounts: {
    issueboardId: string;
    count: number;
  }[];
};
export type PostProjectByProjectIdIssuesOnBoardsApiArg = {
  projectId: string;
  body: {
    issueboardIds: string[];
    includeIssues?: "true" | "false";
    includeTasks?: "true" | "false";
    limit?: number;
    page?: number;
    includeTotalCount?: "true" | "false";
    filter?: {
      taskOrIssue?: "ISSUE" | "TASK";
      freeText?: string;
      issueboardIds?: string[];
      status?: string[];
      assignedToIds?: string[];
    };
    sort?: {
      field: "issueBoard.name" | "id" | "title" | "status" | "assignedTo" | "dates.due" | "pns";
      direction: "asc" | "desc";
    };
  };
};
export type GetProjectByProjectIdIssuesFilesOnBoardApiResponse = /** status 200 Successful response */ {
  [key: string]: {
    blobName?: string;
    fileName: string;
    uploadedAt: string;
    uploadedBy: string;
    description?: string;
    size?: number;
    title: string;
  }[];
};
export type GetProjectByProjectIdIssuesFilesOnBoardApiArg = {
  projectId: string;
  issueboardId: string;
};
export type PutProjectByProjectIdIssueUpdateDatesApiResponse = /** status 200 Successful response */ {
  updatedIssue: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    descriptionRichText: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
      pns?: string | null;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    formulaCounters: {
      [key: string]: {
        value: number;
        updatedBy?: {
          _id: string;
          name: string;
        } | null;
        updatedDate?: string | null;
      };
    };
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
      reactions?: {
        user: {
          _id: string;
          name: string;
        };
        date: string;
        emoji: string;
      }[];
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
};
export type PutProjectByProjectIdIssueUpdateDatesApiArg = {
  projectId: string;
  body: {
    issueId: string;
    dates: {
      plannedStart: string;
      due: string;
    };
  };
};
export type GetProjectByProjectIdIssueFormulaGroupIssuesApiResponse = /** status 200 Successful response */ {
  formulaAttributeKey: string;
  issueId: string;
  issues: {
    _id: string;
    id: number;
    title?: string | null;
    bucket?: string | null;
    status: string;
    createdAt: string;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    formulaCounters?: {
      [key: string]: {
        value: number;
        updatedBy?: {
          _id: string;
          name: string;
        } | null;
        updatedDate?: string | null;
      };
    };
  }[];
};
export type GetProjectByProjectIdIssueFormulaGroupIssuesApiArg = {
  projectId: string;
  issueId: string;
  formulaAttributeKey: string;
};
export type PutProjectByProjectIdIssueUpdateFormulaCounterApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueUpdateFormulaCounterApiArg = {
  projectId: string;
  body: {
    issueId: string;
    formulaAttributeKey: string;
    value: number;
  };
};
export type PostProjectByProjectIdIssuesFileDescriptionApiResponse = /** status 200 Successful response */ {
  ok: boolean;
};
export type PostProjectByProjectIdIssuesFileDescriptionApiArg = {
  projectId: string;
  body: {
    body: {
      fileId: string;
      description: string;
    };
  };
};
export type PutProjectByProjectIdIssueConnectedBimSpacesApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueConnectedBimSpacesApiArg = {
  projectId: string;
  body: {
    issueId: string;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId?: string;
      roomNumber: string;
      roomName?: string;
      floor?: string;
      building?: string;
      ifcFile?: string;
      pns?: string | null;
    }[];
  };
};
export type GetProjectByProjectIdConnectedTasksApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
}[];
export type GetProjectByProjectIdConnectedTasksApiArg = {
  projectId: string;
  issueId: string;
};
export type PostProjectByProjectIdIssueTodosAddApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PostProjectByProjectIdIssueTodosAddApiArg = {
  projectId: string;
  body: {
    issueId: string;
    todoText: string;
  };
};
export type PutProjectByProjectIdIssueTodosUpdateApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueTodosUpdateApiArg = {
  projectId: string;
  body: {
    issueId: string;
    todoId: string;
    text: string;
  };
};
export type PutProjectByProjectIdIssueTodosToggleApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueTodosToggleApiArg = {
  projectId: string;
  body: {
    issueId: string;
    todoId: string;
    isChecked: boolean;
  };
};
export type PutProjectByProjectIdIssueTodosReorderApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueTodosReorderApiArg = {
  projectId: string;
  body: {
    issueId: string;
    todoIds: string[];
  };
};
export type DeleteProjectByProjectIdIssueTodosDeleteApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type DeleteProjectByProjectIdIssueTodosDeleteApiArg = {
  projectId: string;
  issueId: string;
  todoId: string;
};
export type PostProjectByProjectIdIssuesGenerateDocxApiResponse = /** status 200 Successful response */ {
  filename: string;
  mime: string;
  base64: string;
};
export type PostProjectByProjectIdIssuesGenerateDocxApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    templateBlobName: string;
    issueIds: string[];
  };
};
export type PutProjectByProjectIdIssueUpdateSimpleApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueUpdateSimpleApiArg = {
  projectId: string;
  body: {
    _id: string;
    property: {
      title?: string | null;
      description?: string | null;
      descriptionRichText?: string | null;
      status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      priority?: "HIGH" | "MEDIUM" | "LOW";
      referenceUrl?: string;
      bucket?: string;
      typeOfIssue?: string | null;
      pns?: string | null;
      conclusion?: string | null;
      tags?: string[];
      showTodosInKanban?: boolean;
      otherAttributesData?: {
        [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
      } | null;
      formulaCounters?: {
        [key: string]: {
          value: number;
          updatedBy?: {
            _id: string | any;
            name: string;
          } | null;
          updatedDate?: string | null;
        };
      };
      risiko?: {
        probability?: string | null;
        consequence?: {
          [key: string]: string | null;
        } | null;
        categoryComment?: string | null;
      };
      hours?: {
        orignalEstimate?: number | null;
        remaining?: number | null;
        completed?: number | null;
      };
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
      } | null;
      gantActivities?: {
        start?: string;
        end?: string;
        title?: string;
        description?: string;
        progress?: number;
        color?: string;
      }[];
    };
  };
};
export type PutProjectByProjectIdIssueUpdateDescriptionApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueUpdateDescriptionApiArg = {
  projectId: string;
  body: {
    _id: string;
    description?: string | null;
    descriptionRichText?: string | null;
  };
};
export type PutProjectByProjectIdIssueUpdateUserApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueUpdateUserApiArg = {
  projectId: string;
  body: {
    _id: string;
    property: {
      assignedTo?: {
        _id: string | any;
        name: string;
      } | null;
      itemMembers?: {
        _id: string | any;
        name: string;
      }[];
      owner?: {
        _id: string | any;
        name: string;
      } | null;
    };
  };
};
export type PutProjectByProjectIdIssueConnectedTasksUpdateOrderApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueConnectedTasksUpdateOrderApiArg = {
  projectId: string;
  body: {
    issueId: string;
    newOrder: string[];
  };
};
export type PutProjectByProjectIdIssueSubscribeApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueSubscribeApiArg = {
  projectId: string;
  body: {
    issueId: string;
  };
};
export type PutProjectByProjectIdIssueArchiveApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueArchiveApiArg = {
  projectId: string;
  body: {
    issueId: string;
  };
};
export type PutProjectByProjectIdIssueItemAndIssueIdCommentCommentIdReactionApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    descriptionRichText: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
      pns?: string | null;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    formulaCounters: {
      [key: string]: {
        value: number;
        updatedBy?: {
          _id: string;
          name: string;
        } | null;
        updatedDate?: string | null;
      };
    };
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
      reactions?: {
        user: {
          _id: string;
          name: string;
        };
        date: string;
        emoji: string;
      }[];
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
export type PutProjectByProjectIdIssueItemAndIssueIdCommentCommentIdReactionApiArg = {
  projectId: string;
  issueId: string;
  commentId: string;
  body: {
    emoji: string;
  };
};
export type PutProjectByProjectIdIssueConvertTypeApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  descriptionRichText: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
    pns?: string | null;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  formulaCounters: {
    [key: string]: {
      value: number;
      updatedBy?: {
        _id: string;
        name: string;
      } | null;
      updatedDate?: string | null;
    };
  };
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueConvertTypeApiArg = {
  projectId: string;
  body: {
    issueId: string;
    taskOrIssue: "ISSUE" | "TASK";
    connectedIssueId?: string | null;
  };
};
export type GetProjectByProjectIdIssueAndIssueIdLogsApiResponse = /** status 200 Successful response */ {
  _id: string;
  project: string;
  board: string;
  issueId: string;
  taskOrIssue: "ISSUE" | "TASK";
  column: string;
  oldValue?: string;
  newValue: string;
  userName: string;
  updatedAt: string;
  createdAt: string;
}[];
export type GetProjectByProjectIdIssueAndIssueIdLogsApiArg = {
  projectId: string;
  issueId: string;
};
export type GetProjectByProjectIdIssuesValidateOtherAttributesByBoardApiResponse =
  /** status 200 Successful response */ {
    id: number;
    data: {
      [key: string]: {
        typeInConf?:
          | (
              | "STRING"
              | "MULTILINESTRING"
              | "NUMBER"
              | "DATE"
              | "BOOLEAN"
              | "DROPDOWN"
              | "FORMULA"
              | "MATH_FORMULA"
              | null
            )
          | null;
        value?: any;
        isTypeValid: boolean;
      };
    };
  }[];
export type GetProjectByProjectIdIssuesValidateOtherAttributesByBoardApiArg = {
  projectId: string;
  issueBoardId: string;
};
export type PostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckApiResponse = /** status 200 Successful response */ {
  status: "preview" | "success";
  verdict: "PASS" | "PARTIAL" | "FAIL" | "UNCERTAIN";
  inputData: {
    otherAttributeIText: string;
    pdfFileCount: number;
    pdfFiles: {
      fileName: string;
      blobName: string;
      extractedTextLength: number;
    }[];
    imageFiles: {
      fileName: string;
      blobName: string;
      description: string;
      includedInAi: boolean;
      missingDescription: boolean;
    }[];
    aiInput: {
      outputLanguage: "NO" | "EN";
      tokenEstimate: {
        inputTokens: number;
        outputTokens: number;
        totalTokens: number;
        estimatedCostNok: number;
        usdToNokRate: number;
        inputUsdPer1MTokens: number;
        outputUsdPer1MTokens: number;
        pricingNote: string;
      };
      relevanceKeywords: string[];
      prompt: string;
      documents: {
        fileName: string;
        selectedText: string;
        selectedTextLength: number;
        totalTextLength: number;
        pages: {
          pageNumber: number;
          text: string;
          textLength: number;
          selected: boolean;
        }[];
      }[];
      imageEvidence: {
        fileName: string;
        description: string;
      }[];
    };
  };
  summary: string;
  analysis: string[];
  evidence: {
    documentName: string;
    page: number;
    text: string;
  }[];
  gaps: string[];
};
export type PostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckApiArg = {
  issueId: string;
  projectId: string;
  body: {
    body?: {
      runAi?: boolean;
      outputLanguage?: "NO" | "EN";
    };
  };
};
export type GetUsageAggregateProjectStartsApiResponse = /** status 200 Successful response */ {
  keyField?: number | string;
  count: number;
  projectName: string;
  projectId: string;
}[];
export type GetUsageAggregateProjectStartsApiArg = {
  fromDate?: string | null;
  toDate?: string | null;
  appName?: string;
};
export type GetUsageAggregateProjectApiResponse = /** status 200 Successful response */ {
  users: {
    name: string;
    count: number;
  }[];
  appStarts: {
    name: string;
    count: number;
  }[];
};
export type GetUsageAggregateProjectApiArg = {
  fromDate?: string | null;
  toDate?: string | null;
  projectId: string;
};
export type GetProjectByProjectIdTableTemplatesApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  issueBoard: string;
  tableColumns: string[];
  tableColConfigs?: {
    colId?: string;
    orderPriority?: number;
    width?: number;
  }[];
  taskAndOrIssue?: ("TASK" | "ISSUE")[];
  filters: {
    typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
    dataField?: string;
    multiFilterValues?: string[] | object[];
    isActive?: boolean;
  }[];
  sortedCol?: {
    column?: string;
    direction?: "ASC" | "DESC";
  };
  archived?: boolean;
}[];
export type GetProjectByProjectIdTableTemplatesApiArg = {
  projectId: string;
  issueboardId: string;
};
export type PatchProjectByProjectIdTableTemplateApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  issueBoard: string;
  tableColumns: string[];
  tableColConfigs?: {
    colId?: string;
    orderPriority?: number;
    width?: number;
  }[];
  taskAndOrIssue?: ("TASK" | "ISSUE")[];
  filters: {
    typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
    dataField?: string;
    multiFilterValues?: string[] | object[];
    isActive?: boolean;
  }[];
  sortedCol?: {
    column?: string;
    direction?: "ASC" | "DESC";
  };
  archived?: boolean;
};
export type PatchProjectByProjectIdTableTemplateApiArg = {
  projectId: string;
  body: {
    tableTemplate: {
      _id: string | any;
      name: string;
      issueBoard: string | any;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    };
  };
};
export type PostProjectByProjectIdTableTemplateApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  issueBoard: string;
  tableColumns: string[];
  tableColConfigs?: {
    colId?: string;
    orderPriority?: number;
    width?: number;
  }[];
  taskAndOrIssue?: ("TASK" | "ISSUE")[];
  filters: {
    typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
    dataField?: string;
    multiFilterValues?: string[] | object[];
    isActive?: boolean;
  }[];
  sortedCol?: {
    column?: string;
    direction?: "ASC" | "DESC";
  };
  archived?: boolean;
};
export type PostProjectByProjectIdTableTemplateApiArg = {
  projectId: string;
  body: {
    tableTemplate: {
      name: string;
      issueBoard: string | any;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    };
  };
};
export type PostProjectByProjectIdMeetingApiResponse = /** status 200 Successful response */ {
  meetings: {
    _id: string;
    id?: number;
    name?: string;
    dateOfMeeting?: string;
    owner?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    meetingSerie?:
      | string
      | ({
          _id?: string;
          name?: string;
          access?:
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: string[];
              }
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: {
                  _id: string;
                  name: string;
                }[];
              };
        } | null);
    isDeleted?: boolean;
    isMember?: boolean;
  }[];
  allFilters: {
    dataField: string;
    options?: {
      label: string;
      value: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
};
export type PostProjectByProjectIdMeetingApiArg = {
  projectId: string;
  body: {
    allFilters?: {
      dataField: string;
      options?: {
        label: string;
        value: (string | any) | string;
        isActive: boolean;
      }[];
      bool?: boolean;
    }[];
  };
};
export type GetProjectByProjectIdMeetingAndMeetingIdApiResponse = /** status 200 Successful response */ {
  _id?: string;
  id?: number;
  project?: string;
  createdBy: {
    _id?: string;
    name: string;
    email?: string;
  };
  meetingSerie?:
    | {
        _id?: string;
        project?: string;
        name?: string;
        description?: string;
        createdBy?:
          | string
          | {
              _id?: string;
              name?: string;
            };
        access?:
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: string[];
            }
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: {
                _id: string;
                name: string;
              }[];
            };
        createdAt?: string;
        updatedAt?: string;
        seriesEnd?: string | null;
        seriesStart?: string;
        day?: number;
        interval?: string | null;
        color?: string;
        instanceDate?: string;
        tagsToFilter?: string[];
        timeStart?: string;
        timeEnd?: string;
        status?: "ACTIVE" | "ARCHIVED" | "DELETED";
        connectedMeetingInstances?: (
          | {
              _id?: string;
              name?: string;
              dateOfMeeting?: string;
              isDeleted?: boolean;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        defaultIssueBoard?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                }
            )
          | null;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      );
  status?: string;
  name?: string;
  pns?: string;
  description?: string;
  typeOfMeeting?: string;
  location?: string;
  owner: {
    _id?: string;
    name: string;
    email?: string;
  };
  referent?: {
    _id?: string;
    name: string;
    email?: string;
  };
  dateOfMeeting?: string;
  participants?: {
    _id?: string;
    user?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  externalParticipants?: {
    _id?: string;
    name?: string;
    email?: string;
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  otherParticipants?: string[];
  meetingUrl?: string;
  agendaItems?: (
    | {
        _id?: string;
        id?: number;
        time?: string;
        title?: string;
        project?: string;
        meeting?: string;
        meetingSerie?:
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
          | null;
        description?: string;
        completed?: boolean;
        editedBy?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        connectedIssues?: (
          | {
              _id?: string;
              name?: string;
              title?: string;
              assignedTo?:
                | (
                    | string
                    | {
                        _id?: string;
                        name: string;
                        email?: string;
                      }
                  )
                | null;
              issueBoard?: {
                _id?: string;
                name?: string;
                access?:
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: string[];
                    }
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: {
                        _id: string;
                        name: string;
                      }[];
                    };
              };
              connectedTasks?: {
                _id?: string;
                name?: string;
              }[];
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        conclusion?: string;
        duration?: number;
        startTimeCalculated?: string;
        todos?: {
          _id?: string;
          text?: string;
          createdAt?: string;
          listIndex?: number;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          createdByName?: string;
          completedByName?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          completedDate?: string | null;
          completedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
        }[];
        purpose?: string | null;
        assignedTo?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        assignedToFreeText?: string;
        comments?: (
          | {
              _id?: string;
              text?: string;
              createdBy?:
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  };
              createdAt?: string;
              updatedAt?: string;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        uploadedFiles?: {
          _id?: string;
          createdDate?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name: string;
                email?: string;
              };
          filename?: string;
        }[];
        isDeleted?: boolean;
        order?: number;
        notRelevant?: boolean;
        itemParticipants?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )[]
          | null;
        filesUploadedToAzure?: {
          success?: number;
          failed?: number;
        };
        createdAt?: string;
        updatedAt?: string;
      }
    | (
        | string
        | {
            _id: string;
            name?: string;
          }
      )
  )[];
  isDeleted?: boolean;
  generatedMeetingsInDocx?: {
    _id?: string;
    createdDate?: string;
    createdBy?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    filename?: string;
  }[];
  timeStart?: string;
  defaultIssueBoard?: {
    _id: string;
    name: string;
  } | null;
  isMember?: boolean;
  documentCode?: string;
  availability?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type GetProjectByProjectIdMeetingAndMeetingIdApiArg = {
  projectId: string;
  meetingId: string;
};
export type PutProjectByProjectIdMeetingAndMeetingIdApiResponse = /** status 200 Successful response */ {
  _id?: string;
  id?: number;
  project?: string;
  createdBy: {
    _id?: string;
    name: string;
    email?: string;
  };
  meetingSerie?:
    | {
        _id?: string;
        project?: string;
        name?: string;
        description?: string;
        createdBy?:
          | string
          | {
              _id?: string;
              name?: string;
            };
        access?:
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: string[];
            }
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: {
                _id: string;
                name: string;
              }[];
            };
        createdAt?: string;
        updatedAt?: string;
        seriesEnd?: string | null;
        seriesStart?: string;
        day?: number;
        interval?: string | null;
        color?: string;
        instanceDate?: string;
        tagsToFilter?: string[];
        timeStart?: string;
        timeEnd?: string;
        status?: "ACTIVE" | "ARCHIVED" | "DELETED";
        connectedMeetingInstances?: (
          | {
              _id?: string;
              name?: string;
              dateOfMeeting?: string;
              isDeleted?: boolean;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        defaultIssueBoard?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                }
            )
          | null;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      );
  status?: string;
  name?: string;
  pns?: string;
  description?: string;
  typeOfMeeting?: string;
  location?: string;
  owner: {
    _id?: string;
    name: string;
    email?: string;
  };
  referent?: {
    _id?: string;
    name: string;
    email?: string;
  };
  dateOfMeeting?: string;
  participants?: {
    _id?: string;
    user?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  externalParticipants?: {
    _id?: string;
    name?: string;
    email?: string;
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  otherParticipants?: string[];
  meetingUrl?: string;
  agendaItems?: (
    | {
        _id?: string;
        id?: number;
        time?: string;
        title?: string;
        project?: string;
        meeting?: string;
        meetingSerie?:
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
          | null;
        description?: string;
        completed?: boolean;
        editedBy?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        connectedIssues?: (
          | {
              _id?: string;
              name?: string;
              title?: string;
              assignedTo?:
                | (
                    | string
                    | {
                        _id?: string;
                        name: string;
                        email?: string;
                      }
                  )
                | null;
              issueBoard?: {
                _id?: string;
                name?: string;
                access?:
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: string[];
                    }
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: {
                        _id: string;
                        name: string;
                      }[];
                    };
              };
              connectedTasks?: {
                _id?: string;
                name?: string;
              }[];
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        conclusion?: string;
        duration?: number;
        startTimeCalculated?: string;
        todos?: {
          _id?: string;
          text?: string;
          createdAt?: string;
          listIndex?: number;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          createdByName?: string;
          completedByName?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          completedDate?: string | null;
          completedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
        }[];
        purpose?: string | null;
        assignedTo?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        assignedToFreeText?: string;
        comments?: (
          | {
              _id?: string;
              text?: string;
              createdBy?:
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  };
              createdAt?: string;
              updatedAt?: string;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        uploadedFiles?: {
          _id?: string;
          createdDate?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name: string;
                email?: string;
              };
          filename?: string;
        }[];
        isDeleted?: boolean;
        order?: number;
        notRelevant?: boolean;
        itemParticipants?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )[]
          | null;
        filesUploadedToAzure?: {
          success?: number;
          failed?: number;
        };
        createdAt?: string;
        updatedAt?: string;
      }
    | (
        | string
        | {
            _id: string;
            name?: string;
          }
      )
  )[];
  isDeleted?: boolean;
  generatedMeetingsInDocx?: {
    _id?: string;
    createdDate?: string;
    createdBy?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    filename?: string;
  }[];
  timeStart?: string;
  defaultIssueBoard?: {
    _id: string;
    name: string;
  } | null;
  isMember?: boolean;
  documentCode?: string;
  availability?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type PutProjectByProjectIdMeetingAndMeetingIdApiArg = {
  projectId: string;
  meetingId: string;
};
export type GetMeetingParticipantByUserIdApiResponse = /** status 200 Successful response */ {
  _id?: string;
  id?: number;
  project?: string;
  createdBy?:
    | string
    | {
        _id?: string;
        name: string;
        email?: string;
      };
  meetingSerie?:
    | {
        _id?: string;
        project?: string;
        name?: string;
        description?: string;
        createdBy?:
          | string
          | {
              _id?: string;
              name?: string;
            };
        access?:
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: string[];
            }
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: {
                _id: string;
                name: string;
              }[];
            };
        createdAt?: string;
        updatedAt?: string;
        seriesEnd?: string | null;
        seriesStart?: string;
        day?: number;
        interval?: string | null;
        color?: string;
        instanceDate?: string;
        tagsToFilter?: string[];
        timeStart?: string;
        timeEnd?: string;
        status?: "ACTIVE" | "ARCHIVED" | "DELETED";
        connectedMeetingInstances?: (
          | {
              _id?: string;
              name?: string;
              dateOfMeeting?: string;
              isDeleted?: boolean;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        defaultIssueBoard?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                }
            )
          | null;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      );
  status?: string;
  name?: string;
  pns?: string;
  description?: string;
  typeOfMeeting?: string;
  location?: string;
  owner?:
    | string
    | {
        _id?: string;
        name: string;
        email?: string;
      };
  referent?:
    | string
    | {
        _id?: string;
        name: string;
        email?: string;
      };
  dateOfMeeting?: string;
  participants?: {
    _id?: string;
    user?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  externalParticipants?: {
    _id?: string;
    name?: string;
    email?: string;
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  otherParticipants?: string[];
  meetingUrl?: string;
  agendaItems?: (
    | {
        _id?: string;
        id?: number;
        time?: string;
        title?: string;
        project?: string;
        meeting?: string;
        meetingSerie?:
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
          | null;
        description?: string;
        completed?: boolean;
        editedBy?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        connectedIssues?: (
          | {
              _id?: string;
              name?: string;
              title?: string;
              assignedTo?:
                | (
                    | string
                    | {
                        _id?: string;
                        name: string;
                        email?: string;
                      }
                  )
                | null;
              issueBoard?: {
                _id?: string;
                name?: string;
                access?:
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: string[];
                    }
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: {
                        _id: string;
                        name: string;
                      }[];
                    };
              };
              connectedTasks?: {
                _id?: string;
                name?: string;
              }[];
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        conclusion?: string;
        duration?: number;
        startTimeCalculated?: string;
        todos?: {
          _id?: string;
          text?: string;
          createdAt?: string;
          listIndex?: number;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          createdByName?: string;
          completedByName?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          completedDate?: string | null;
          completedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
        }[];
        purpose?: string | null;
        assignedTo?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        assignedToFreeText?: string;
        comments?: (
          | {
              _id?: string;
              text?: string;
              createdBy?:
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  };
              createdAt?: string;
              updatedAt?: string;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        uploadedFiles?: {
          _id?: string;
          createdDate?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name: string;
                email?: string;
              };
          filename?: string;
        }[];
        isDeleted?: boolean;
        order?: number;
        notRelevant?: boolean;
        itemParticipants?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )[]
          | null;
        filesUploadedToAzure?: {
          success?: number;
          failed?: number;
        };
        createdAt?: string;
        updatedAt?: string;
      }
    | (
        | string
        | {
            _id: string;
            name?: string;
          }
      )
  )[];
  isDeleted?: boolean;
  generatedMeetingsInDocx?: {
    _id?: string;
    createdDate?: string;
    createdBy?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    filename?: string;
  }[];
  timeStart?: string;
  defaultIssueBoard?:
    | (
        | string
        | {
            _id: string;
            name: string;
          }
      )
    | null;
  isMember?: boolean;
  documentCode?: string;
  availability?: string;
  createdAt?: string;
  updatedAt?: string;
}[];
export type GetMeetingParticipantByUserIdApiArg = {
  userId: string;
};
export type PostProjectByProjectIdMeetingNewSingleMeetingApiResponse = /** status 200 Successful response */ {
  _id?: string;
  id?: number;
  project?: string;
  createdBy?:
    | string
    | {
        _id?: string;
        name: string;
        email?: string;
      };
  meetingSerie?:
    | {
        _id?: string;
        project?: string;
        name?: string;
        description?: string;
        createdBy?:
          | string
          | {
              _id?: string;
              name?: string;
            };
        access?:
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: string[];
            }
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: {
                _id: string;
                name: string;
              }[];
            };
        createdAt?: string;
        updatedAt?: string;
        seriesEnd?: string | null;
        seriesStart?: string;
        day?: number;
        interval?: string | null;
        color?: string;
        instanceDate?: string;
        tagsToFilter?: string[];
        timeStart?: string;
        timeEnd?: string;
        status?: "ACTIVE" | "ARCHIVED" | "DELETED";
        connectedMeetingInstances?: (
          | {
              _id?: string;
              name?: string;
              dateOfMeeting?: string;
              isDeleted?: boolean;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        defaultIssueBoard?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                }
            )
          | null;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      );
  status?: string;
  name?: string;
  pns?: string;
  description?: string;
  typeOfMeeting?: string;
  location?: string;
  owner?:
    | string
    | {
        _id?: string;
        name: string;
        email?: string;
      };
  referent?:
    | string
    | {
        _id?: string;
        name: string;
        email?: string;
      };
  dateOfMeeting?: string;
  participants?: {
    _id?: string;
    user?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  externalParticipants?: {
    _id?: string;
    name?: string;
    email?: string;
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  otherParticipants?: string[];
  meetingUrl?: string;
  agendaItems?: (
    | {
        _id?: string;
        id?: number;
        time?: string;
        title?: string;
        project?: string;
        meeting?: string;
        meetingSerie?:
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
          | null;
        description?: string;
        completed?: boolean;
        editedBy?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        connectedIssues?: (
          | {
              _id?: string;
              name?: string;
              title?: string;
              assignedTo?:
                | (
                    | string
                    | {
                        _id?: string;
                        name: string;
                        email?: string;
                      }
                  )
                | null;
              issueBoard?: {
                _id?: string;
                name?: string;
                access?:
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: string[];
                    }
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: {
                        _id: string;
                        name: string;
                      }[];
                    };
              };
              connectedTasks?: {
                _id?: string;
                name?: string;
              }[];
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        conclusion?: string;
        duration?: number;
        startTimeCalculated?: string;
        todos?: {
          _id?: string;
          text?: string;
          createdAt?: string;
          listIndex?: number;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          createdByName?: string;
          completedByName?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          completedDate?: string | null;
          completedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
        }[];
        purpose?: string | null;
        assignedTo?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        assignedToFreeText?: string;
        comments?: (
          | {
              _id?: string;
              text?: string;
              createdBy?:
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  };
              createdAt?: string;
              updatedAt?: string;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        uploadedFiles?: {
          _id?: string;
          createdDate?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name: string;
                email?: string;
              };
          filename?: string;
        }[];
        isDeleted?: boolean;
        order?: number;
        notRelevant?: boolean;
        itemParticipants?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )[]
          | null;
        filesUploadedToAzure?: {
          success?: number;
          failed?: number;
        };
        createdAt?: string;
        updatedAt?: string;
      }
    | (
        | string
        | {
            _id: string;
            name?: string;
          }
      )
  )[];
  isDeleted?: boolean;
  generatedMeetingsInDocx?: {
    _id?: string;
    createdDate?: string;
    createdBy?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    filename?: string;
  }[];
  timeStart?: string;
  defaultIssueBoard?:
    | (
        | string
        | {
            _id: string;
            name: string;
          }
      )
    | null;
  isMember?: boolean;
  documentCode?: string;
  availability?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type PostProjectByProjectIdMeetingNewSingleMeetingApiArg = {
  projectId: string;
  body: {
    startDate: string;
    title: string;
  };
};
export type PutProjectByProjectIdMeetingNewMeetingInSeriesApiResponse = /** status 200 Successful response */ {
  _id?: string;
  id?: number;
  project?: string;
  createdBy?:
    | string
    | {
        _id?: string;
        name: string;
        email?: string;
      };
  meetingSerie?:
    | {
        _id?: string;
        project?: string;
        name?: string;
        description?: string;
        createdBy?:
          | string
          | {
              _id?: string;
              name?: string;
            };
        access?:
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: string[];
            }
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: {
                _id: string;
                name: string;
              }[];
            };
        createdAt?: string;
        updatedAt?: string;
        seriesEnd?: string | null;
        seriesStart?: string;
        day?: number;
        interval?: string | null;
        color?: string;
        instanceDate?: string;
        tagsToFilter?: string[];
        timeStart?: string;
        timeEnd?: string;
        status?: "ACTIVE" | "ARCHIVED" | "DELETED";
        connectedMeetingInstances?: (
          | {
              _id?: string;
              name?: string;
              dateOfMeeting?: string;
              isDeleted?: boolean;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        defaultIssueBoard?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                }
            )
          | null;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      );
  status?: string;
  name?: string;
  pns?: string;
  description?: string;
  typeOfMeeting?: string;
  location?: string;
  owner?:
    | string
    | {
        _id?: string;
        name: string;
        email?: string;
      };
  referent?:
    | string
    | {
        _id?: string;
        name: string;
        email?: string;
      };
  dateOfMeeting?: string;
  participants?: {
    _id?: string;
    user?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  externalParticipants?: {
    _id?: string;
    name?: string;
    email?: string;
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  otherParticipants?: string[];
  meetingUrl?: string;
  agendaItems?: (
    | {
        _id?: string;
        id?: number;
        time?: string;
        title?: string;
        project?: string;
        meeting?: string;
        meetingSerie?:
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
          | null;
        description?: string;
        completed?: boolean;
        editedBy?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        connectedIssues?: (
          | {
              _id?: string;
              name?: string;
              title?: string;
              assignedTo?:
                | (
                    | string
                    | {
                        _id?: string;
                        name: string;
                        email?: string;
                      }
                  )
                | null;
              issueBoard?: {
                _id?: string;
                name?: string;
                access?:
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: string[];
                    }
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: {
                        _id: string;
                        name: string;
                      }[];
                    };
              };
              connectedTasks?: {
                _id?: string;
                name?: string;
              }[];
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        conclusion?: string;
        duration?: number;
        startTimeCalculated?: string;
        todos?: {
          _id?: string;
          text?: string;
          createdAt?: string;
          listIndex?: number;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          createdByName?: string;
          completedByName?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          completedDate?: string | null;
          completedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
        }[];
        purpose?: string | null;
        assignedTo?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        assignedToFreeText?: string;
        comments?: (
          | {
              _id?: string;
              text?: string;
              createdBy?:
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  };
              createdAt?: string;
              updatedAt?: string;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        uploadedFiles?: {
          _id?: string;
          createdDate?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name: string;
                email?: string;
              };
          filename?: string;
        }[];
        isDeleted?: boolean;
        order?: number;
        notRelevant?: boolean;
        itemParticipants?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )[]
          | null;
        filesUploadedToAzure?: {
          success?: number;
          failed?: number;
        };
        createdAt?: string;
        updatedAt?: string;
      }
    | (
        | string
        | {
            _id: string;
            name?: string;
          }
      )
  )[];
  isDeleted?: boolean;
  generatedMeetingsInDocx?: {
    _id?: string;
    createdDate?: string;
    createdBy?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    filename?: string;
  }[];
  timeStart?: string;
  defaultIssueBoard?:
    | (
        | string
        | {
            _id: string;
            name: string;
          }
      )
    | null;
  isMember?: boolean;
  documentCode?: string;
  availability?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type PutProjectByProjectIdMeetingNewMeetingInSeriesApiArg = {
  projectId: string;
  body: {
    meetingSerieId: string;
    dateOfMeeting: string;
    copyAgenda: boolean;
  };
};
export type PutProjectByProjectIdMeetingAndMeetingIdAttributeApiResponse = /** status 200 Successful response */ {
  _id?: string;
  id?: number;
  project?: string;
  createdBy: {
    _id?: string;
    name: string;
    email?: string;
  };
  meetingSerie?:
    | {
        _id?: string;
        project?: string;
        name?: string;
        description?: string;
        createdBy?:
          | string
          | {
              _id?: string;
              name?: string;
            };
        access?:
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: string[];
            }
          | {
              /** AccessLevels */
              level: "PROJECT" | "USERS" | "GROUPS";
              groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
              users: {
                _id: string;
                name: string;
              }[];
            };
        createdAt?: string;
        updatedAt?: string;
        seriesEnd?: string | null;
        seriesStart?: string;
        day?: number;
        interval?: string | null;
        color?: string;
        instanceDate?: string;
        tagsToFilter?: string[];
        timeStart?: string;
        timeEnd?: string;
        status?: "ACTIVE" | "ARCHIVED" | "DELETED";
        connectedMeetingInstances?: (
          | {
              _id?: string;
              name?: string;
              dateOfMeeting?: string;
              isDeleted?: boolean;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        defaultIssueBoard?:
          | (
              | string
              | {
                  _id: string;
                  name: string;
                }
            )
          | null;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      );
  status?: string;
  name?: string;
  pns?: string;
  description?: string;
  typeOfMeeting?: string;
  location?: string;
  owner: {
    _id?: string;
    name: string;
    email?: string;
  };
  referent?: {
    _id?: string;
    name: string;
    email?: string;
  };
  dateOfMeeting?: string;
  participants?: {
    _id?: string;
    user?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  externalParticipants?: {
    _id?: string;
    name?: string;
    email?: string;
    isPresent?: boolean;
    discipline?: string | null;
  }[];
  otherParticipants?: string[];
  meetingUrl?: string;
  agendaItems?: (
    | {
        _id?: string;
        id?: number;
        time?: string;
        title?: string;
        project?: string;
        meeting?: string;
        meetingSerie?:
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
          | null;
        description?: string;
        completed?: boolean;
        editedBy?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        connectedIssues?: (
          | {
              _id?: string;
              name?: string;
              title?: string;
              assignedTo?:
                | (
                    | string
                    | {
                        _id?: string;
                        name: string;
                        email?: string;
                      }
                  )
                | null;
              issueBoard?: {
                _id?: string;
                name?: string;
                access?:
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: string[];
                    }
                  | {
                      /** AccessLevels */
                      level: "PROJECT" | "USERS" | "GROUPS";
                      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                      users: {
                        _id: string;
                        name: string;
                      }[];
                    };
              };
              connectedTasks?: {
                _id?: string;
                name?: string;
              }[];
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        conclusion?: string;
        duration?: number;
        startTimeCalculated?: string;
        todos?: {
          _id?: string;
          text?: string;
          createdAt?: string;
          listIndex?: number;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          createdByName?: string;
          completedByName?: string | null;
          updatedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          completedDate?: string | null;
          completedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
        }[];
        purpose?: string | null;
        assignedTo?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        assignedToFreeText?: string;
        comments?: (
          | {
              _id?: string;
              text?: string;
              createdBy?:
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  };
              createdAt?: string;
              updatedAt?: string;
            }
          | (
              | string
              | {
                  _id?: string;
                  name?: string;
                }
            )
        )[];
        uploadedFiles?: {
          _id?: string;
          createdDate?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name: string;
                email?: string;
              };
          filename?: string;
        }[];
        isDeleted?: boolean;
        order?: number;
        notRelevant?: boolean;
        itemParticipants?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )[]
          | null;
        filesUploadedToAzure?: {
          success?: number;
          failed?: number;
        };
        createdAt?: string;
        updatedAt?: string;
      }
    | (
        | string
        | {
            _id: string;
            name?: string;
          }
      )
  )[];
  isDeleted?: boolean;
  generatedMeetingsInDocx?: {
    _id?: string;
    createdDate?: string;
    createdBy?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    filename?: string;
  }[];
  timeStart?: string;
  defaultIssueBoard?: {
    _id: string;
    name: string;
  } | null;
  isMember?: boolean;
  documentCode?: string;
  availability?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type PutProjectByProjectIdMeetingAndMeetingIdAttributeApiArg = {
  projectId: string;
  meetingId: string;
  body: {
    attribute: string;
    value?: any;
  };
};
export type PutProjectByProjectIdMeetingAndMeetingIdSendagendaApiResponse = /** status 200 Successful response */ any;
export type PutProjectByProjectIdMeetingAndMeetingIdSendagendaApiArg = {
  projectId: string;
  meetingId: string;
  body: {
    emailSubject: string;
    emailContent: string;
    urlToMeetingAgenda: string;
    contextLabel: string;
  };
};
export type PostProjectByProjectIdMeetingAndMeetingIdParticipantUserIdApiResponse =
  /** status 200 Successful response */ {
    _id?: string;
    id?: number;
    project?: string;
    createdBy: {
      _id?: string;
      name: string;
      email?: string;
    };
    meetingSerie?:
      | {
          _id?: string;
          project?: string;
          name?: string;
          description?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          access?:
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: string[];
              }
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: {
                  _id: string;
                  name: string;
                }[];
              };
          createdAt?: string;
          updatedAt?: string;
          seriesEnd?: string | null;
          seriesStart?: string;
          day?: number;
          interval?: string | null;
          color?: string;
          instanceDate?: string;
          tagsToFilter?: string[];
          timeStart?: string;
          timeEnd?: string;
          status?: "ACTIVE" | "ARCHIVED" | "DELETED";
          connectedMeetingInstances?: (
            | {
                _id?: string;
                name?: string;
                dateOfMeeting?: string;
                isDeleted?: boolean;
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          defaultIssueBoard?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                  }
              )
            | null;
        }
      | (
          | string
          | {
              _id?: string;
              name?: string;
            }
        );
    status?: string;
    name?: string;
    pns?: string;
    description?: string;
    typeOfMeeting?: string;
    location?: string;
    owner: {
      _id?: string;
      name: string;
      email?: string;
    };
    referent?: {
      _id?: string;
      name: string;
      email?: string;
    };
    dateOfMeeting?: string;
    participants?: {
      _id?: string;
      user?:
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          };
      isPresent?: boolean;
      discipline?: string | null;
    }[];
    externalParticipants?: {
      _id?: string;
      name?: string;
      email?: string;
      isPresent?: boolean;
      discipline?: string | null;
    }[];
    otherParticipants?: string[];
    meetingUrl?: string;
    agendaItems?: (
      | {
          _id?: string;
          id?: number;
          time?: string;
          title?: string;
          project?: string;
          meeting?: string;
          meetingSerie?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          description?: string;
          completed?: boolean;
          editedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )
            | null;
          connectedIssues?: (
            | {
                _id?: string;
                name?: string;
                title?: string;
                assignedTo?:
                  | (
                      | string
                      | {
                          _id?: string;
                          name: string;
                          email?: string;
                        }
                    )
                  | null;
                issueBoard?: {
                  _id?: string;
                  name?: string;
                  access?:
                    | {
                        /** AccessLevels */
                        level: "PROJECT" | "USERS" | "GROUPS";
                        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                        users: string[];
                      }
                    | {
                        /** AccessLevels */
                        level: "PROJECT" | "USERS" | "GROUPS";
                        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                        users: {
                          _id: string;
                          name: string;
                        }[];
                      };
                };
                connectedTasks?: {
                  _id?: string;
                  name?: string;
                }[];
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          conclusion?: string;
          duration?: number;
          startTimeCalculated?: string;
          todos?: {
            _id?: string;
            text?: string;
            createdAt?: string;
            listIndex?: number;
            createdBy?:
              | string
              | {
                  _id?: string;
                  name?: string;
                };
            createdByName?: string;
            completedByName?: string | null;
            updatedBy?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
            assignedTo?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
            completedDate?: string | null;
            completedBy?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
          }[];
          purpose?: string | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )
            | null;
          assignedToFreeText?: string;
          comments?: (
            | {
                _id?: string;
                text?: string;
                createdBy?:
                  | string
                  | {
                      _id?: string;
                      name: string;
                      email?: string;
                    };
                createdAt?: string;
                updatedAt?: string;
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          uploadedFiles?: {
            _id?: string;
            createdDate?: string;
            createdBy?:
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                };
            filename?: string;
          }[];
          isDeleted?: boolean;
          order?: number;
          notRelevant?: boolean;
          itemParticipants?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )[]
            | null;
          filesUploadedToAzure?: {
            success?: number;
            failed?: number;
          };
          createdAt?: string;
          updatedAt?: string;
        }
      | (
          | string
          | {
              _id: string;
              name?: string;
            }
        )
    )[];
    isDeleted?: boolean;
    generatedMeetingsInDocx?: {
      _id?: string;
      createdDate?: string;
      createdBy?:
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          };
      filename?: string;
    }[];
    timeStart?: string;
    defaultIssueBoard?: {
      _id: string;
      name: string;
    } | null;
    isMember?: boolean;
    documentCode?: string;
    availability?: string;
    createdAt?: string;
    updatedAt?: string;
  };
export type PostProjectByProjectIdMeetingAndMeetingIdParticipantUserIdApiArg = {
  projectId: string;
  meetingId: string;
  userId: string;
};
export type PutProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdApiResponse =
  /** status 200 Successful response */ {
    _id?: string;
    id?: number;
    project?: string;
    createdBy: {
      _id?: string;
      name: string;
      email?: string;
    };
    meetingSerie?:
      | {
          _id?: string;
          project?: string;
          name?: string;
          description?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          access?:
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: string[];
              }
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: {
                  _id: string;
                  name: string;
                }[];
              };
          createdAt?: string;
          updatedAt?: string;
          seriesEnd?: string | null;
          seriesStart?: string;
          day?: number;
          interval?: string | null;
          color?: string;
          instanceDate?: string;
          tagsToFilter?: string[];
          timeStart?: string;
          timeEnd?: string;
          status?: "ACTIVE" | "ARCHIVED" | "DELETED";
          connectedMeetingInstances?: (
            | {
                _id?: string;
                name?: string;
                dateOfMeeting?: string;
                isDeleted?: boolean;
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          defaultIssueBoard?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                  }
              )
            | null;
        }
      | (
          | string
          | {
              _id?: string;
              name?: string;
            }
        );
    status?: string;
    name?: string;
    pns?: string;
    description?: string;
    typeOfMeeting?: string;
    location?: string;
    owner: {
      _id?: string;
      name: string;
      email?: string;
    };
    referent?: {
      _id?: string;
      name: string;
      email?: string;
    };
    dateOfMeeting?: string;
    participants?: {
      _id?: string;
      user?:
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          };
      isPresent?: boolean;
      discipline?: string | null;
    }[];
    externalParticipants?: {
      _id?: string;
      name?: string;
      email?: string;
      isPresent?: boolean;
      discipline?: string | null;
    }[];
    otherParticipants?: string[];
    meetingUrl?: string;
    agendaItems?: (
      | {
          _id?: string;
          id?: number;
          time?: string;
          title?: string;
          project?: string;
          meeting?: string;
          meetingSerie?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          description?: string;
          completed?: boolean;
          editedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )
            | null;
          connectedIssues?: (
            | {
                _id?: string;
                name?: string;
                title?: string;
                assignedTo?:
                  | (
                      | string
                      | {
                          _id?: string;
                          name: string;
                          email?: string;
                        }
                    )
                  | null;
                issueBoard?: {
                  _id?: string;
                  name?: string;
                  access?:
                    | {
                        /** AccessLevels */
                        level: "PROJECT" | "USERS" | "GROUPS";
                        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                        users: string[];
                      }
                    | {
                        /** AccessLevels */
                        level: "PROJECT" | "USERS" | "GROUPS";
                        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                        users: {
                          _id: string;
                          name: string;
                        }[];
                      };
                };
                connectedTasks?: {
                  _id?: string;
                  name?: string;
                }[];
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          conclusion?: string;
          duration?: number;
          startTimeCalculated?: string;
          todos?: {
            _id?: string;
            text?: string;
            createdAt?: string;
            listIndex?: number;
            createdBy?:
              | string
              | {
                  _id?: string;
                  name?: string;
                };
            createdByName?: string;
            completedByName?: string | null;
            updatedBy?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
            assignedTo?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
            completedDate?: string | null;
            completedBy?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
          }[];
          purpose?: string | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )
            | null;
          assignedToFreeText?: string;
          comments?: (
            | {
                _id?: string;
                text?: string;
                createdBy?:
                  | string
                  | {
                      _id?: string;
                      name: string;
                      email?: string;
                    };
                createdAt?: string;
                updatedAt?: string;
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          uploadedFiles?: {
            _id?: string;
            createdDate?: string;
            createdBy?:
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                };
            filename?: string;
          }[];
          isDeleted?: boolean;
          order?: number;
          notRelevant?: boolean;
          itemParticipants?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )[]
            | null;
          filesUploadedToAzure?: {
            success?: number;
            failed?: number;
          };
          createdAt?: string;
          updatedAt?: string;
        }
      | (
          | string
          | {
              _id: string;
              name?: string;
            }
        )
    )[];
    isDeleted?: boolean;
    generatedMeetingsInDocx?: {
      _id?: string;
      createdDate?: string;
      createdBy?:
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          };
      filename?: string;
    }[];
    timeStart?: string;
    defaultIssueBoard?: {
      _id: string;
      name: string;
    } | null;
    isMember?: boolean;
    documentCode?: string;
    availability?: string;
    createdAt?: string;
    updatedAt?: string;
  };
export type PutProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdApiArg = {
  projectId: string;
  meetingId: string;
  participantId: string;
  body: {
    attribute: string;
    value?: any;
  };
};
export type DeleteProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdApiResponse =
  /** status 200 Successful response */ {
    _id?: string;
    id?: number;
    project?: string;
    createdBy: {
      _id?: string;
      name: string;
      email?: string;
    };
    meetingSerie?:
      | {
          _id?: string;
          project?: string;
          name?: string;
          description?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          access?:
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: string[];
              }
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: {
                  _id: string;
                  name: string;
                }[];
              };
          createdAt?: string;
          updatedAt?: string;
          seriesEnd?: string | null;
          seriesStart?: string;
          day?: number;
          interval?: string | null;
          color?: string;
          instanceDate?: string;
          tagsToFilter?: string[];
          timeStart?: string;
          timeEnd?: string;
          status?: "ACTIVE" | "ARCHIVED" | "DELETED";
          connectedMeetingInstances?: (
            | {
                _id?: string;
                name?: string;
                dateOfMeeting?: string;
                isDeleted?: boolean;
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          defaultIssueBoard?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                  }
              )
            | null;
        }
      | (
          | string
          | {
              _id?: string;
              name?: string;
            }
        );
    status?: string;
    name?: string;
    pns?: string;
    description?: string;
    typeOfMeeting?: string;
    location?: string;
    owner: {
      _id?: string;
      name: string;
      email?: string;
    };
    referent?: {
      _id?: string;
      name: string;
      email?: string;
    };
    dateOfMeeting?: string;
    participants?: {
      _id?: string;
      user?:
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          };
      isPresent?: boolean;
      discipline?: string | null;
    }[];
    externalParticipants?: {
      _id?: string;
      name?: string;
      email?: string;
      isPresent?: boolean;
      discipline?: string | null;
    }[];
    otherParticipants?: string[];
    meetingUrl?: string;
    agendaItems?: (
      | {
          _id?: string;
          id?: number;
          time?: string;
          title?: string;
          project?: string;
          meeting?: string;
          meetingSerie?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          description?: string;
          completed?: boolean;
          editedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )
            | null;
          connectedIssues?: (
            | {
                _id?: string;
                name?: string;
                title?: string;
                assignedTo?:
                  | (
                      | string
                      | {
                          _id?: string;
                          name: string;
                          email?: string;
                        }
                    )
                  | null;
                issueBoard?: {
                  _id?: string;
                  name?: string;
                  access?:
                    | {
                        /** AccessLevels */
                        level: "PROJECT" | "USERS" | "GROUPS";
                        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                        users: string[];
                      }
                    | {
                        /** AccessLevels */
                        level: "PROJECT" | "USERS" | "GROUPS";
                        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                        users: {
                          _id: string;
                          name: string;
                        }[];
                      };
                };
                connectedTasks?: {
                  _id?: string;
                  name?: string;
                }[];
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          conclusion?: string;
          duration?: number;
          startTimeCalculated?: string;
          todos?: {
            _id?: string;
            text?: string;
            createdAt?: string;
            listIndex?: number;
            createdBy?:
              | string
              | {
                  _id?: string;
                  name?: string;
                };
            createdByName?: string;
            completedByName?: string | null;
            updatedBy?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
            assignedTo?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
            completedDate?: string | null;
            completedBy?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
          }[];
          purpose?: string | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )
            | null;
          assignedToFreeText?: string;
          comments?: (
            | {
                _id?: string;
                text?: string;
                createdBy?:
                  | string
                  | {
                      _id?: string;
                      name: string;
                      email?: string;
                    };
                createdAt?: string;
                updatedAt?: string;
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          uploadedFiles?: {
            _id?: string;
            createdDate?: string;
            createdBy?:
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                };
            filename?: string;
          }[];
          isDeleted?: boolean;
          order?: number;
          notRelevant?: boolean;
          itemParticipants?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )[]
            | null;
          filesUploadedToAzure?: {
            success?: number;
            failed?: number;
          };
          createdAt?: string;
          updatedAt?: string;
        }
      | (
          | string
          | {
              _id: string;
              name?: string;
            }
        )
    )[];
    isDeleted?: boolean;
    generatedMeetingsInDocx?: {
      _id?: string;
      createdDate?: string;
      createdBy?:
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          };
      filename?: string;
    }[];
    timeStart?: string;
    defaultIssueBoard?: {
      _id: string;
      name: string;
    } | null;
    isMember?: boolean;
    documentCode?: string;
    availability?: string;
    createdAt?: string;
    updatedAt?: string;
  };
export type DeleteProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdApiArg = {
  projectId: string;
  meetingId: string;
  participantId: string;
};
export type PostProjectByProjectIdMeetingAndMeetingIdExternalParticipantsApiResponse =
  /** status 200 Successful response */ {
    _id?: string;
    id?: number;
    project?: string;
    createdBy: {
      _id?: string;
      name: string;
      email?: string;
    };
    meetingSerie?:
      | {
          _id?: string;
          project?: string;
          name?: string;
          description?: string;
          createdBy?:
            | string
            | {
                _id?: string;
                name?: string;
              };
          access?:
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: string[];
              }
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: {
                  _id: string;
                  name: string;
                }[];
              };
          createdAt?: string;
          updatedAt?: string;
          seriesEnd?: string | null;
          seriesStart?: string;
          day?: number;
          interval?: string | null;
          color?: string;
          instanceDate?: string;
          tagsToFilter?: string[];
          timeStart?: string;
          timeEnd?: string;
          status?: "ACTIVE" | "ARCHIVED" | "DELETED";
          connectedMeetingInstances?: (
            | {
                _id?: string;
                name?: string;
                dateOfMeeting?: string;
                isDeleted?: boolean;
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          defaultIssueBoard?:
            | (
                | string
                | {
                    _id: string;
                    name: string;
                  }
              )
            | null;
        }
      | (
          | string
          | {
              _id?: string;
              name?: string;
            }
        );
    status?: string;
    name?: string;
    pns?: string;
    description?: string;
    typeOfMeeting?: string;
    location?: string;
    owner: {
      _id?: string;
      name: string;
      email?: string;
    };
    referent?: {
      _id?: string;
      name: string;
      email?: string;
    };
    dateOfMeeting?: string;
    participants?: {
      _id?: string;
      user?:
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          };
      isPresent?: boolean;
      discipline?: string | null;
    }[];
    externalParticipants?: {
      _id?: string;
      name?: string;
      email?: string;
      isPresent?: boolean;
      discipline?: string | null;
    }[];
    otherParticipants?: string[];
    meetingUrl?: string;
    agendaItems?: (
      | {
          _id?: string;
          id?: number;
          time?: string;
          title?: string;
          project?: string;
          meeting?: string;
          meetingSerie?:
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
            | null;
          description?: string;
          completed?: boolean;
          editedBy?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )
            | null;
          connectedIssues?: (
            | {
                _id?: string;
                name?: string;
                title?: string;
                assignedTo?:
                  | (
                      | string
                      | {
                          _id?: string;
                          name: string;
                          email?: string;
                        }
                    )
                  | null;
                issueBoard?: {
                  _id?: string;
                  name?: string;
                  access?:
                    | {
                        /** AccessLevels */
                        level: "PROJECT" | "USERS" | "GROUPS";
                        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                        users: string[];
                      }
                    | {
                        /** AccessLevels */
                        level: "PROJECT" | "USERS" | "GROUPS";
                        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                        users: {
                          _id: string;
                          name: string;
                        }[];
                      };
                };
                connectedTasks?: {
                  _id?: string;
                  name?: string;
                }[];
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          conclusion?: string;
          duration?: number;
          startTimeCalculated?: string;
          todos?: {
            _id?: string;
            text?: string;
            createdAt?: string;
            listIndex?: number;
            createdBy?:
              | string
              | {
                  _id?: string;
                  name?: string;
                };
            createdByName?: string;
            completedByName?: string | null;
            updatedBy?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
            assignedTo?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
            completedDate?: string | null;
            completedBy?:
              | (
                  | string
                  | {
                      _id?: string;
                      name?: string;
                    }
                )
              | null;
          }[];
          purpose?: string | null;
          assignedTo?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )
            | null;
          assignedToFreeText?: string;
          comments?: (
            | {
                _id?: string;
                text?: string;
                createdBy?:
                  | string
                  | {
                      _id?: string;
                      name: string;
                      email?: string;
                    };
                createdAt?: string;
                updatedAt?: string;
              }
            | (
                | string
                | {
                    _id?: string;
                    name?: string;
                  }
              )
          )[];
          uploadedFiles?: {
            _id?: string;
            createdDate?: string;
            createdBy?:
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                };
            filename?: string;
          }[];
          isDeleted?: boolean;
          order?: number;
          notRelevant?: boolean;
          itemParticipants?:
            | (
                | string
                | {
                    _id?: string;
                    name: string;
                    email?: string;
                  }
              )[]
            | null;
          filesUploadedToAzure?: {
            success?: number;
            failed?: number;
          };
          createdAt?: string;
          updatedAt?: string;
        }
      | (
          | string
          | {
              _id: string;
              name?: string;
            }
        )
    )[];
    isDeleted?: boolean;
    generatedMeetingsInDocx?: {
      _id?: string;
      createdDate?: string;
      createdBy?:
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          };
      filename?: string;
    }[];
    timeStart?: string;
    defaultIssueBoard?: {
      _id: string;
      name: string;
    } | null;
    isMember?: boolean;
    documentCode?: string;
    availability?: string;
    createdAt?: string;
    updatedAt?: string;
  };
export type PostProjectByProjectIdMeetingAndMeetingIdExternalParticipantsApiArg = {
  projectId: string;
  meetingId: string;
  body: {
    externalParticipants: {
      _id?: string;
      name: string;
      email: string;
      isPresent: boolean;
      discipline?: string;
    }[];
  };
};
export type PutProjectByProjectIdMeetingAndMeetingIdUpdateAgendaIdsApiResponse = /** status 200 Successful response */ {
  _id?: string;
  id?: number;
  time?: string;
  title?: string;
  project?: string;
  meeting?: string;
  meetingSerie?:
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      )
    | null;
  description?: string;
  completed?: boolean;
  editedBy?:
    | (
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          }
      )
    | null;
  connectedIssues?: (
    | {
        _id?: string;
        name?: string;
        title?: string;
        assignedTo?:
          | (
              | string
              | {
                  _id?: string;
                  name: string;
                  email?: string;
                }
            )
          | null;
        issueBoard?: {
          _id?: string;
          name?: string;
          access?:
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: string[];
              }
            | {
                /** AccessLevels */
                level: "PROJECT" | "USERS" | "GROUPS";
                groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
                users: {
                  _id: string;
                  name: string;
                }[];
              };
        };
        connectedTasks?: {
          _id?: string;
          name?: string;
        }[];
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      )
  )[];
  conclusion?: string;
  duration?: number;
  startTimeCalculated?: string;
  todos?: {
    _id?: string;
    text?: string;
    createdAt?: string;
    listIndex?: number;
    createdBy?:
      | string
      | {
          _id?: string;
          name?: string;
        };
    createdByName?: string;
    completedByName?: string | null;
    updatedBy?:
      | (
          | string
          | {
              _id?: string;
              name?: string;
            }
        )
      | null;
    assignedTo?:
      | (
          | string
          | {
              _id?: string;
              name?: string;
            }
        )
      | null;
    completedDate?: string | null;
    completedBy?:
      | (
          | string
          | {
              _id?: string;
              name?: string;
            }
        )
      | null;
  }[];
  purpose?: string | null;
  assignedTo?:
    | (
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          }
      )
    | null;
  assignedToFreeText?: string;
  comments?: (
    | {
        _id?: string;
        text?: string;
        createdBy?:
          | string
          | {
              _id?: string;
              name: string;
              email?: string;
            };
        createdAt?: string;
        updatedAt?: string;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      )
  )[];
  uploadedFiles?: {
    _id?: string;
    createdDate?: string;
    createdBy?:
      | string
      | {
          _id?: string;
          name: string;
          email?: string;
        };
    filename?: string;
  }[];
  isDeleted?: boolean;
  order?: number;
  notRelevant?: boolean;
  itemParticipants?:
    | (
        | string
        | {
            _id?: string;
            name: string;
            email?: string;
          }
      )[]
    | null;
  filesUploadedToAzure?: {
    success?: number;
    failed?: number;
  };
  createdAt?: string;
  updatedAt?: string;
}[];
export type PutProjectByProjectIdMeetingAndMeetingIdUpdateAgendaIdsApiArg = {
  projectId: string;
  meetingId: string;
};
export type GetProjectByProjectIdMeetingserieApiResponse = /** status 200 Successful response */ {
  _id?: string;
  project?: string;
  name?: string;
  description?: string;
  createdBy?:
    | string
    | {
        _id?: string;
        name?: string;
      };
  access?:
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: string[];
      }
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: {
          _id: string;
          name: string;
        }[];
      };
  createdAt?: string;
  updatedAt?: string;
  seriesEnd?: string | null;
  seriesStart?: string;
  day?: number;
  interval?: string | null;
  color?: string;
  instanceDate?: string;
  tagsToFilter?: string[];
  timeStart?: string;
  timeEnd?: string;
  status?: "ACTIVE" | "ARCHIVED" | "DELETED";
  connectedMeetingInstances?: (
    | {
        _id?: string;
        name?: string;
        dateOfMeeting?: string;
        isDeleted?: boolean;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      )
  )[];
  defaultIssueBoard?:
    | (
        | string
        | {
            _id: string;
            name: string;
          }
      )
    | null;
}[];
export type GetProjectByProjectIdMeetingserieApiArg = {
  projectId: string;
};
export type PostProjectByProjectIdMeetingserieApiResponse = /** status 200 Successful response */ {
  _id?: string;
  project?: string;
  name?: string;
  description?: string;
  createdBy?:
    | string
    | {
        _id?: string;
        name?: string;
      };
  access?:
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: string[];
      }
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: {
          _id: string;
          name: string;
        }[];
      };
  createdAt?: string;
  updatedAt?: string;
  seriesEnd?: string | null;
  seriesStart?: string;
  day?: number;
  interval?: string | null;
  color?: string;
  instanceDate?: string;
  tagsToFilter?: string[];
  timeStart?: string;
  timeEnd?: string;
  status?: "ACTIVE" | "ARCHIVED" | "DELETED";
  connectedMeetingInstances?: (
    | {
        _id?: string;
        name?: string;
        dateOfMeeting?: string;
        isDeleted?: boolean;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      )
  )[];
  defaultIssueBoard?:
    | (
        | string
        | {
            _id: string;
            name: string;
          }
      )
    | null;
};
export type PostProjectByProjectIdMeetingserieApiArg = {
  projectId: string;
  body: {
    seriesStart: string;
    name: string;
  };
};
export type GetProjectByProjectIdMeetingserieAndMeetingSerieIdApiResponse = /** status 200 Successful response */ {
  _id?: string;
  project?: string;
  name?: string;
  description?: string;
  createdBy?:
    | string
    | {
        _id?: string;
        name?: string;
      };
  access?:
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: string[];
      }
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: {
          _id: string;
          name: string;
        }[];
      };
  createdAt?: string;
  updatedAt?: string;
  seriesEnd?: string | null;
  seriesStart?: string;
  day?: number;
  interval?: string | null;
  color?: string;
  instanceDate?: string;
  tagsToFilter?: string[];
  timeStart?: string;
  timeEnd?: string;
  status?: "ACTIVE" | "ARCHIVED" | "DELETED";
  connectedMeetingInstances?: (
    | {
        _id?: string;
        name?: string;
        dateOfMeeting?: string;
        isDeleted?: boolean;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      )
  )[];
  defaultIssueBoard?:
    | (
        | string
        | {
            _id: string;
            name: string;
          }
      )
    | null;
};
export type GetProjectByProjectIdMeetingserieAndMeetingSerieIdApiArg = {
  projectId: string;
  meetingSerieId: string;
};
export type PutProjectByProjectIdMeetingserieAndMeetingSerieIdApiResponse = /** status 200 Successful response */ {
  _id?: string;
  project?: string;
  name?: string;
  description?: string;
  createdBy?:
    | string
    | {
        _id?: string;
        name?: string;
      };
  access?:
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: string[];
      }
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: {
          _id: string;
          name: string;
        }[];
      };
  createdAt?: string;
  updatedAt?: string;
  seriesEnd?: string | null;
  seriesStart?: string;
  day?: number;
  interval?: string | null;
  color?: string;
  instanceDate?: string;
  tagsToFilter?: string[];
  timeStart?: string;
  timeEnd?: string;
  status?: "ACTIVE" | "ARCHIVED" | "DELETED";
  connectedMeetingInstances?: (
    | {
        _id?: string;
        name?: string;
        dateOfMeeting?: string;
        isDeleted?: boolean;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      )
  )[];
  defaultIssueBoard?:
    | (
        | string
        | {
            _id: string;
            name: string;
          }
      )
    | null;
};
export type PutProjectByProjectIdMeetingserieAndMeetingSerieIdApiArg = {
  projectId: string;
  meetingSerieId: string;
  body: {
    meetingSerie?: any;
  };
};
export type PostProjectByProjectIdMeetingserieAllFieldsApiResponse = /** status 200 Successful response */ {
  _id?: string;
  project?: string;
  name?: string;
  description?: string;
  createdBy?:
    | string
    | {
        _id?: string;
        name?: string;
      };
  access?:
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: string[];
      }
    | {
        /** AccessLevels */
        level: "PROJECT" | "USERS" | "GROUPS";
        groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
        users: {
          _id: string;
          name: string;
        }[];
      };
  createdAt?: string;
  updatedAt?: string;
  seriesEnd?: string | null;
  seriesStart?: string;
  day?: number;
  interval?: string | null;
  color?: string;
  instanceDate?: string;
  tagsToFilter?: string[];
  timeStart?: string;
  timeEnd?: string;
  status?: "ACTIVE" | "ARCHIVED" | "DELETED";
  connectedMeetingInstances?: (
    | {
        _id?: string;
        name?: string;
        dateOfMeeting?: string;
        isDeleted?: boolean;
      }
    | (
        | string
        | {
            _id?: string;
            name?: string;
          }
      )
  )[];
  defaultIssueBoard?:
    | (
        | string
        | {
            _id: string;
            name: string;
          }
      )
    | null;
};
export type PostProjectByProjectIdMeetingserieAllFieldsApiArg = {
  projectId: string;
  body: {
    meetingSerie?: any;
  };
};
export type PutProjectByProjectIdMeetingserieAndMeetingSerieIdAttributeApiResponse =
  /** status 200 Successful response */ {
    _id?: string;
    project?: string;
    name?: string;
    description?: string;
    createdBy?:
      | string
      | {
          _id?: string;
          name?: string;
        };
    access?:
      | {
          /** AccessLevels */
          level: "PROJECT" | "USERS" | "GROUPS";
          groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
          users: string[];
        }
      | {
          /** AccessLevels */
          level: "PROJECT" | "USERS" | "GROUPS";
          groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
          users: {
            _id: string;
            name: string;
          }[];
        };
    createdAt?: string;
    updatedAt?: string;
    seriesEnd?: string | null;
    seriesStart?: string;
    day?: number;
    interval?: string | null;
    color?: string;
    instanceDate?: string;
    tagsToFilter?: string[];
    timeStart?: string;
    timeEnd?: string;
    status?: "ACTIVE" | "ARCHIVED" | "DELETED";
    connectedMeetingInstances?: (
      | {
          _id?: string;
          name?: string;
          dateOfMeeting?: string;
          isDeleted?: boolean;
        }
      | (
          | string
          | {
              _id?: string;
              name?: string;
            }
        )
    )[];
    defaultIssueBoard?:
      | (
          | string
          | {
              _id: string;
              name: string;
            }
        )
      | null;
  };
export type PutProjectByProjectIdMeetingserieAndMeetingSerieIdAttributeApiArg = {
  projectId: string;
  meetingSerieId: string;
  body: {
    attribute: string;
    value?: any;
  };
};
export type PostProjectByProjectIdMeetingagendaMeetingAndMeetingIdApiResponse =
  /** status 200 Successful response */ any;
export type PostProjectByProjectIdMeetingagendaMeetingAndMeetingIdApiArg = {
  projectId: string;
  meetingId: string;
};
export type GetProjectByProjectIdMeetingagendaAndAgendaIdApiResponse = /** status 200 Successful response */ any;
export type GetProjectByProjectIdMeetingagendaAndAgendaIdApiArg = {
  projectId: string;
  agendaId: string;
};
export type PutProjectByProjectIdMeetingagendaAndAgendaIdAttributeApiResponse =
  /** status 200 Successful response */ any;
export type PutProjectByProjectIdMeetingagendaAndAgendaIdAttributeApiArg = {
  projectId: string;
  agendaId: string;
  body: {
    attribute: string;
    value?: any;
  };
};
export type PutProjectByProjectIdMeetingagendaAndAgendaIdOrderApiResponse = /** status 200 Successful response */ any;
export type PutProjectByProjectIdMeetingagendaAndAgendaIdOrderApiArg = {
  projectId: string;
  agendaId: string;
  body: {
    order: number;
  };
};
export type PutProjectByProjectIdMeetingagendaAndAgendaIdConnectDisconnectIssueIssueIdApiResponse =
  /** status 200 Successful response */ any;
export type PutProjectByProjectIdMeetingagendaAndAgendaIdConnectDisconnectIssueIssueIdApiArg = {
  projectId: string;
  agendaId: string;
  issueId: string;
  body: {
    connectOrDisconnect: "CONNECT" | "DISCONNECT";
  };
};
export type PutProjectByProjectIdMeetingagendaTodoAndAgendaIdToggleApiResponse =
  /** status 200 Successful response */ any;
export type PutProjectByProjectIdMeetingagendaTodoAndAgendaIdToggleApiArg = {
  projectId: string;
  agendaId: string;
  body: {
    todoId: string;
    isChecked: boolean;
  };
};
export type PostProjectByProjectIdMeetingagendaTodoAndAgendaIdAddApiResponse =
  /** status 200 Successful response */ any;
export type PostProjectByProjectIdMeetingagendaTodoAndAgendaIdAddApiArg = {
  projectId: string;
  agendaId: string;
  body: {
    text: string;
  };
};
export type PutProjectByProjectIdMeetingagendaTodoAndAgendaIdUpdateApiResponse =
  /** status 200 Successful response */ any;
export type PutProjectByProjectIdMeetingagendaTodoAndAgendaIdUpdateApiArg = {
  projectId: string;
  agendaId: string;
  body: {
    todoId: string;
    text: string;
  };
};
export type DeleteProjectByProjectIdMeetingagendaTodoAndAgendaIdDeleteTodoIdApiResponse =
  /** status 200 Successful response */ any;
export type DeleteProjectByProjectIdMeetingagendaTodoAndAgendaIdDeleteTodoIdApiArg = {
  projectId: string;
  agendaId: string;
  todoId: string;
};
export type PostProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdApiResponse =
  /** status 200 Successful response */ any;
export type PostProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdApiArg = {
  projectId: string;
  agendaId: string;
  commentId: string;
};
export type DeleteProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdApiResponse =
  /** status 200 Successful response */ any;
export type DeleteProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdApiArg = {
  projectId: string;
  agendaId: string;
  commentId: string;
};
export type PutProjectByProjectIdMeetingagendaCommentAndCommentIdApiResponse =
  /** status 200 Successful response */ any;
export type PutProjectByProjectIdMeetingagendaCommentAndCommentIdApiArg = {
  projectId: string;
  commentId: string;
  body: {
    text: string;
    metadata?: {
      plainText?: string;
      mentionIdArray?: string[];
    };
  };
};
export type PutProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdReactionApiResponse =
  /** status 200 Successful response */ any;
export type PutProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdReactionApiArg = {
  projectId: string;
  agendaId: string;
  commentId: string;
  body: {
    emoji: string;
  };
};
export type PutProjectByProjectIdAgendaItemReorderConnectedIssuesApiResponse = /** status 200 Successful response */ {
  agendaItem?: any;
};
export type PutProjectByProjectIdAgendaItemReorderConnectedIssuesApiArg = {
  projectId: string;
  body: {
    agendaItemId: string;
    newOrder: string[];
  };
};
export type PostIssueboardFavoriteToggleApiResponse = /** status 200 Successful response */ {
  isFavorite: boolean;
};
export type PostIssueboardFavoriteToggleApiArg = {
  body: {
    projectId: string;
    issueboardId: string;
  };
};
export type GetIssueboardFavoritesApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: string;
  issueboard: string;
  project: string;
}[];
export type GetIssueboardFavoritesApiArg = {
  projectId: string;
};
export type PostProjectByProjectIdIssueboardApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access?: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: string[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?:
    | {
        _id: string;
        name: string;
      }
    | string;
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
};
export type PostProjectByProjectIdIssueboardApiArg = {
  projectId: string;
  body: {
    name: string;
    boardIdToCopySettingsFrom?: string;
    copyIssuesAndTasks?: boolean;
  };
};
export type GetProjectByProjectIdIssueboardApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: {
      _id: string;
      name: string;
    }[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?: {
    _id: string;
    name: string;
  };
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
}[];
export type GetProjectByProjectIdIssueboardApiArg = {
  projectId: string;
};
export type GetProjectByProjectIdIssueboardAndIssueBoardIdApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: {
      _id: string;
      name: string;
    }[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?: {
    _id: string;
    name: string;
  };
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
};
export type GetProjectByProjectIdIssueboardAndIssueBoardIdApiArg = {
  projectId: string;
  issueBoardId: string;
};
export type PostProjectByProjectIdIssueboardAndBoardIdTableTemplateApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  issueBoard: string;
  tableColumns: string[];
  tableColConfigs?: {
    colId?: string;
    orderPriority?: number;
    width?: number;
  }[];
  taskAndOrIssue?: ("TASK" | "ISSUE")[];
  filters: {
    typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
    dataField?: string;
    multiFilterValues?: string[] | object[];
    isActive?: boolean;
  }[];
  sortedCol?: {
    column?: string;
    direction?: "ASC" | "DESC";
  };
  archived?: boolean;
};
export type PostProjectByProjectIdIssueboardAndBoardIdTableTemplateApiArg = {
  projectId: string;
  boardId: string;
  body: {
    name: string;
    filters?: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
  };
};
export type DeleteProjectByProjectIdIssueboardAndBoardIdTableTemplateTemplateIdApiResponse =
  /** status 200 Successful response */ {
    acknowledged?: boolean;
    deletedCount?: number;
  };
export type DeleteProjectByProjectIdIssueboardAndBoardIdTableTemplateTemplateIdApiArg = {
  projectId: string;
  boardId: string;
  templateId: string;
};
export type PutProjectByProjectIdIssueboardAndBoardIdApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access?: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: string[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?:
    | {
        _id: string;
        name: string;
      }
    | string;
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
};
export type PutProjectByProjectIdIssueboardAndBoardIdApiArg = {
  projectId: string;
  boardId: string;
  body: {
    name?: string;
    pns?: string;
    status?: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
    showConclusion?: boolean;
    defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
    defaultTemplateId?: string;
    description?: string;
    issueNameSetting?: string;
    taskNameSetting?: string;
    dashboardSetting?: string;
    category?: string;
    bucketNameSetting?: string;
    showCompletedTodosInKanban?: boolean;
    disableDeleteIssue?: boolean;
    completedIssuesFetchLimitMonths?: number | null;
  };
};
export type PutProjectByProjectIdIssueboardAndBoardIdBucketsApiResponse = /** status 200 Successful response */ {
  _id?: string;
  value: string;
  order: number;
  status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
}[];
export type PutProjectByProjectIdIssueboardAndBoardIdBucketsApiArg = {
  projectId: string;
  boardId: string;
  body: {
    buckets: {
      _id?: string | any;
      value: string;
      order: number;
      status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    }[];
  };
};
export type PutProjectByProjectIdIssueboardAndBoardIdUsebucketsasworkflowApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    createdAt: string;
    project: string;
    name: string;
    access?: {
      /** AccessLevels */
      level: "PROJECT" | "USERS" | "GROUPS";
      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
      users: string[];
    };
    status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
    lastUpdatedBy?: {
      _id: string;
      name: string;
    };
    createdFromTemplate?: string;
    progress?: {
      percentage: number;
      color: string;
    }[];
    pns?: string;
    createdDate?: string;
    disabledColumns?: string[];
    disabledColumnsTasks?: string[];
    tableTemplates?: {
      _id: string;
      name: string;
      issueBoard: string;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    }[];
    buckets?: {
      _id?: string;
      value: string;
      order: number;
      status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    }[];
    types?: {
      _id?: string;
      name: string;
    }[];
    useBucketsAsWorkflow?: boolean;
    allFilters?: {
      dataField: string;
      options?: {
        value: string;
        label: string;
        isActive: boolean;
      }[];
      bool?: boolean;
    }[];
    showConclusion?: boolean;
    template?: {
      isTemplate: boolean;
      description: string;
      admin?: {
        _id: string;
        name: string;
      };
      status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
      approvedBy?: {
        _id: string;
        name: string;
      };
      approvalDate?: string;
      history?: {
        action:
          "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
        by: {
          _id: string;
          name: string;
        };
        date: string;
        comment: string;
      }[];
    };
    defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
    defaultTemplate?: string;
    issueNameSetting?: string;
    taskNameSetting?: string;
    dashboardSetting?: string;
    category?: string | null;
    description?: string;
    bucketNameSetting?: string;
    showCompletedTodosInKanban?: boolean;
    completedIssuesFetchLimitMonths?: number | null;
    usePredefinedTags?: boolean;
    useOnlyPredefinedTags?: boolean;
    predefinedTags?: {
      _id?: string;
      title: string;
    }[];
    madeFromTemplate?: {
      title: string;
      id?: string;
    };
    noteboardImageNodes?: {
      _id?: string;
      path: string;
      x: number;
      y: number;
      height: number;
      width: number;
    }[];
    createdBy?:
      | {
          _id: string;
          name: string;
        }
      | string;
    otherAttributesTasksConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    otherAttributesConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    risikoSection?: {
      isActive: boolean;
      enableProbabilityAfterTiltak: boolean;
      probabilites: {
        [key: string]: {
          id?: string;
          name: string;
          description: string;
          matrixValue: number;
          isActive: boolean;
          order: number;
        };
      };
      evaluationCategoriesConfig: {
        [key: string]: {
          name: string;
          description: string;
          isActive: boolean;
          type: "RISK" | "OPPORTUNITY";
          matrixConfig: {
            color: string;
          }[][];
          consequences: {
            [key: string]: {
              id?: string;
              name: string;
              description: string | null;
              matrixValue: number;
              isActive: boolean;
              order: number;
            };
          };
        };
      };
    };
    ganttVacationSettings?: {
      startDate: string;
      endDate: string;
      title: string;
    }[];
    disableDeleteIssue?: boolean;
  };
export type PutProjectByProjectIdIssueboardAndBoardIdUsebucketsasworkflowApiArg = {
  projectId: string;
  boardId: string;
  body: {
    useBucketsAsWorkflow: boolean;
  };
};
export type PutProjectByProjectIdIssueboardAndBoardIdTypesApiResponse = /** status 200 Successful response */ {
  _id?: string;
  name: string;
}[];
export type PutProjectByProjectIdIssueboardAndBoardIdTypesApiArg = {
  projectId: string;
  boardId: string;
  body: {
    types: {
      _id?: string | any;
      name: string;
    }[];
  };
};
export type PutProjectByProjectIdIssueboardAndBoardIdAttributeApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access?: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: string[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?:
    | {
        _id: string;
        name: string;
      }
    | string;
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
};
export type PutProjectByProjectIdIssueboardAndBoardIdAttributeApiArg = {
  projectId: string;
  boardId: string;
  body: {
    attribute: string;
    newValue?: any;
  };
};
export type GetProjectByProjectIdIssueboardTemplateAllApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access?: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: string[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?:
    | {
        _id: string;
        name: string;
      }
    | string;
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
}[];
export type GetProjectByProjectIdIssueboardTemplateAllApiArg = {
  projectId: string;
};
export type PostProjectByProjectIdIssueboardImportExcelApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access?: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: string[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?:
    | {
        _id: string;
        name: string;
      }
    | string;
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
};
export type PostProjectByProjectIdIssueboardImportExcelApiArg = {
  projectId: string;
  body: {
    titleAndDescriptions: {
      title?: string;
      description?: string;
    }[];
    nameOfBoard: string;
  };
};
export type PutProjectByProjectIdIssueboardAndBoardIdAccessApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access?: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: string[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?:
    | {
        _id: string;
        name: string;
      }
    | string;
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
};
export type PutProjectByProjectIdIssueboardAndBoardIdAccessApiArg = {
  projectId: string;
  boardId: string;
  body: {
    access: {
      /** AccessLevels */
      level: "PROJECT" | "USERS" | "GROUPS";
      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
      users: (string | any)[];
    };
  };
};
export type PutProjectByProjectIdIssueboardAndBoardIdDisabledColumnsApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    createdAt: string;
    project: string;
    name: string;
    access?: {
      /** AccessLevels */
      level: "PROJECT" | "USERS" | "GROUPS";
      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
      users: string[];
    };
    status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
    lastUpdatedBy?: {
      _id: string;
      name: string;
    };
    createdFromTemplate?: string;
    progress?: {
      percentage: number;
      color: string;
    }[];
    pns?: string;
    createdDate?: string;
    disabledColumns?: string[];
    disabledColumnsTasks?: string[];
    tableTemplates?: {
      _id: string;
      name: string;
      issueBoard: string;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    }[];
    buckets?: {
      _id?: string;
      value: string;
      order: number;
      status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    }[];
    types?: {
      _id?: string;
      name: string;
    }[];
    useBucketsAsWorkflow?: boolean;
    allFilters?: {
      dataField: string;
      options?: {
        value: string;
        label: string;
        isActive: boolean;
      }[];
      bool?: boolean;
    }[];
    showConclusion?: boolean;
    template?: {
      isTemplate: boolean;
      description: string;
      admin?: {
        _id: string;
        name: string;
      };
      status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
      approvedBy?: {
        _id: string;
        name: string;
      };
      approvalDate?: string;
      history?: {
        action:
          "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
        by: {
          _id: string;
          name: string;
        };
        date: string;
        comment: string;
      }[];
    };
    defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
    defaultTemplate?: string;
    issueNameSetting?: string;
    taskNameSetting?: string;
    dashboardSetting?: string;
    category?: string | null;
    description?: string;
    bucketNameSetting?: string;
    showCompletedTodosInKanban?: boolean;
    completedIssuesFetchLimitMonths?: number | null;
    usePredefinedTags?: boolean;
    useOnlyPredefinedTags?: boolean;
    predefinedTags?: {
      _id?: string;
      title: string;
    }[];
    madeFromTemplate?: {
      title: string;
      id?: string;
    };
    noteboardImageNodes?: {
      _id?: string;
      path: string;
      x: number;
      y: number;
      height: number;
      width: number;
    }[];
    createdBy?:
      | {
          _id: string;
          name: string;
        }
      | string;
    otherAttributesTasksConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    otherAttributesConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    risikoSection?: {
      isActive: boolean;
      enableProbabilityAfterTiltak: boolean;
      probabilites: {
        [key: string]: {
          id?: string;
          name: string;
          description: string;
          matrixValue: number;
          isActive: boolean;
          order: number;
        };
      };
      evaluationCategoriesConfig: {
        [key: string]: {
          name: string;
          description: string;
          isActive: boolean;
          type: "RISK" | "OPPORTUNITY";
          matrixConfig: {
            color: string;
          }[][];
          consequences: {
            [key: string]: {
              id?: string;
              name: string;
              description: string | null;
              matrixValue: number;
              isActive: boolean;
              order: number;
            };
          };
        };
      };
    };
    ganttVacationSettings?: {
      startDate: string;
      endDate: string;
      title: string;
    }[];
    disableDeleteIssue?: boolean;
  };
export type PutProjectByProjectIdIssueboardAndBoardIdDisabledColumnsApiArg = {
  projectId: string;
  boardId: string;
  body: {
    disabledColumns: string[];
    taskOrIssue?: "ISSUE" | "TASK";
  };
};
export type PostProjectByProjectIdIssueboardOtherAttributesConfigAddApiResponse =
  /** status 200 Successful response */ {
    success: true;
  };
export type PostProjectByProjectIdIssueboardOtherAttributesConfigAddApiArg = {
  projectId: string;
  body: {
    issueBoardId: string | any;
    otherAttributesConfigItemProps: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string | any;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
    taskOrIssue: "TASK" | "ISSUE";
  };
};
export type PostProjectByProjectIdIssueboardOtherAttributesConfigUpdateorderApiResponse =
  /** status 200 Successful response */ {
    success: true;
  };
export type PostProjectByProjectIdIssueboardOtherAttributesConfigUpdateorderApiArg = {
  projectId: string;
  body: {
    issueBoardId: string | any;
    idsInOrder: string[];
    taskOrIssue: "TASK" | "ISSUE";
  };
};
export type PostProjectByProjectIdIssueboardUseonlypredefinedtagsUpdateApiResponse =
  /** status 200 Successful response */ {
    success: true;
    issueBoardId: string;
    useOnlyPredefinedTags?: boolean;
  };
export type PostProjectByProjectIdIssueboardUseonlypredefinedtagsUpdateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    useOnlyPredefinedTags: boolean;
  };
};
export type PostProjectByProjectIdIssueboardRisikoIsactiveApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access?: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: string[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?:
    | {
        _id: string;
        name: string;
      }
    | string;
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
};
export type PostProjectByProjectIdIssueboardRisikoIsactiveApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    isActive: boolean;
  };
};
export type PostProjectByProjectIdIssueboardRisikoProbabilityIsactiveaftertiltakApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    createdAt: string;
    project: string;
    name: string;
    access?: {
      /** AccessLevels */
      level: "PROJECT" | "USERS" | "GROUPS";
      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
      users: string[];
    };
    status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
    lastUpdatedBy?: {
      _id: string;
      name: string;
    };
    createdFromTemplate?: string;
    progress?: {
      percentage: number;
      color: string;
    }[];
    pns?: string;
    createdDate?: string;
    disabledColumns?: string[];
    disabledColumnsTasks?: string[];
    tableTemplates?: {
      _id: string;
      name: string;
      issueBoard: string;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    }[];
    buckets?: {
      _id?: string;
      value: string;
      order: number;
      status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    }[];
    types?: {
      _id?: string;
      name: string;
    }[];
    useBucketsAsWorkflow?: boolean;
    allFilters?: {
      dataField: string;
      options?: {
        value: string;
        label: string;
        isActive: boolean;
      }[];
      bool?: boolean;
    }[];
    showConclusion?: boolean;
    template?: {
      isTemplate: boolean;
      description: string;
      admin?: {
        _id: string;
        name: string;
      };
      status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
      approvedBy?: {
        _id: string;
        name: string;
      };
      approvalDate?: string;
      history?: {
        action:
          "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
        by: {
          _id: string;
          name: string;
        };
        date: string;
        comment: string;
      }[];
    };
    defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
    defaultTemplate?: string;
    issueNameSetting?: string;
    taskNameSetting?: string;
    dashboardSetting?: string;
    category?: string | null;
    description?: string;
    bucketNameSetting?: string;
    showCompletedTodosInKanban?: boolean;
    completedIssuesFetchLimitMonths?: number | null;
    usePredefinedTags?: boolean;
    useOnlyPredefinedTags?: boolean;
    predefinedTags?: {
      _id?: string;
      title: string;
    }[];
    madeFromTemplate?: {
      title: string;
      id?: string;
    };
    noteboardImageNodes?: {
      _id?: string;
      path: string;
      x: number;
      y: number;
      height: number;
      width: number;
    }[];
    createdBy?:
      | {
          _id: string;
          name: string;
        }
      | string;
    otherAttributesTasksConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    otherAttributesConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    risikoSection?: {
      isActive: boolean;
      enableProbabilityAfterTiltak: boolean;
      probabilites: {
        [key: string]: {
          id?: string;
          name: string;
          description: string;
          matrixValue: number;
          isActive: boolean;
          order: number;
        };
      };
      evaluationCategoriesConfig: {
        [key: string]: {
          name: string;
          description: string;
          isActive: boolean;
          type: "RISK" | "OPPORTUNITY";
          matrixConfig: {
            color: string;
          }[][];
          consequences: {
            [key: string]: {
              id?: string;
              name: string;
              description: string | null;
              matrixValue: number;
              isActive: boolean;
              order: number;
            };
          };
        };
      };
    };
    ganttVacationSettings?: {
      startDate: string;
      endDate: string;
      title: string;
    }[];
    disableDeleteIssue?: boolean;
  };
export type PostProjectByProjectIdIssueboardRisikoProbabilityIsactiveaftertiltakApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    isActive: boolean;
  };
};
export type PostProjectByProjectIdIssueboardRisikoProbabilityUpdateApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access?: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: string[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates?: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters?: {
    dataField: string;
    options?: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion?: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string | null;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  completedIssuesFetchLimitMonths?: number | null;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id?: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy?:
    | {
        _id: string;
        name: string;
      }
    | string;
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id?: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
};
export type PostProjectByProjectIdIssueboardRisikoProbabilityUpdateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    probabilities: {
      id?: string;
      name: string;
      description: string;
      matrixValue: number;
      isActive: boolean;
      order: number;
    }[];
  };
};
export type PostProjectByProjectIdIssueboardRisikoEvaluationcategoryAddApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    createdAt: string;
    project: string;
    name: string;
    access?: {
      /** AccessLevels */
      level: "PROJECT" | "USERS" | "GROUPS";
      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
      users: string[];
    };
    status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
    lastUpdatedBy?: {
      _id: string;
      name: string;
    };
    createdFromTemplate?: string;
    progress?: {
      percentage: number;
      color: string;
    }[];
    pns?: string;
    createdDate?: string;
    disabledColumns?: string[];
    disabledColumnsTasks?: string[];
    tableTemplates?: {
      _id: string;
      name: string;
      issueBoard: string;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    }[];
    buckets?: {
      _id?: string;
      value: string;
      order: number;
      status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    }[];
    types?: {
      _id?: string;
      name: string;
    }[];
    useBucketsAsWorkflow?: boolean;
    allFilters?: {
      dataField: string;
      options?: {
        value: string;
        label: string;
        isActive: boolean;
      }[];
      bool?: boolean;
    }[];
    showConclusion?: boolean;
    template?: {
      isTemplate: boolean;
      description: string;
      admin?: {
        _id: string;
        name: string;
      };
      status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
      approvedBy?: {
        _id: string;
        name: string;
      };
      approvalDate?: string;
      history?: {
        action:
          "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
        by: {
          _id: string;
          name: string;
        };
        date: string;
        comment: string;
      }[];
    };
    defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
    defaultTemplate?: string;
    issueNameSetting?: string;
    taskNameSetting?: string;
    dashboardSetting?: string;
    category?: string | null;
    description?: string;
    bucketNameSetting?: string;
    showCompletedTodosInKanban?: boolean;
    completedIssuesFetchLimitMonths?: number | null;
    usePredefinedTags?: boolean;
    useOnlyPredefinedTags?: boolean;
    predefinedTags?: {
      _id?: string;
      title: string;
    }[];
    madeFromTemplate?: {
      title: string;
      id?: string;
    };
    noteboardImageNodes?: {
      _id?: string;
      path: string;
      x: number;
      y: number;
      height: number;
      width: number;
    }[];
    createdBy?:
      | {
          _id: string;
          name: string;
        }
      | string;
    otherAttributesTasksConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    otherAttributesConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    risikoSection?: {
      isActive: boolean;
      enableProbabilityAfterTiltak: boolean;
      probabilites: {
        [key: string]: {
          id?: string;
          name: string;
          description: string;
          matrixValue: number;
          isActive: boolean;
          order: number;
        };
      };
      evaluationCategoriesConfig: {
        [key: string]: {
          name: string;
          description: string;
          isActive: boolean;
          type: "RISK" | "OPPORTUNITY";
          matrixConfig: {
            color: string;
          }[][];
          consequences: {
            [key: string]: {
              id?: string;
              name: string;
              description: string | null;
              matrixValue: number;
              isActive: boolean;
              order: number;
            };
          };
        };
      };
    };
    ganttVacationSettings?: {
      startDate: string;
      endDate: string;
      title: string;
    }[];
    disableDeleteIssue?: boolean;
  };
export type PostProjectByProjectIdIssueboardRisikoEvaluationcategoryAddApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    name: string;
  };
};
export type PostProjectByProjectIdIssueboardRisikoEvaluationcategoryUpdateApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    createdAt: string;
    project: string;
    name: string;
    access?: {
      /** AccessLevels */
      level: "PROJECT" | "USERS" | "GROUPS";
      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
      users: string[];
    };
    status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
    lastUpdatedBy?: {
      _id: string;
      name: string;
    };
    createdFromTemplate?: string;
    progress?: {
      percentage: number;
      color: string;
    }[];
    pns?: string;
    createdDate?: string;
    disabledColumns?: string[];
    disabledColumnsTasks?: string[];
    tableTemplates?: {
      _id: string;
      name: string;
      issueBoard: string;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    }[];
    buckets?: {
      _id?: string;
      value: string;
      order: number;
      status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    }[];
    types?: {
      _id?: string;
      name: string;
    }[];
    useBucketsAsWorkflow?: boolean;
    allFilters?: {
      dataField: string;
      options?: {
        value: string;
        label: string;
        isActive: boolean;
      }[];
      bool?: boolean;
    }[];
    showConclusion?: boolean;
    template?: {
      isTemplate: boolean;
      description: string;
      admin?: {
        _id: string;
        name: string;
      };
      status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
      approvedBy?: {
        _id: string;
        name: string;
      };
      approvalDate?: string;
      history?: {
        action:
          "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
        by: {
          _id: string;
          name: string;
        };
        date: string;
        comment: string;
      }[];
    };
    defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
    defaultTemplate?: string;
    issueNameSetting?: string;
    taskNameSetting?: string;
    dashboardSetting?: string;
    category?: string | null;
    description?: string;
    bucketNameSetting?: string;
    showCompletedTodosInKanban?: boolean;
    completedIssuesFetchLimitMonths?: number | null;
    usePredefinedTags?: boolean;
    useOnlyPredefinedTags?: boolean;
    predefinedTags?: {
      _id?: string;
      title: string;
    }[];
    madeFromTemplate?: {
      title: string;
      id?: string;
    };
    noteboardImageNodes?: {
      _id?: string;
      path: string;
      x: number;
      y: number;
      height: number;
      width: number;
    }[];
    createdBy?:
      | {
          _id: string;
          name: string;
        }
      | string;
    otherAttributesTasksConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    otherAttributesConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    risikoSection?: {
      isActive: boolean;
      enableProbabilityAfterTiltak: boolean;
      probabilites: {
        [key: string]: {
          id?: string;
          name: string;
          description: string;
          matrixValue: number;
          isActive: boolean;
          order: number;
        };
      };
      evaluationCategoriesConfig: {
        [key: string]: {
          name: string;
          description: string;
          isActive: boolean;
          type: "RISK" | "OPPORTUNITY";
          matrixConfig: {
            color: string;
          }[][];
          consequences: {
            [key: string]: {
              id?: string;
              name: string;
              description: string | null;
              matrixValue: number;
              isActive: boolean;
              order: number;
            };
          };
        };
      };
    };
    ganttVacationSettings?: {
      startDate: string;
      endDate: string;
      title: string;
    }[];
    disableDeleteIssue?: boolean;
  };
export type PostProjectByProjectIdIssueboardRisikoEvaluationcategoryUpdateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    prop: string;
    id: string;
    newValue:
      | string
      | boolean
      | {
          id: string;
          name: string;
          description: string | null;
          matrixValue: number;
          isActive: boolean;
          order: number;
        }[]
      | {
          color: string;
        }[][];
  };
};
export type PostProjectByProjectIdIssueboardMoveIssueboardToProjectApiResponse =
  /** status 200 Successful response */ any;
export type PostProjectByProjectIdIssueboardMoveIssueboardToProjectApiArg = {
  projectId: string;
  body: {
    maconomyProjectNo: number;
    issueBoardId: string;
  };
};
export type PostProjectByProjectIdIssueboardOtherAttributesConfigGetSumsByFormulaApiResponse =
  /** status 200 Successful response */ {
    [key: string]: {
      issueCounts: {
        [key: string]: number;
      };
    }[];
  };
export type PostProjectByProjectIdIssueboardOtherAttributesConfigGetSumsByFormulaApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
  };
};
export type PostProjectByProjectIdIssueboardNoteboardImageNodeAddApiResponse = /** status 200 Successful response */ {
  _id?: string;
  path: string;
  x: number;
  y: number;
  height: number;
  width: number;
};
export type PostProjectByProjectIdIssueboardNoteboardImageNodeAddApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    noteboardImageNode: {
      _id?: string | any;
      path: string;
      x: number;
      y: number;
      height: number;
      width: number;
    };
  };
};
export type PostProjectByProjectIdIssueboardNoteboardImageNodeUpdateApiResponse =
  /** status 200 Successful response */ {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  };
export type PostProjectByProjectIdIssueboardNoteboardImageNodeUpdateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    noteboardImageNode: {
      _id?: string | any;
      path: string;
      x: number;
      y: number;
      height: number;
      width: number;
    };
  };
};
export type PostProjectByProjectIdIssueboardNoteboardImageNodeDeleteApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    createdAt: string;
    project: string;
    name: string;
    access?: {
      /** AccessLevels */
      level: "PROJECT" | "USERS" | "GROUPS";
      groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
      users: string[];
    };
    status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE" | "COMPLETED";
    lastUpdatedBy?: {
      _id: string;
      name: string;
    };
    createdFromTemplate?: string;
    progress?: {
      percentage: number;
      color: string;
    }[];
    pns?: string;
    createdDate?: string;
    disabledColumns?: string[];
    disabledColumnsTasks?: string[];
    tableTemplates?: {
      _id: string;
      name: string;
      issueBoard: string;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    }[];
    buckets?: {
      _id?: string;
      value: string;
      order: number;
      status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    }[];
    types?: {
      _id?: string;
      name: string;
    }[];
    useBucketsAsWorkflow?: boolean;
    allFilters?: {
      dataField: string;
      options?: {
        value: string;
        label: string;
        isActive: boolean;
      }[];
      bool?: boolean;
    }[];
    showConclusion?: boolean;
    template?: {
      isTemplate: boolean;
      description: string;
      admin?: {
        _id: string;
        name: string;
      };
      status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
      approvedBy?: {
        _id: string;
        name: string;
      };
      approvalDate?: string;
      history?: {
        action:
          "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
        by: {
          _id: string;
          name: string;
        };
        date: string;
        comment: string;
      }[];
    };
    defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
    defaultTemplate?: string;
    issueNameSetting?: string;
    taskNameSetting?: string;
    dashboardSetting?: string;
    category?: string | null;
    description?: string;
    bucketNameSetting?: string;
    showCompletedTodosInKanban?: boolean;
    completedIssuesFetchLimitMonths?: number | null;
    usePredefinedTags?: boolean;
    useOnlyPredefinedTags?: boolean;
    predefinedTags?: {
      _id?: string;
      title: string;
    }[];
    madeFromTemplate?: {
      title: string;
      id?: string;
    };
    noteboardImageNodes?: {
      _id?: string;
      path: string;
      x: number;
      y: number;
      height: number;
      width: number;
    }[];
    createdBy?:
      | {
          _id: string;
          name: string;
        }
      | string;
    otherAttributesTasksConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    otherAttributesConfig?: {
      [key: string]: {
        typeOfValue:
          "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
        dropdownOptionType?: "STRING" | "NUMBER";
        tableOptions?: {
          _id?: string;
          value: string | number;
          description: string | null;
          color?: string;
        }[];
        defaultDropdownValue?: (string | number) | null;
        defaultTextValue?: string | null;
        defaultNumberValue?: number | null;
        allowMultipleSelectionsInDropdown?: boolean;
        label: string;
        labelColor?: string;
        section: string;
        description: string;
        order: number;
        isActive: boolean;
        formula?: {
          nrOfCharsInCounter?: number;
          deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
          counterMode?: "AUTO" | "MANUAL";
          manualCounter?: {
            enforceUniqueWithinGroup?: boolean;
          };
          confArr: {
            id?: string;
            type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
            value: string;
          }[];
        };
        mathFormula?: {
          expression?: string;
          variables?: string[];
        };
        locked?: boolean;
      };
    };
    risikoSection?: {
      isActive: boolean;
      enableProbabilityAfterTiltak: boolean;
      probabilites: {
        [key: string]: {
          id?: string;
          name: string;
          description: string;
          matrixValue: number;
          isActive: boolean;
          order: number;
        };
      };
      evaluationCategoriesConfig: {
        [key: string]: {
          name: string;
          description: string;
          isActive: boolean;
          type: "RISK" | "OPPORTUNITY";
          matrixConfig: {
            color: string;
          }[][];
          consequences: {
            [key: string]: {
              id?: string;
              name: string;
              description: string | null;
              matrixValue: number;
              isActive: boolean;
              order: number;
            };
          };
        };
      };
    };
    ganttVacationSettings?: {
      startDate: string;
      endDate: string;
      title: string;
    }[];
    disableDeleteIssue?: boolean;
  };
export type PostProjectByProjectIdIssueboardNoteboardImageNodeDeleteApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    noteboardImageNodeId?: string | any;
  };
};
export type PutProjectByProjectIdGanttVacationsApiResponse = /** status 200 Successful response */ {
  success: boolean;
};
export type PutProjectByProjectIdGanttVacationsApiArg = {
  projectId: string;
  body: {
    issueboardId: string;
    ganttVacationSettings: {
      startDate: string;
      endDate: string;
      title: string;
    }[];
  };
};
export type PostProjectByProjectIdIssueboardOtherAttributesConfigUpdateApiResponse =
  /** status 200 Successful response */ {
    success: true;
    issueBoardId: string;
    otherAttributeConfigKey: string;
    otherAttributeConfigItemProps: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
    taskOrIssue: "TASK" | "ISSUE";
  };
export type PostProjectByProjectIdIssueboardOtherAttributesConfigUpdateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string | any;
    otherAttributeConfigItemProps: {
      typeOfValue:
        "STRING" | "MULTILINESTRING" | "NUMBER" | "DATE" | "BOOLEAN" | "DROPDOWN" | "FORMULA" | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      defaultDropdownValue?: (string | number) | null;
      defaultTextValue?: string | null;
      defaultNumberValue?: number | null;
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        counterMode?: "AUTO" | "MANUAL";
        manualCounter?: {
          enforceUniqueWithinGroup?: boolean;
        };
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
    otherAttributeConfigKey: string;
    taskOrIssue: "TASK" | "ISSUE";
  };
};
export type PatchBoardsTemplateActionApiResponse = /** status 200 Successful response */ {
  boardId: string;
  template: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status?: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history?: {
      action:
        "IKKE AKTIV" | "AKTIV" | "CREATED" | "SET_TO_REVIEW" | "UNDER_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
};
export type PatchBoardsTemplateActionApiArg = {
  body: {
    projectId: string;
    boardId: string;
    action: "IKKE AKTIV" | "AKTIV" | "CREATED" | "UNDER_REVIEW" | "APPROVED";
    comment?: string;
  };
};
export type PostProjectByProjectIdIssueboardPredefinedtagsUpdateApiResponse = /** status 200 Successful response */ {
  success: true;
  issueBoardId: string;
  tags: {
    _id?: string;
    title: string;
  }[];
};
export type PostProjectByProjectIdIssueboardPredefinedtagsUpdateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    tags: {
      _id?: string | any;
      title: string;
    }[];
  };
};
export type PostProjectByProjectIdIssueboardUsepredefinedtagsUpdateApiResponse = /** status 200 Successful response */ {
  success: true;
  issueBoardId: string;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
};
export type PostProjectByProjectIdIssueboardUsepredefinedtagsUpdateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    useCustomTags: boolean;
  };
};
export type GetProjectByProjectIdIssueLogsApiResponse = /** status 200 Successful response */ {
  items: {
    _id: string;
    project: string;
    board: string;
    issueId: string;
    taskOrIssue: "ISSUE" | "TASK";
    column: string;
    oldValue?: string;
    newValue: string;
    userName: string;
    updatedAt: string;
    createdAt: string;
  }[];
  totalCount?: number;
};
export type GetProjectByProjectIdIssueLogsApiArg = {
  projectId: string;
  boardId: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  limit?: number;
  page?: number;
  includeTotalCount?: "true" | "false";
};
export type GetMcbimCeilingsOnFloorApiResponse = /** status 200 Successful response */ {
  globalId: string;
  ceilingGrids?: {
    lines: number[][][];
    /** 3D point represented as [x, y, z] */
    intersectionPoint?: number[];
    /** 3D point represented as [x, y, z] */
    direction?: number[];
    tileSize?: number[];
    interiorLines?: number[][][];
    edgePolygon?: number[][];
    floorHeightMm?: number;
    floorHeightM?: number;
    worldHeightMm?: number;
    worldHeightM?: number;
  }[];
}[];
export type GetMcbimCeilingsOnFloorApiArg = {
  projectNo: number;
  floorName: string;
};
export type GetMcbimFragsApiResponse = /** status 200 Successful response */ {
  projectNo: number;
  containerName: string;
  ttlMinutes: number;
  files: {
    fileName: string;
    frag: {
      blobName: string;
      url: string;
      expiresAt: string;
      sizeBytes?: number;
    };
    manifest: {
      blobName: string;
      url: string;
      expiresAt: string;
      sizeBytes?: number;
    };
  }[];
};
export type GetMcbimFragsApiArg = {
  projectNo: number;
};
export type GetMcbimFloorsApiResponse = /** status 200 Successful response */ {
  name: string;
  globalId: string;
  elevation?: number;
  spaceCount: number;
}[];
export type GetMcbimFloorsApiArg = {
  projectNo: number;
};
export type GetMcbimFurnitureAndWallsOnFloorApiResponse = /** status 200 Successful response */ {
  _id: string;
  name?: string;
  longName?: string;
  fileName?: string;
  instanceClass:
    | "IfcFurniture"
    | "IfcFurnishingElement"
    | "IfcCurtainWall"
    | "IfcWall"
    | "IfcWallElementedCase"
    | "IfcWallStandardCase"
    | "IfcWindow";
  bbox?: number[][];
}[];
export type GetMcbimFurnitureAndWallsOnFloorApiArg = {
  projectNo: number;
  floorName: string;
};
export type GetMcbimItemsInSpaceApiResponse = /** status 200 Successful response */ {
  _id?: any;
  globalId: string;
  buildingStory: {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
  } | null;
  instanceClass: string;
  expressId: number;
  predefinedType?: (string | number) | null;
  geometry?: {
    polygon2d?: number[][];
    bbox2d?: number[][];
    centerPoint2d?: number[];
    Obb3DWorldMmList?: {
      centerMm: {
        x: number;
        y: number;
        z: number;
      };
      centerM?: {
        x: number;
        y: number;
        z: number;
      };
      axisA: {
        x: number;
        y: number;
        z: number;
      };
      axisB: {
        x: number;
        y: number;
        z: number;
      };
      axisC: {
        x: number;
        y: number;
        z: number;
      };
      extentAMm: number;
      extentBMm: number;
      extentCMm: number;
      extentAM?: number;
      extentBM?: number;
      extentCM?: number;
    }[];
    zWorldMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zWorldM?: {
      bottom: number;
      middle: number;
      top: number;
    };
    heightMm?: number;
    heightM?: number;
    floorZWorldMm?: number;
    floorZWorldM?: number;
    floorSource?: "buildingStorey" | "unknown";
    zRelMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zRelM?: {
      bottom: number;
      middle: number;
      top: number;
    };
  };
  geometryVersion?: number;
  fileAttr1?: string;
  fileAttr2?: string;
  fileAttr3?: string;
  fileAttr4?: string;
  fileFolderId?: string;
  fileIfcSchema: string;
  fileIsLatest: boolean;
  fileLastModifiedBy: string;
  fileName: string;
  filePath: string;
  fileStorageId: string;
  fileUploadedAt: string;
  includedMaterials?: {
    [key: string]: boolean;
  };
  insertedAt: string;
  longName?: string;
  materials?: {
    [key: string]: number;
  }[];
  name: string;
  description: string;
  building?: string;
  job: {
    jobId?: any;
    createdAt: string;
  };
  bbox?: number[][];
  polygon?: number[][];
  centerPoint?: number[];
  psets: {
    [key: string]: {
      [key: string]: (string | number) | boolean;
    };
  };
  type: {
    globalId: string;
    name: string;
    typeClass: string;
    predefinedType?: (string | number) | null;
  } | null;
  ceilingGrids?: {
    lines: number[][][];
    /** 3D point represented as [x, y, z] */
    intersectionPoint?: number[];
    /** 3D point represented as [x, y, z] */
    direction?: number[];
    tileSize?: number[];
    interiorLines?: number[][][];
    edgePolygon?: number[][];
    floorHeightMm?: number;
    floorHeightM?: number;
    worldHeightMm?: number;
    worldHeightM?: number;
  }[];
  error2d?: {
    message: string;
    stack: string;
  };
  geometryExtractedFromTypeGlobalId?: string;
  elementMaterials?: {
    name: string;
    thickness: number;
    calculatedVolume?: number;
  }[];
  primarySystem?: {
    globalId: string;
    name: string;
    typeClass: string;
    predefinedType?: (string | number) | null;
  } | null;
  systems?: {
    globalId: string;
    name: string;
    typeClass: string;
    predefinedType?: (string | number) | null;
  }[];
}[];
export type GetMcbimItemsInSpaceApiArg = {
  projectId: string;
  spaceId?: string;
  spaceName?: string;
};
export type GetMcbimSpaceApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  longName?: string;
  polygon?: number[][];
  ceilingGrids?: {
    lines: number[][][];
    /** 3D point represented as [x, y, z] */
    intersectionPoint?: number[];
    /** 3D point represented as [x, y, z] */
    direction?: number[];
    tileSize?: number[];
    interiorLines?: number[][][];
    edgePolygon?: number[][];
    floorHeightMm?: number;
    floorHeightM?: number;
    worldHeightMm?: number;
    worldHeightM?: number;
  }[];
};
export type GetMcbimSpaceApiArg = {
  projectId: string;
  roomNumber: string;
};
export type GetMcbimSpacesApiResponse = /** status 200 Successful response */ {
  spaceDbId?: any;
  globalId: string;
  roomNumber: string;
  roomName: string;
  floor: string;
  building: string;
  ifcFile: string;
  pns?: string | null;
}[];
export type GetMcbimSpacesApiArg = {
  projectId: string;
};
export type GetMcbimSpacesOnFloorApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  longName?: string;
  fileName: string;
  polygon?: number[][];
  ceilingGrids?: {
    lines: number[][][];
    /** 3D point represented as [x, y, z] */
    intersectionPoint?: number[];
    /** 3D point represented as [x, y, z] */
    direction?: number[];
    tileSize?: number[];
    interiorLines?: number[][][];
    edgePolygon?: number[][];
    floorHeightMm?: number;
    floorHeightM?: number;
    worldHeightMm?: number;
    worldHeightM?: number;
  }[];
}[];
export type GetMcbimSpacesOnFloorApiArg = {
  projectNo: number;
  floorName: string;
};
export type GetEmailsTemplatesApiResponse = /** status 200 Successful response */ {
  collection: "emails";
  templates: {
    templateKey:
      "landing-page-inquiry" | "meeting-agenda" | "project-invite" | "reset-password" | "task-notify" | "test-mail";
    files: {
      filename:
        | "html.hbs"
        | "html.hbs.json"
        | "html.handlebars.json"
        | "styles.css"
        | "subject.html"
        | "subject.pug"
        | "text.pug"
        | "html.pug";
      exists: boolean;
      contentType: string | null;
      sizeBytes: number | null;
      lastModifiedIso: string | null;
      etag: string | null;
    }[];
    allRequiredFilesExist: boolean;
  }[];
};
export type GetEmailsTemplatesApiArg = void;
export type GetEmailsTemplatesDownloadApiResponse = /** status 200 Successful response */ {
  collection: "emails";
  templateKey:
    "landing-page-inquiry" | "meeting-agenda" | "project-invite" | "reset-password" | "task-notify" | "test-mail";
  contentType: "application/zip";
  filename: string;
  base64: string;
  sizeBytes: number;
  etag: string | null;
  lastModifiedIso: string | null;
};
export type GetEmailsTemplatesDownloadApiArg = {
  templateKey:
    "landing-page-inquiry" | "meeting-agenda" | "project-invite" | "reset-password" | "task-notify" | "test-mail";
};
export type PostEmailsTemplatesUploadZipApiResponse = /** status 200 Successful response */ {
  collection: "emails";
  templateKey:
    "landing-page-inquiry" | "meeting-agenda" | "project-invite" | "reset-password" | "task-notify" | "test-mail";
  uploaded: {
    filename:
      | "html.hbs"
      | "html.hbs.json"
      | "html.handlebars.json"
      | "styles.css"
      | "subject.html"
      | "subject.pug"
      | "text.pug"
      | "html.pug";
    blobName: string;
    etag?: string;
    sizeBytes: number;
  }[];
};
export type PostEmailsTemplatesUploadZipApiArg = {
  body: {
    templateKey:
      "landing-page-inquiry" | "meeting-agenda" | "project-invite" | "reset-password" | "task-notify" | "test-mail";
    file: {
      filename: string;
      contentType: "application/zip";
      base64: string;
    };
  };
};
export type GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiResponse = /** status 200 Successful response */ {
  _id?: any;
  dashboard?: any;
  project?: any;
  text: string;
  deleted: boolean;
  createdBy?: any;
  createdByUser: {
    _id: string;
    name: string;
  };
  createdAt: string;
  reactions?: {
    user: {
      _id: string;
      name: string;
    };
    date: string;
    emoji: string;
  }[];
  replies: {
    _id?: any;
    text: string;
    deleted: boolean;
    createdBy?: any;
    createdByUser: {
      _id: string;
      name: string;
    };
    createdAt: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
}[];
export type GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiArg = {
  projectId: string;
  dashboardId: string;
};
export type PostProjectByProjectIdProjectdashboardNewsApiResponse = /** status 200 Successful response */ {
  _id?: any;
  dashboard?: any;
  project?: any;
  text: string;
  deleted: boolean;
  createdBy?: any;
  createdByUser: {
    _id: string;
    name: string;
  };
  createdAt: string;
  reactions?: {
    user: {
      _id: string;
      name: string;
    };
    date: string;
    emoji: string;
  }[];
  replies: {
    _id?: any;
    text: string;
    deleted: boolean;
    createdBy?: any;
    createdByUser: {
      _id: string;
      name: string;
    };
    createdAt: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
};
export type PostProjectByProjectIdProjectdashboardNewsApiArg = {
  projectId: string;
  body: {
    newsItem: {
      dashboardId: string;
      text: string;
      deleted?: boolean;
      metadata?: {
        plainText?: string;
        mentionIdArray?: (string | any)[];
      };
    };
  };
};
export type PutProjectByProjectIdProjectdashboardNewsAndNewsItemIdApiResponse = /** status 200 Successful response */ {
  _id?: any;
  dashboard?: any;
  project?: any;
  text: string;
  deleted: boolean;
  createdBy?: any;
  createdByUser: {
    _id: string;
    name: string;
  };
  createdAt: string;
  reactions?: {
    user: {
      _id: string;
      name: string;
    };
    date: string;
    emoji: string;
  }[];
  replies: {
    _id?: any;
    text: string;
    deleted: boolean;
    createdBy?: any;
    createdByUser: {
      _id: string;
      name: string;
    };
    createdAt: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
};
export type PutProjectByProjectIdProjectdashboardNewsAndNewsItemIdApiArg = {
  projectId: string;
  newsItemId: string;
  body: {
    newsItem: {
      dashboard: string;
      text?: string;
      deleted?: boolean;
      metadata?: {
        plainText?: string;
        mentionIdArray?: (string | any)[];
      };
      reply?: {
        _id?: string;
        text?: string;
        deleted?: boolean;
        metadata?: {
          plainText?: string;
          mentionIdArray?: (string | any)[];
        };
      };
    };
  };
};
export type PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    dashboard?: any;
    project?: any;
    text: string;
    deleted: boolean;
    createdBy?: any;
    createdByUser: {
      _id: string;
      name: string;
    };
    createdAt: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
    replies: {
      _id?: any;
      text: string;
      deleted: boolean;
      createdBy?: any;
      createdByUser: {
        _id: string;
        name: string;
      };
      createdAt: string;
      reactions?: {
        user: {
          _id: string;
          name: string;
        };
        date: string;
        emoji: string;
      }[];
    }[];
  };
export type PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiArg = {
  projectId: string;
  dashboardId: string;
  body: {
    commentId: string;
    replyId?: string;
    emoji: string;
  };
};
export type PostProjectByProjectIdProjectdashboardNewsSearchApiResponse = /** status 200 Successful response */ {
  _id?: any;
  dashboard?: any;
  project?: any;
  text: string;
  deleted: boolean;
  createdBy?: any;
  createdByUser: {
    _id: string;
    name: string;
  };
  createdAt: string;
  reactions?: {
    user: {
      _id: string;
      name: string;
    };
    date: string;
    emoji: string;
  }[];
  replies: {
    _id?: any;
    text: string;
    deleted: boolean;
    createdBy?: any;
    createdByUser: {
      _id: string;
      name: string;
    };
    createdAt: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  }[];
}[];
export type PostProjectByProjectIdProjectdashboardNewsSearchApiArg = {
  projectId: string;
  body: {
    dashboardId: string;
    query: string;
    users: string[];
  };
};
export type PostNotificationsIssueStatusesApiResponse = /** status 200 Successful response */ {
  issueId: string;
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
}[];
export type PostNotificationsIssueStatusesApiArg = {
  body: {
    issueIds: string[];
  };
};
export type PostAppadminIssueFormulaCounterMaterializationMaterializeApiResponse =
  /** status 200 Successful response */ {
    issueBoardId: string;
    formulaAttributeKey: string;
    dryRun: boolean;
    groupAttributeKeys: string[];
    totalIssues: number;
    totalGroups: number;
    issuesWithExistingCounter: number;
    issuesToSet: number;
    matchedCount: number;
    modifiedCount: number;
    preview: {
      issueObjectId: string;
      issueId: number;
      groupKey: string;
      groupValues: {
        [key: string]: any;
      };
      automaticCounterValue: number;
      newManualCounterValue: number;
      existingCounterValue: number | null;
    }[];
  };
export type PostAppadminIssueFormulaCounterMaterializationMaterializeApiArg = {
  body: {
    issueBoardId: string;
    formulaAttributeKey: string;
    dryRun?: boolean;
  };
};
export type GetAppadminCompanyLogoApiResponse =
  | /** status 200 Successful response */ {
      blobName?: string;
      fileName: string;
      uploadedAt: string;
      uploadedBy: string;
      description?: string;
      size?: number;
    }
  | null;
export type GetAppadminCompanyLogoApiArg = void;
export type PostAppadminCompanyLogoApiResponse =
  | /** status 200 Successful response */ {
      blobName?: string;
      fileName: string;
      uploadedAt: string;
      uploadedBy: string;
      description?: string;
      size?: number;
    }
  | null;
export type PostAppadminCompanyLogoApiArg = {
  body: {
    file: {
      filename: string;
      contentType: string;
      base64: string;
    };
  };
};
export type DeleteAppadminCompanyLogoApiResponse =
  | /** status 200 Successful response */ {
      blobName?: string;
      fileName: string;
      uploadedAt: string;
      uploadedBy: string;
      description?: string;
      size?: number;
    }
  | null;
export type DeleteAppadminCompanyLogoApiArg = void;
export type GetAppadminKafkaEmployeeProjectsApiResponse = /** status 200 Successful response */ {
  initials: string;
  employees: {
    employeeNumber: string;
    initials: string;
    name: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    email?: string;
    mobilePhone?: string;
    postalDistrict?: string;
    dateEmployed?: string | null;
    dateEndEmployment?: string | null;
    changedDate?: string | null;
    transactionTimestamp?: string;
  }[];
  projects: {
    projectNo: number;
    employeeNumber: string;
    transactionTimestamp?: string;
    project: {
      projectNo: number;
      jobNumber: string;
      name: string;
      description1?: string;
      description2?: string;
      description3?: string;
      status?: number | null;
      closed?: number | null;
      jobState?: number | null;
      changedDate?: string | null;
      transactionTimestamp?: string;
    } | null;
  }[];
};
export type GetAppadminKafkaEmployeeProjectsApiArg = {
  initials: string;
};
export type GetAppadminKafkaProjectAccessApiResponse = /** status 200 Successful response */ {
  project: {
    projectNo: number;
    jobNumber: string;
    name: string;
    description1?: string;
    description2?: string;
    description3?: string;
    status?: number | null;
    closed?: number | null;
    jobState?: number | null;
    changedDate?: string | null;
    transactionTimestamp?: string;
  };
  access: {
    projectNo: number;
    employeeNumber: string;
    transactionTimestamp?: string;
    employee: {
      employeeNumber: string;
      initials: string;
      name: string;
      firstName?: string;
      middleName?: string;
      lastName?: string;
      email?: string;
      mobilePhone?: string;
      postalDistrict?: string;
      dateEmployed?: string | null;
      dateEndEmployment?: string | null;
      changedDate?: string | null;
      transactionTimestamp?: string;
    } | null;
  }[];
};
export type GetAppadminKafkaProjectAccessApiArg = {
  projectNo: number;
};
export type GetAppadminGraphProfilePhotoApiResponse = /** status 200 Successful response */ {
  found: boolean;
  userIdOrPrincipalName: string;
  contentType: string | null;
  base64: string | null;
  dataUrl: string | null;
  errorCode: string | null;
  errorMessage: string | null;
};
export type GetAppadminGraphProfilePhotoApiArg = {
  userIdOrPrincipalName: string;
};
export type GetAppadminMcappsInitialsAccessApiResponse = /** status 200 Successful response */ {
  initials: string;
  users: {
    _id: string;
    name: string;
    phoneNumber: string;
    location: string;
    maconomyStatus: "APPROVED" | "TERMINATED";
    email?: string | null;
    fullEmail?: string | null;
    initials?: string;
    employeeNumber?: string | null;
  }[];
  projects: {
    memberId: string;
    group?: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT" | null) | null;
    disciplin?: string | null;
    isPassive: boolean;
    project: {
      _id: string;
      maconomy: {
        projectNo: number;
        name: string;
        coordinates?: {
          UTMN: number;
          GNR: number;
          BNR: number;
          UTME: number;
          UTMZ: number;
        };
        useDashboardAsDefaultStartPage?: boolean;
      };
      domainOwner?: string | null;
    };
  }[];
};
export type GetAppadminMcappsInitialsAccessApiArg = {
  initials: string;
};
export type GetAppadminMcappsProjectAccessApiResponse = /** status 200 Successful response */ {
  project: {
    _id: string;
    maconomy: {
      projectNo: number;
      name: string;
      coordinates?: {
        UTMN: number;
        GNR: number;
        BNR: number;
        UTME: number;
        UTMZ: number;
      };
      useDashboardAsDefaultStartPage?: boolean;
    };
    domainOwner?: string | null;
  };
  access: {
    memberId: string;
    group?: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT" | null) | null;
    disciplin?: string | null;
    isPassive: boolean;
    user: {
      _id: string;
      name: string;
      phoneNumber: string;
      location: string;
      maconomyStatus: "APPROVED" | "TERMINATED";
      email?: string | null;
      fullEmail?: string | null;
      initials?: string;
      employeeNumber?: string | null;
    } | null;
  }[];
};
export type GetAppadminMcappsProjectAccessApiArg = {
  projectNo: number;
};
export type GetAppadminExternalIssueBannersActiveApiResponse = /** status 200 Successful response */ {
  _id: string;
  source: string;
  message: string;
  severity: "info" | "warning" | "error";
  isActive: boolean;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt?: string;
  updatedAt?: string;
}[];
export type GetAppadminExternalIssueBannersActiveApiArg = void;
export type GetAppadminExternalIssueBannersApiResponse = /** status 200 Successful response */ {
  _id: string;
  source: string;
  message: string;
  severity: "info" | "warning" | "error";
  isActive: boolean;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt?: string;
  updatedAt?: string;
}[];
export type GetAppadminExternalIssueBannersApiArg = void;
export type PostAppadminExternalIssueBannersApiResponse = /** status 200 Successful response */ {
  _id: string;
  source: string;
  message: string;
  severity: "info" | "warning" | "error";
  isActive: boolean;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt?: string;
  updatedAt?: string;
};
export type PostAppadminExternalIssueBannersApiArg = {
  body: {
    source: string;
    message: string;
    severity?: "info" | "warning" | "error";
    isActive?: boolean;
  };
};
export type PutAppadminExternalIssueBannersApiResponse = /** status 200 Successful response */ {
  _id: string;
  source: string;
  message: string;
  severity: "info" | "warning" | "error";
  isActive: boolean;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt?: string;
  updatedAt?: string;
};
export type PutAppadminExternalIssueBannersApiArg = {
  body: {
    bannerId: string;
    patch: {
      source?: string;
      message?: string;
      severity?: "info" | "warning" | "error";
      isActive?: boolean;
    };
  };
};
export type PostAppadminExternalIssueBannersDeleteApiResponse = /** status 200 Successful response */ {
  deleted: boolean;
};
export type PostAppadminExternalIssueBannersDeleteApiArg = {
  body: {
    bannerId: string;
  };
};
export type GetAppadminMigrationsApiResponse = /** status 200 Successful response */ {
  name: string;
  title: string;
  description: string;
  latestRun: {
    id: string;
    name: string;
    status: "running" | "success" | "failed";
    startedAt: string;
    finishedAt?: string;
    startedBy: string;
    startedByName?: string;
    logs: string[];
    error?: string;
  } | null;
}[];
export type GetAppadminMigrationsApiArg = void;
export type PostAppadminMigrationsRunApiResponse = /** status 200 Successful response */ {
  id: string;
  name: string;
  status: "running" | "success" | "failed";
  startedAt: string;
  finishedAt?: string;
  startedBy: string;
  startedByName?: string;
  logs: string[];
  error?: string;
};
export type PostAppadminMigrationsRunApiArg = {
  body: {
    name: string;
    allowRerun?: boolean;
    limit?: number;
  };
};
export type PostAppadminMaconomyUsersSyncApiResponse = /** status 200 Successful response */ {
  dryRun: boolean;
  scannedEmployees: number;
  matchedUsers: number;
  updatedUsers: number;
  unchangedUsers: number;
  employeeNumbersWithMultipleRows: string[];
  updated: {
    employeeNumber: string;
    employeeName?: string | null;
    dateEndEmployment?: string | null;
    changes: {
      field: string;
      from?: string | null;
      to?: string | null;
    }[];
  }[];
  unchanged: {
    employeeNumber: string;
    employeeName?: string | null;
    dateEndEmployment?: string | null;
    changes: {
      field: string;
      from?: string | null;
      to?: string | null;
    }[];
  }[];
};
export type PostAppadminMaconomyUsersSyncApiArg = {
  body: {
    dryRun?: boolean;
    includeUnchanged?: boolean;
  };
};
export type AuthorizationNotProvidedError401 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type InsufficientAccessError403 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type InternalServerErrorError500 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type InvalidInputDataError400 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type NotFoundError404 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export const {
  usePingQuery,
  usePutProjectsAutodeskConnectMutation,
  useDeleteProjectsAutodeskConnectionMutation,
  useGetProjectsAutodeskConnectionQuery,
  useGetProjectsAutodeskAvailableProjectsQuery,
  usePostProjectsAutodeskLoginStartMutation,
  usePostProjectsAutodeskVerifyServiceAccountAccessMutation,
  useGetProjectMembersQuery,
  usePutProjectMemberMutation,
  useGetProjectMemberQuery,
  usePutProjectMemberOtherAttributesMutation,
  useGetProjectIssueboardsQuery,
  useGetProjectPnsQuery,
  useGetProjectProjectIdQuery,
  useGetProjectsMcappsQuery,
  useGetProjectsMaconomyQuery,
  usePostProjectMaconomyMembersSyncMutation,
  usePostProjectByProjectIdReportboardsMutation,
  usePutUserProfileMutation,
  useGetWhoamiQuery,
  usePostUsersProfilePictureSasMutation,
  usePostUserApikeyMutation,
  useGetUserApikeyQuery,
  useDeleteUserApikeyMutation,
  useGetProjectByProjectIdChecklistTemplatesQuery,
  usePostProjectByProjectIdChecklistAllMutation,
  useGetProjectByProjectIdChecklistInstanceAndChecklistIdQuery,
  useGetProjectByProjectIdChecklistCreatedByUserQuery,
  usePostProjectByProjectIdChecklistUpdateRowPositionMutation,
  useGetProjectByProjectIdChecklistAndChecklistIdPartsQuery,
  useGetProjectByProjectIdChecklistAndChecklistIdLogsRowIdQuery,
  usePostProjectByProjectIdChecklistAddMutation,
  usePostProjectByProjectIdChecklistImportExcelMutation,
  usePostProjectByProjectIdChecklistAndChecklistIdCategoryMutation,
  usePostProjectByProjectIdChecklistAndChecklistIdItemMutation,
  usePutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdInactiveMutation,
  useDeleteProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdMutation,
  usePutProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdMutation,
  useDeleteProjectByProjectIdChecklistAndChecklistIdItemItemIdMutation,
  usePutProjectByProjectIdChecklistAndChecklistIdItemItemIdMutation,
  usePutProjectByProjectIdChecklistAndChecklistIdMutation,
  useGetProjectByProjectIdChecklistChecklistitemAndChecklistitemidQuery,
  useGetProjectByProjectIdChecklistTagsQuery,
  usePutProjectByProjectIdChecklistIssueConnectDisconnectIssueMutation,
  usePutProjectByProjectIdChecklistAndChecklistIdUpdateChecklistIdsMutation,
  usePostProjectByProjectIdChecklistTemplatesChecklistsFromTemplateGetMutation,
  useGetChecklistMcTemplatesQuery,
  usePostChecklistMcTemplatesMutation,
  useGetChecklistByChecklistIdExportQuery,
  usePostChecklistValidateExcelMutation,
  usePostChecklistMcTemplatesPublishMutation,
  useGetChecklistLogsQuery,
  useGetChecklistProjectTemplatesQuery,
  usePostChecklistMcTemplatesUploadDocxMutation,
  useGetChecklistMcTemplatesDocxDownloadQuery,
  useGetChecklistMcTemplatesDocxQuery,
  usePostChecklistIntegrationGenerateMutation,
  useGetChecklistsByReviewByReviewIdQuery,
  usePutProjectByProjectIdChecklistItemAndChecklistItemIdCommentCommentIdReactionMutation,
  usePutChecklistsByChecklistIdDkApprovalToggleMutation,
  usePostProjectByProjectIdIssuesCreateMutation,
  useGetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesQuery,
  usePutProjectByProjectIdIssuesUpdateGantActivityMutation,
  usePutIssueConnectMutation,
  useGetIssueByUserQuery,
  usePutProjectByProjectIdIssuesKanbanreorderMutation,
  useGetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsQuery,
  usePostProjectByProjectIdIssuesCopyMutation,
  useGetProjectByProjectIdIssuesGetSingleQuery,
  useGetProjectByProjectIdIssuesExternalQuery,
  useGetProjectByProjectIdIssuesOnBoardQuery,
  useGetProjectByProjectIdIssuesOnBoardOldCompletedQuery,
  useGetProjectByProjectIdIssuesOnBoardOldCompletedCountQuery,
  usePostProjectByProjectIdIssuesOnBoardsMutation,
  useGetProjectByProjectIdIssuesFilesOnBoardQuery,
  usePutProjectByProjectIdIssueUpdateDatesMutation,
  useGetProjectByProjectIdIssueFormulaGroupIssuesQuery,
  usePutProjectByProjectIdIssueUpdateFormulaCounterMutation,
  usePostProjectByProjectIdIssuesFileDescriptionMutation,
  usePutProjectByProjectIdIssueConnectedBimSpacesMutation,
  useGetProjectByProjectIdConnectedTasksQuery,
  usePostProjectByProjectIdIssueTodosAddMutation,
  usePutProjectByProjectIdIssueTodosUpdateMutation,
  usePutProjectByProjectIdIssueTodosToggleMutation,
  usePutProjectByProjectIdIssueTodosReorderMutation,
  useDeleteProjectByProjectIdIssueTodosDeleteMutation,
  usePostProjectByProjectIdIssuesGenerateDocxMutation,
  usePutProjectByProjectIdIssueUpdateSimpleMutation,
  usePutProjectByProjectIdIssueUpdateDescriptionMutation,
  usePutProjectByProjectIdIssueUpdateUserMutation,
  usePutProjectByProjectIdIssueConnectedTasksUpdateOrderMutation,
  usePutProjectByProjectIdIssueSubscribeMutation,
  usePutProjectByProjectIdIssueArchiveMutation,
  usePutProjectByProjectIdIssueItemAndIssueIdCommentCommentIdReactionMutation,
  usePutProjectByProjectIdIssueConvertTypeMutation,
  useGetProjectByProjectIdIssueAndIssueIdLogsQuery,
  useGetProjectByProjectIdIssuesValidateOtherAttributesByBoardQuery,
  usePostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckMutation,
  useGetUsageAggregateProjectStartsQuery,
  useGetUsageAggregateProjectQuery,
  useGetProjectByProjectIdTableTemplatesQuery,
  usePatchProjectByProjectIdTableTemplateMutation,
  usePostProjectByProjectIdTableTemplateMutation,
  usePostProjectByProjectIdMeetingMutation,
  useGetProjectByProjectIdMeetingAndMeetingIdQuery,
  usePutProjectByProjectIdMeetingAndMeetingIdMutation,
  useGetMeetingParticipantByUserIdQuery,
  usePostProjectByProjectIdMeetingNewSingleMeetingMutation,
  usePutProjectByProjectIdMeetingNewMeetingInSeriesMutation,
  usePutProjectByProjectIdMeetingAndMeetingIdAttributeMutation,
  usePutProjectByProjectIdMeetingAndMeetingIdSendagendaMutation,
  usePostProjectByProjectIdMeetingAndMeetingIdParticipantUserIdMutation,
  usePutProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdMutation,
  useDeleteProjectByProjectIdMeetingAndMeetingIdParticipantParticipantIdMutation,
  usePostProjectByProjectIdMeetingAndMeetingIdExternalParticipantsMutation,
  usePutProjectByProjectIdMeetingAndMeetingIdUpdateAgendaIdsMutation,
  useGetProjectByProjectIdMeetingserieQuery,
  usePostProjectByProjectIdMeetingserieMutation,
  useGetProjectByProjectIdMeetingserieAndMeetingSerieIdQuery,
  usePutProjectByProjectIdMeetingserieAndMeetingSerieIdMutation,
  usePostProjectByProjectIdMeetingserieAllFieldsMutation,
  usePutProjectByProjectIdMeetingserieAndMeetingSerieIdAttributeMutation,
  usePostProjectByProjectIdMeetingagendaMeetingAndMeetingIdMutation,
  useGetProjectByProjectIdMeetingagendaAndAgendaIdQuery,
  usePutProjectByProjectIdMeetingagendaAndAgendaIdAttributeMutation,
  usePutProjectByProjectIdMeetingagendaAndAgendaIdOrderMutation,
  usePutProjectByProjectIdMeetingagendaAndAgendaIdConnectDisconnectIssueIssueIdMutation,
  usePutProjectByProjectIdMeetingagendaTodoAndAgendaIdToggleMutation,
  usePostProjectByProjectIdMeetingagendaTodoAndAgendaIdAddMutation,
  usePutProjectByProjectIdMeetingagendaTodoAndAgendaIdUpdateMutation,
  useDeleteProjectByProjectIdMeetingagendaTodoAndAgendaIdDeleteTodoIdMutation,
  usePostProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdMutation,
  useDeleteProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdMutation,
  usePutProjectByProjectIdMeetingagendaCommentAndCommentIdMutation,
  usePutProjectByProjectIdMeetingagendaAndAgendaIdCommentCommentIdReactionMutation,
  usePutProjectByProjectIdAgendaItemReorderConnectedIssuesMutation,
  usePostIssueboardFavoriteToggleMutation,
  useGetIssueboardFavoritesQuery,
  usePostProjectByProjectIdIssueboardMutation,
  useGetProjectByProjectIdIssueboardQuery,
  useGetProjectByProjectIdIssueboardAndIssueBoardIdQuery,
  usePostProjectByProjectIdIssueboardAndBoardIdTableTemplateMutation,
  useDeleteProjectByProjectIdIssueboardAndBoardIdTableTemplateTemplateIdMutation,
  usePutProjectByProjectIdIssueboardAndBoardIdMutation,
  usePutProjectByProjectIdIssueboardAndBoardIdBucketsMutation,
  usePutProjectByProjectIdIssueboardAndBoardIdUsebucketsasworkflowMutation,
  usePutProjectByProjectIdIssueboardAndBoardIdTypesMutation,
  usePutProjectByProjectIdIssueboardAndBoardIdAttributeMutation,
  useGetProjectByProjectIdIssueboardTemplateAllQuery,
  usePostProjectByProjectIdIssueboardImportExcelMutation,
  usePutProjectByProjectIdIssueboardAndBoardIdAccessMutation,
  usePutProjectByProjectIdIssueboardAndBoardIdDisabledColumnsMutation,
  usePostProjectByProjectIdIssueboardOtherAttributesConfigAddMutation,
  usePostProjectByProjectIdIssueboardOtherAttributesConfigUpdateorderMutation,
  usePostProjectByProjectIdIssueboardUseonlypredefinedtagsUpdateMutation,
  usePostProjectByProjectIdIssueboardRisikoIsactiveMutation,
  usePostProjectByProjectIdIssueboardRisikoProbabilityIsactiveaftertiltakMutation,
  usePostProjectByProjectIdIssueboardRisikoProbabilityUpdateMutation,
  usePostProjectByProjectIdIssueboardRisikoEvaluationcategoryAddMutation,
  usePostProjectByProjectIdIssueboardRisikoEvaluationcategoryUpdateMutation,
  usePostProjectByProjectIdIssueboardMoveIssueboardToProjectMutation,
  usePostProjectByProjectIdIssueboardOtherAttributesConfigGetSumsByFormulaMutation,
  usePostProjectByProjectIdIssueboardNoteboardImageNodeAddMutation,
  usePostProjectByProjectIdIssueboardNoteboardImageNodeUpdateMutation,
  usePostProjectByProjectIdIssueboardNoteboardImageNodeDeleteMutation,
  usePutProjectByProjectIdGanttVacationsMutation,
  usePostProjectByProjectIdIssueboardOtherAttributesConfigUpdateMutation,
  usePatchBoardsTemplateActionMutation,
  usePostProjectByProjectIdIssueboardPredefinedtagsUpdateMutation,
  usePostProjectByProjectIdIssueboardUsepredefinedtagsUpdateMutation,
  useGetProjectByProjectIdIssueLogsQuery,
  useGetMcbimCeilingsOnFloorQuery,
  useGetMcbimFragsQuery,
  useGetMcbimFloorsQuery,
  useGetMcbimFurnitureAndWallsOnFloorQuery,
  useGetMcbimItemsInSpaceQuery,
  useGetMcbimSpaceQuery,
  useGetMcbimSpacesQuery,
  useGetMcbimSpacesOnFloorQuery,
  useGetEmailsTemplatesQuery,
  useGetEmailsTemplatesDownloadQuery,
  usePostEmailsTemplatesUploadZipMutation,
  useGetProjectByProjectIdProjectdashboardAndDashboardIdNewsQuery,
  usePostProjectByProjectIdProjectdashboardNewsMutation,
  usePutProjectByProjectIdProjectdashboardNewsAndNewsItemIdMutation,
  usePostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionMutation,
  usePostProjectByProjectIdProjectdashboardNewsSearchMutation,
  usePostNotificationsIssueStatusesMutation,
  usePostAppadminIssueFormulaCounterMaterializationMaterializeMutation,
  useGetAppadminCompanyLogoQuery,
  usePostAppadminCompanyLogoMutation,
  useDeleteAppadminCompanyLogoMutation,
  useGetAppadminKafkaEmployeeProjectsQuery,
  useGetAppadminKafkaProjectAccessQuery,
  useGetAppadminGraphProfilePhotoQuery,
  useGetAppadminMcappsInitialsAccessQuery,
  useGetAppadminMcappsProjectAccessQuery,
  useGetAppadminExternalIssueBannersActiveQuery,
  useGetAppadminExternalIssueBannersQuery,
  usePostAppadminExternalIssueBannersMutation,
  usePutAppadminExternalIssueBannersMutation,
  usePostAppadminExternalIssueBannersDeleteMutation,
  useGetAppadminMigrationsQuery,
  usePostAppadminMigrationsRunMutation,
  usePostAppadminMaconomyUsersSyncMutation,
} = injectedRtkApi;
